webpackJsonp([0],{

/***/ "+0zs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BEGIN_AJAX_CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AJAX_CALL_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AJAX_CALL_SUCCESS; });
// mutations
var BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
var AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';
var AJAX_CALL_SUCCESS = 'AJAX_CALL_SUCCESS';

/***/ }),

/***/ "+ANa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.symbol))]),_c('span',[_vm._v(_vm._s(_vm.price))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+QWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundScreen_vue__ = __webpack_require__("Z3Ux");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4e9045_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundScreen_vue__ = __webpack_require__("QN4d");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4e9045_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+SIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{staticClass:"u-bg-primary",attrs:{"wrapper-class":"u-bg-primary","white":true}}),_c('div',{staticClass:"u-pt5 u-bg-landscape"},[_vm._m(0),_c('section',{staticClass:" o-wrapper u-mb5"},[_c('label',{staticClass:"u-fw-bold u-color-primary u-block u-mb3 u-fz-h4"},[_vm._v("Selecciona una opción:")]),_c('div',{staticClass:"u-flex u-flex-wrap"},[_c('div',{staticClass:"c-input c-input--secondary u-flex u-items-center u-px3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.claimOptionId),expression:"form.claimOptionId"}],staticClass:"u-mr2",attrs:{"id":"claim1","type":"radio","name":"claimOptionId"},domProps:{"value":1,"checked":_vm._q(_vm.form.claimOptionId,1)},on:{"change":function($event){_vm.$set(_vm.form, "claimOptionId", 1)}}}),_c('label',{staticClass:"c-input__label",attrs:{"for":"claim1"}},[_vm._v("Reclamo")])]),_c('div',{staticClass:"c-input c-input--secondary u-flex u-items-center u-px3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.claimOptionId),expression:"form.claimOptionId"}],staticClass:"u-mr2",attrs:{"id":"claim2","type":"radio","name":"claimOptionId"},domProps:{"value":2,"checked":_vm._q(_vm.form.claimOptionId,2)},on:{"change":function($event){_vm.$set(_vm.form, "claimOptionId", 2)}}}),_c('label',{staticClass:"c-input__label",attrs:{"for":"claim2"}},[_vm._v("Queja")])]),_c('div',{staticClass:"c-input c-input--secondary u-flex u-items-center u-px3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.claimOptionId),expression:"form.claimOptionId"}],staticClass:"u-mr2",attrs:{"id":"claim3","type":"radio","name":"claimOptionId"},domProps:{"value":3,"checked":_vm._q(_vm.form.claimOptionId,3)},on:{"change":function($event){_vm.$set(_vm.form, "claimOptionId", 3)}}}),_c('label',{staticClass:"c-input__label",attrs:{"for":"claim3"}},[_vm._v("Consulta")])])])]),_c('section',{staticClass:" o-wrapper u-mb5"},[_c('label',{staticClass:"u-fw-bold u-color-primary u-block u-mb3 u-fz-h4"},[_vm._v("1. Datos personales")]),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-8/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.person.fullname,"placeholder":"Nombres y apellidos","validation":_vm.toggleValidate,"error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.person.fullname),callback:function ($$v) {_vm.$set(_vm.form.person, "fullname", $$v)},expression:"form.person.fullname"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-8/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.person.legalName,"placeholder":"Razón Social","validation":_vm.toggleValidate,"error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.person.legalName),callback:function ($$v) {_vm.$set(_vm.form.person, "legalName", $$v)},expression:"form.person.legalName"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-8/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.person.address,"placeholder":"Dirección","validation":_vm.toggleValidate,"error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.person.address),callback:function ($$v) {_vm.$set(_vm.form.person, "address", $$v)},expression:"form.person.address"}}),_c('div',{staticClass:" u-flex-wrap u-flex"},[_c('input-validate',{staticClass:"u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.person.district,"placeholder":"Distrito","validation":_vm.toggleValidate,"error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.person.district),callback:function ($$v) {_vm.$set(_vm.form.person, "district", $$v)},expression:"form.person.district"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.person.province,"placeholder":"Provincia","validation":_vm.toggleValidate,"error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.person.province),callback:function ($$v) {_vm.$set(_vm.form.person, "province", $$v)},expression:"form.person.province"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.person.region,"placeholder":"Departamento","validation":_vm.toggleValidate,"error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.person.region),callback:function ($$v) {_vm.$set(_vm.form.person, "region", $$v)},expression:"form.person.region"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.person.identityDocument,"placeholder":"Documento de identidad","validation":_vm.toggleValidate,"error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.person.identityDocument),callback:function ($$v) {_vm.$set(_vm.form.person, "identityDocument", $$v)},expression:"form.person.identityDocument"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.person.phone,"placeholder":"Teléfono fijo","validation":_vm.toggleValidate,"type":"tel","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.person.phone),callback:function ($$v) {_vm.$set(_vm.form.person, "phone", $$v)},expression:"form.person.phone"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.person.cellphone,"placeholder":"Telefonía móvil","validation":_vm.toggleValidate,"type":"tel","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.person.cellphone),callback:function ($$v) {_vm.$set(_vm.form.person, "cellphone", $$v)},expression:"form.person.cellphone"}})],1),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-8/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.person.email,"placeholder":"Correo electrónico","validation":_vm.toggleValidate,"type":"email","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.person.email),callback:function ($$v) {_vm.$set(_vm.form.person, "email", $$v)},expression:"form.person.email"}}),_c('div',{staticClass:" u-flex-wrap u-flex"},[_c('input-validate',{staticClass:"u-12/12 u-8/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.person.parentsName,"placeholder":"Nombre del padre  y de la madre","validation":_vm.toggleValidate,"type":"email","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.person.parentsName),callback:function ($$v) {_vm.$set(_vm.form.person, "parentsName", $$v)},expression:"form.person.parentsName"}}),_c('p',{staticClass:"u-italic u-color-text u-show@tablet"},[_vm._v("( En caso sea menor de edad )")])],1)],1),_c('section',{staticClass:" o-wrapper u-mb5"},[_c('label',{staticClass:"u-fw-bold u-color-primary u-block u-mb3 u-fz-h4"},[_vm._v("2. Identificación del bien contratado")]),_c('div',{staticClass:"u-flex u-mb3"},[_c('div',{staticClass:"c-input c-input--secondary u-flex u-items-center u-px3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.itemOptionId),expression:"form.itemOptionId"}],staticClass:"u-mr2",attrs:{"id":"contract1","type":"radio","name":"contract"},domProps:{"value":1,"checked":_vm._q(_vm.form.itemOptionId,1)},on:{"change":function($event){_vm.$set(_vm.form, "itemOptionId", 1)}}}),_c('label',{staticClass:"c-input__label",attrs:{"for":"contract1"}},[_vm._v("Producto")])]),_c('div',{staticClass:"c-input c-input--secondary u-flex u-items-center u-px3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.itemOptionId),expression:"form.itemOptionId"}],staticClass:"u-mr2",attrs:{"id":"contract2","type":"radio","name":"contract"},domProps:{"value":2,"checked":_vm._q(_vm.form.itemOptionId,2)},on:{"change":function($event){_vm.$set(_vm.form, "itemOptionId", 2)}}}),_c('label',{staticClass:"c-input__label",attrs:{"for":"contract2"}},[_vm._v("Servicio")])])]),_c('input-validate',{staticClass:"u-mb3 u-12/12  u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.descriptionItem,"placeholder":"Descripción","validation":_vm.toggleValidate,"type":"textarea","rows":"5","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.descriptionItem),callback:function ($$v) {_vm.$set(_vm.form, "descriptionItem", $$v)},expression:"form.descriptionItem"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-4/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.amount,"placeholder":"Monto reclamado","validation":_vm.toggleValidate,"type":"text","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.amount),callback:function ($$v) {_vm.$set(_vm.form, "amount", $$v)},expression:"form.amount"}})],1),_c('section',{staticClass:" o-wrapper u-mb5"},[_c('label',{staticClass:"u-fw-bold u-color-primary u-block u-mb3 u-fz-h4"},[_vm._v("3. Detalles de la queja y/o reclamo, y pedido del consumidor:")]),_c('div',{staticClass:"u-flex u-mb3 u-flex-wrap"},[_c('input-validate',{staticClass:"u-mb3 u-12/12 u-6/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.details,"placeholder":"Detalles","validation":_vm.toggleValidate,"type":"textarea","rows":"6","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.details),callback:function ($$v) {_vm.$set(_vm.form, "details", $$v)},expression:"form.details"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-6/12@tablet u-px3 c-input c-input--secondary",attrs:{"rule":_vm.rules.order,"placeholder":"Pedido","validation":_vm.toggleValidate,"type":"textarea","rows":"6","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.order),callback:function ($$v) {_vm.$set(_vm.form, "order", $$v)},expression:"form.order"}})],1),_c('file-validate',{staticClass:"u-px3 u-6/12@tablet u-12/12",attrs:{"clear":_vm.clearForm,"label-class":"u-italic u-fw-light u-mb2","validation":_vm.toggleValidate,"label":"Documentos que sustenten la reclamación:","placeholder":"Adjuntar archivo","wrapper-class":"c-input c-input--secondary","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},on:{"update":_vm.updateFile}})],1),_c('section',{staticClass:" o-wrapper u-pb5"},[_c('label',{staticClass:"u-fw-bold u-color-primary u-block u-mb3 u-fz-h4"},[_vm._v("4. Canal de respuesta")]),_c('div',{staticClass:"u-flex u-flex-wrap u-mb3"},[_c('div',{staticClass:"c-input c-input--secondary u-flex u-items-center u-px3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.responseChanelId),expression:"form.responseChanelId"}],staticClass:"u-mr2",attrs:{"id":"channel1","type":"radio","name":"channel"},domProps:{"value":1,"checked":_vm._q(_vm.form.responseChanelId,1)},on:{"change":function($event){_vm.$set(_vm.form, "responseChanelId", 1)}}}),_c('label',{staticClass:"c-input__label",attrs:{"for":"channel1"}},[_vm._v("Personal")])]),_c('div',{staticClass:"c-input c-input--secondary u-flex u-items-center u-px3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.responseChanelId),expression:"form.responseChanelId"}],staticClass:"u-mr2",attrs:{"id":"channel2","type":"radio","name":"channel"},domProps:{"value":2,"checked":_vm._q(_vm.form.responseChanelId,2)},on:{"change":function($event){_vm.$set(_vm.form, "responseChanelId", 2)}}}),_c('label',{staticClass:"c-input__label",attrs:{"for":"channel2"}},[_vm._v("Correo Electrónico")])]),_c('div',{staticClass:"c-input c-input--secondary u-flex u-items-center u-px3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.responseChanelId),expression:"form.responseChanelId"}],staticClass:"u-mr2",attrs:{"id":"channel3","type":"radio","name":"channel"},domProps:{"value":3,"checked":_vm._q(_vm.form.responseChanelId,3)},on:{"change":function($event){_vm.$set(_vm.form, "responseChanelId", 3)}}}),_c('label',{staticClass:"c-input__label",attrs:{"for":"channel3"}},[_vm._v("Carta")])]),_c('div',{staticClass:"c-input c-input--secondary u-flex u-items-center u-px3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.responseChanelId),expression:"form.responseChanelId"}],staticClass:"u-mr2",attrs:{"id":"channel4","type":"radio","name":"channel"},domProps:{"value":4,"checked":_vm._q(_vm.form.responseChanelId,4)},on:{"change":function($event){_vm.$set(_vm.form, "responseChanelId", 4)}}}),_c('label',{staticClass:"c-input__label",attrs:{"for":"channel4"}},[_vm._v("Teléfono")])])]),_c('div',{staticClass:"u-center"},[_c('button',{staticClass:"u-fw-s-bold c-btn--primary u-px5",on:{"click":_vm.postForm}},[_vm._v("Enviar Formulario")])])])]),_c('app-footer'),(_vm.isLoading)?_c('loading',{attrs:{"message":"Enviando"}}):_vm._e(),(_vm.isShowModalConfirm)?_c('modal-confirm',{on:{"hide":function($event){_vm.isShowModalConfirm = false}}}):_vm._e(),(_vm.isShowModalError)?_c('modal-error',{on:{"hide":function($event){_vm.isShowModalError = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"u-center u-mt0 u-fz-h1 u-line-1  o-wrapper"},[_c('span',{staticClass:"u-fw-light"},[_vm._v("Libro de ")]),_c('strong',{staticClass:"u-color-secondary"},[_vm._v("Reclamaciones")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+U0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PostsScreen',
  data: function data() {
    return {
      posts: [],
      isLoading: false,
      currentPage: 1,
      totalPages: 1,
      lastPage: 1
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  }), {
    faceWeb: function faceWeb() {
      return 'https://www.facebook.com/plugins/page.php?href=' + encodeURIComponent(this.company.facebookPage) + '&tabs=timeline&width=320&height=400&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId';
      // return `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent('https://www.facebook.com/NoveltiePeru/')}&tabs=timeline&width=320&height=400&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`
    }
  }),

  methods: {
    prevPosts: function prevPosts() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        this.getPosts();
      }
    },
    nextPosts: function nextPosts() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1;
        this.getPosts();
      }
    },
    changePage: function changePage(page) {
      this.currentPage = page;
      this.getPosts();
    },
    getPosts: function getPosts() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/posts?page=' + this.currentPage).then(function (_ref) {
        var data = _ref.data;

        _this.posts = data.data;
        _this.totalPages = data.last_page;
        _this.isLoading = false;
      });
    }
  },

  created: function created() {
    this.getPosts();
  }
});

/***/ }),

/***/ "+p9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ "+tAw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validatorjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      toggleValidate: false,
      formValidate: false,
      isLoading: false,
      form: {
        fullname: '',
        whatsapp: '',
        descriptionService: '',
        roundTrip: false,
        specificTime: false,
        hours: null
      },
      rules: {
        fullname: 'required|name',
        whatsapp: 'required|phone',
        hours: ''
      }
    };
  },


  methods: {
    postForm: function postForm() {
      var _this = this;

      this.validate();

      if (this.formValidate && !this.isLoading) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://radiotaxipavill.ddns.net:8015/enlacepavill/RegistrarPedidoMujerTaxi.php', this.form);
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(window.API_URL + '/womantaxi', this.form).then(function (response) {
          _this.isLoading = false;
          _this.$emit('hide');
          _this.$emit('success');
        }).catch(function (_ref) {
          var response = _ref.response;

          _this.isLoading = false;
          _this.$emit('hide');
          _this.$emit('error');
        });
      }
    },
    validate: function validate() {
      var validation = new __WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a(this.form, this.rules);
      validation.passes();
      this.toggleValidate = !this.toggleValidate;
      this.formValidate = validation.passes();
    }
  },

  watch: {
    'form.specificTime': function formSpecificTime(val) {
      if (val) {
        this.rules.hours = 'required|min:1';
      } else {
        this.form.hours = null;
        this.rules.hours = '';
      }
    }
  }
});

/***/ }),

/***/ "/PsR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalTourism_vue__ = __webpack_require__("obcv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b575bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalTourism_vue__ = __webpack_require__("nbpO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalTourism_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b575bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalTourism_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/XiT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalRadioTaxi_vue__ = __webpack_require__("BGRw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d5dae90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalRadioTaxi_vue__ = __webpack_require__("rkIY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalRadioTaxi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d5dae90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalRadioTaxi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/coY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"form-operator"}},[_c('app-header'),_c('section',{staticClass:"u-bg-primary"},[_c('div',{staticClass:"u-flex o-wrapper u-py5 u-flex-wrap u-items-start"},[_vm._m(0),_c('div',{staticClass:"u-white u-5/12@laptop u-6/12@tablet u-12/12 u-flex-wrap u-flex",attrs:{"data-aos":"fade-left"}},[_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.firstname,"icon":"user","placeholder":"Nombres","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.firstname),callback:function ($$v) {_vm.$set(_vm.form, "firstname", $$v)},expression:"form.firstname"}}),_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.lastname,"placeholder":"Apellidos","validation":_vm.toggleValidate,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.lastname),callback:function ($$v) {_vm.$set(_vm.form, "lastname", $$v)},expression:"form.lastname"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-px2",attrs:{"rule":_vm.rules.dni,"icon":"message","placeholder":"DNI","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.dni),callback:function ($$v) {_vm.$set(_vm.form, "dni", $$v)},expression:"form.dni"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-px2",attrs:{"rule":_vm.rules.workExperience,"placeholder":"Cuéntanos un resumen de tu experiencia laboral","validation":_vm.toggleValidate,"type":"textarea","rows":"4","wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.workExperience),callback:function ($$v) {_vm.$set(_vm.form, "workExperience", $$v)},expression:"form.workExperience"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-px2",attrs:{"rule":_vm.rules.whyWork,"placeholder":"¿Por qué deseas trabajar con nosotros?","validation":_vm.toggleValidate,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.whyWork),callback:function ($$v) {_vm.$set(_vm.form, "whyWork", $$v)},expression:"form.whyWork"}}),_c('label',{staticClass:"u-block u-mb2 u-px2 u-mr3 u-12/12 u-color-text u-fw-s-bold"},[_vm._v("Adjuntar los siguientes requisitos:")]),_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"icon":"application","rule":_vm.rules.curriculumvitae,"info":_vm.infos.curriculumvitae,"placeholder":"Currículum vitae","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.curriculumvitae),callback:function ($$v) {_vm.$set(_vm.form, "curriculumvitae", $$v)},expression:"form.curriculumvitae"}}),_c('file-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"type":"file","clear":_vm.clearForm,"rule":_vm.rules.photo.extension,"icon":"photo","placeholder":"Foto","validation":_vm.toggleValidate,"info":_vm.infos.photo,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},on:{"update":_vm.updateFile}}),_c('div',{staticClass:"u-px2 u-12/12"},[_c('button',{staticClass:"c-btn--primary u-12/12 u-fw-s-bold u-fz-h4 u-mt2",on:{"click":_vm.postForm}},[_vm._v("Registrarse")])])],1)])]),_c('section',{staticClass:"u-py5 o-wrapper"},[_vm._m(1),_c('p',{staticClass:"o-container o-wrapper u-center u-mb4",attrs:{"data-aos":"fade-up"}},[_vm._v("Convenios con empresas privadas y públicas con ubicaciones en paraderos estratégicos en toda la ciudad, trabajamos con la cadena de mercados del Perú Plaza Vea.")]),_c('ul',{staticClass:"u-flex u-flex-wrap u-pl0 u-list-none u-mb0 u-justify-center"},_vm._l((_vm.company.parnerts),function(parnert,index){return _c('li',{staticClass:"u-px4 u-mb3",class:{'u-12/12 u-center u-mb4' : index === 0},attrs:{"data-aos":"fade-up"}},[_c('a',{staticClass:"u-m0 u-block",staticStyle:{"height":"60px"},attrs:{"href":parnert.link,"target":"_blank"}},[_c('img',{staticStyle:{"max-height":"100%"},attrs:{"src":parnert.imageUrl,"title":parnert.title}})])])}))]),_c('section',{staticClass:"u-pb4 o-wrapper"},[_vm._m(2),_c('ul',{staticClass:"u-mt0 u-pt3 u-flex u-flex-wrap u-list-none u-mb0 u-pl0 u-justify-center"},_vm._l((_vm.whereabouts),function(whereabout){return _c('li',{staticClass:"u-px3 u-mb4 u-4/12@tablet u-12/12 u-px3",attrs:{"data-aos":"fade-up"}},[_c('figure',{staticClass:"u-mb0 u-mt0 u-mx2 u-br16 u-overflow-hidden"},[_c('img',{attrs:{"src":whereabout.imageUrl}})]),_c('p',{staticClass:"u-mb2 u-px2 u-center u-color-tertiary u-fz-h4 u-fw-light"},[_vm._v(_vm._s(whereabout.name))]),_c('p',{staticClass:"u-px2 u-mt0 u-mb3 u-center u-color-dark"},[_vm._v(_vm._s(whereabout.address))])])}))]),_c('section',{staticClass:"o-wrapper u-center u-pb5"},[_c('h3',{staticClass:"u-color-primary u-fz-h3 u-mt0 u-mb3",attrs:{"data-aos":"fade-up"}},[_vm._v("¿Te interesa?")]),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#form-operator'),expression:"'#form-operator'"}],staticClass:"c-btn--primary u-px5 u-fw-bold u-inline-flex u-items-center",attrs:{"href":"#","data-aos":"fade-up"}},[_vm._v("Empieza hoy")])]),_c('app-footer'),(_vm.isLoading)?_c('loading',{attrs:{"message":"Enviando"}}):_vm._e(),(_vm.isShowModalConfirm)?_c('modal-confirm',{attrs:{"message":"Nos pondremos en contacto con usted."},on:{"hide":function($event){_vm.isShowModalConfirm = false}}}):_vm._e(),(_vm.isShowModalError)?_c('modal-error',{on:{"hide":function($event){_vm.isShowModalError = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-white u-7/12@laptop u-6/12@tablet u-12/12",attrs:{"data-aos":"fade-right"}},[_c('div',{staticClass:"u-8/12@laptop u-10/12@tablet u-px2 u-mx-auto"},[_c('h2',{staticClass:"u-fz-h0 u-line-1 u-mb3 u-mt4 u-mt0"},[_c('span',{staticClass:"u-color-secondary u-block"},[_vm._v("Trabaja con")]),_c('span',{staticClass:"u-white u-block"},[_vm._v("nosotros")])]),_c('p',{staticClass:"u-color-text u-mb0 u-mt0 u-fz-h4 u-mb4"},[_vm._v("Horarios flexibles, un equipo jóven, un gran ambiente y muchas oportunidades")]),_c('figure',{staticClass:"u-m0 u-show@laptop "},[_c('img',{attrs:{"src":"/images/car_pavill.png"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-mt0 u-mb3 u-fz-h1 u-center u-line-1",attrs:{"data-aos":"fade-up"}},[_c('span',{staticClass:"u-color-secondary u-inline-block"},[_vm._v("Convenios ")]),_c('span',{staticClass:"u-inline-block u-fw-light"},[_vm._v("que te benefician")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-mt0 u-mb4 u-fz-h1 u-center u-line-1",attrs:{"data-aos":"fade-up"}},[_c('span',{staticClass:"u-color-secondary u-inline-block"},[_vm._v("Paraderos ")]),_c('span',{staticClass:"u-inline-block u-fw-light"},[_vm._v("estratégicos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0pDC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label)?_c('label',{staticClass:"u-mb1 u-block",class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{class:_vm.wrapperClass},[(_vm.type === 'textarea')?_c('textarea',{ref:"input",class:{inputClass: _vm.inputClass, 'u-border-warning' : _vm.message},attrs:{"placeholder":_vm.placeholder,"rows":_vm.rows},domProps:{"value":_vm.value},on:{"input":function($event){_vm.updateValue($event.target.value)}}}):_vm._e(),(_vm.type !== 'textarea' && !_vm.mask)?_c('input',{ref:"input",staticClass:"u-block",class:{inputClass: _vm.inputClass, 'u-border-warning' : _vm.message},attrs:{"type":_vm.type,"name":_vm.name,"placeholder":_vm.placeholder,"min":_vm.min},domProps:{"value":_vm.value},on:{"blur":_vm.formatValue,"input":function($event){_vm.updateValue($event.target.value)}}}):_vm._e(),(_vm.type !== 'textarea' && _vm.mask)?_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],ref:"input",staticClass:"u-block",class:{inputClass: _vm.inputClass, 'u-border-warning' : _vm.message},attrs:{"type":_vm.type,"name":_vm.name,"placeholder":_vm.placeholder,"min":_vm.min},domProps:{"value":_vm.value},on:{"blur":_vm.formatValue,"input":function($event){_vm.updateValue($event.target.value)}}}):_vm._e(),(_vm.icon)?_c('i',{staticClass:"u-icon"},[_vm._v(_vm._s(_vm.icon))]):_vm._e()]),(_vm.info)?_c('p',{staticClass:"u-color-text u-fz-h6 u-mt1 u-mb0",staticStyle:{"font-size":"12px","user-select":"none"},domProps:{"innerHTML":_vm._s(_vm.info)}}):_vm._e(),(_vm.message)?_c('span',{staticClass:"u-fz-h6 u-pt1 u-pl1 u-block",class:_vm.errorClass},[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1RGr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConstructionScreen__ = __webpack_require__("iFJD");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/demo',
  name: 'Construction',
  component: __WEBPACK_IMPORTED_MODULE_0__components_ConstructionScreen__["a" /* default */]
});

/***/ }),

/***/ "1f4k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//




// Check if request comes from browser and is not server rendered
if (typeof window !== 'undefined') {
  var slick = __webpack_require__("gqkz");
}

/* harmony default export */ __webpack_exports__["a"] = ({

  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  mounted: function mounted() {
    this.create();
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('unslick');
  },


  methods: {
    create: function create() {
      var $slick = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);

      $slick.on('afterChange', this.onAfterChange);
      $slick.on('beforeChange', this.onBeforeChange);
      $slick.on('breakpoint', this.onBreakpoint);
      $slick.on('destroy', this.onDestroy);
      $slick.on('edge', this.onEdge);
      $slick.on('init', this.onInit);
      $slick.on('reInit', this.onReInit);
      $slick.on('setPosition', this.onSetPosition);
      $slick.on('swipe', this.onSwipe);
      $slick.on('lazyLoaded', this.onLazyLoaded);
      $slick.on('lazyLoadError', this.onLazyLoadError);

      $slick.slick(this.options);
    },
    destroy: function destroy() {
      var $slick = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);

      $slick.off('afterChange', this.onAfterChange);
      $slick.off('beforeChange', this.onBeforeChange);
      $slick.off('breakpoint', this.onBreakpoint);
      $slick.off('destroy', this.onDestroy);
      $slick.off('edge', this.onEdge);
      $slick.off('init', this.onInit);
      $slick.off('reInit', this.onReInit);
      $slick.off('setPosition', this.onSetPosition);
      $slick.off('swipe', this.onSwipe);
      $slick.off('lazyLoaded', this.onLazyLoaded);
      $slick.off('lazyLoadError', this.onLazyLoadError);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('unslick');
    },
    reSlick: function reSlick() {
      this.destroy();
      this.create();
    },
    next: function next() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickNext');
    },
    prev: function prev() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPrev');
    },
    pause: function pause() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPause');
    },
    play: function play() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPlay');
    },
    goTo: function goTo(index, dontAnimate) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickGoTo', index, dontAnimate);
    },
    currentSlide: function currentSlide() {
      return __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickCurrentSlide');
    },
    add: function add(element, index, addBefore) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickAdd', element, index, addBefore);
    },
    remove: function remove(index, removeBefore) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickRemove', index, removeBefore);
    },
    filter: function filter(filterData) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickFilter', filterData);
    },
    unfilter: function unfilter() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickUnfilter');
    },
    getOption: function getOption(option) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickGetOption', option);
    },
    setOption: function setOption(option, value, refresh) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickSetOption', option, value, refresh);
    },
    setPosition: function setPosition() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('setPosition');
    },


    // Events
    onAfterChange: function onAfterChange(event, slick, currentSlide) {
      this.$emit('afterChange', event, slick, currentSlide);
    },
    onBeforeChange: function onBeforeChange(event, slick, currentSlide, nextSlide) {
      this.$emit('beforeChange', event, slick, currentSlide, nextSlide);
    },
    onBreakpoint: function onBreakpoint(event, slick, breakpoint) {
      this.$emit('breakpoint', event, slick, breakpoint);
    },
    onDestroy: function onDestroy(event, slick) {
      this.$emit('destroy', event, slick);
    },
    onEdge: function onEdge(event, slick, direction) {
      this.$emit('edge', event, slick, direction);
    },
    onInit: function onInit(event, slick) {
      this.$emit('init', event, slick);
    },
    onReInit: function onReInit(event, slick) {
      this.$emit('reInit', event, slick);
    },
    onSetPosition: function onSetPosition(event, slick) {
      this.$emit('setPosition', event, slick);
    },
    onSwipe: function onSwipe(event, slick, direction) {
      this.$emit('swipe', event, slick, direction);
    },
    onLazyLoaded: function onLazyLoaded(event, slick, image, imageSource) {
      this.$emit('lazyLoaded', event, slick, image, imageSource);
    },
    onLazyLoadError: function onLazyLoadError(event, slick, image, imageSource) {
      this.$emit('lazyLoadError', event, slick, image, imageSource);
    }
  }

});

/***/ }),

/***/ "1hP4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("onL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("JzpG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("BFy/");





var state = {
  company: false
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* RECEIVE_COMPANY */], function (state, data) {
  state.company = data;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__
});

/***/ }),

/***/ "1pPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{staticClass:"u-bg-primary",attrs:{"white":true}}),_c('div',{staticClass:"u-bg-border u-pt3"},[_c('div',{staticClass:"o-wrapper u-pt4 u-flex u-justify-between",attrs:{"id":"reports-container"}},[_c('section',{staticClass:"u-8/12@laptop u-7/12@tablet u-12/12 u-mb4"},[_vm._l((_vm.reports),function(report){return _c('article',{staticClass:"c-post u-mb4 u-11/12@tablet u-12/12",attrs:{"data-aos":"fade-up"}},[_c('progressive-background',{staticClass:"c-post__image",attrs:{"src":report.imageUrl,"placeholder":report.imageThumbUrl}}),_c('div',{staticClass:"u-p4 u-bg-white"},[_c('router-link',{staticClass:"c-post__title u-fz-h3",attrs:{"to":{ name: 'Report', params:{slug: report.slug}}}},[_vm._v(_vm._s(report.title))]),_c('div',{staticClass:"u-my3",domProps:{"innerHTML":_vm._s(report.content)}}),_c('p',[_c('router-link',{staticClass:"u-color-secondary",attrs:{"to":{ name: 'Report', params:{slug: report.slug}}}},[_vm._v("Leer más...")])],1),_c('p',{staticClass:"u-mb0 u-right-align u-capitalize u-color-dark u-fw-s-bold"},[_vm._v(_vm._s(_vm._f("date")(report.date,'short')))])],1)],1)}),(_vm.reports.length > 0 && _vm.totalPages != 1)?_c('nav',{staticClass:"u-flex u-justify-between u-items-center"},[_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#reports-container'),expression:"'#reports-container'"}],staticClass:"c-btn c-btn--tertiary u-p2 u-fz-h4",attrs:{"disabled":_vm.currentPage === 1},on:{"click":_vm.prevReports}},[_c('i',{staticClass:"u-icon"},[_vm._v("arrow_left")])]),(_vm.totalPages > 0)?_c('ul',{staticClass:"u-flex u-mt0 u-mb0 u-px2 u-flex-wrap"},_vm._l((_vm.totalPages),function(number){return _c('li',{staticClass:"u-px1"},[_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#reports-container'),expression:"'#reports-container'"}],staticClass:"u-fw-s-bold u-px1",class:{'u-color-primary' : _vm.currentPage === number},on:{"click":function($event){_vm.changePage(number)}}},[_vm._v(" "+_vm._s(number))])])})):_vm._e(),_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#reports-container'),expression:"'#reports-container'"}],staticClass:"c-btn c-btn--tertiary u-p2 u-fz-h4",attrs:{"disabled":_vm.totalPages === _vm.currentPage},on:{"click":_vm.nextReports}},[_c('i',{staticClass:"u-icon"},[_vm._v("arrow_right")])])]):_vm._e()],2),_c('aside',{staticClass:"u-4/12@laptop u-5/12@tablet u-12/12 u-mb5 u-show@tablet",staticStyle:{"padding-top":"3.85rem"}},[_c('div',{staticClass:"u-px4  u-py3 u-bg-primary u-br8 u-mb4"},[_vm._m(0),_vm._m(1),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.postForm($event)}}},[_c('input-validate',{staticClass:"u-mb3 u-12/12",attrs:{"rule":_vm.rules.dni,"icon":"card","placeholder":"DNI","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.dni),callback:function ($$v) {_vm.$set(_vm.form, "dni", $$v)},expression:"form.dni"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12",attrs:{"rule":_vm.rules.cellphone,"icon":"cellphone","placeholder":"Celular o teléfono","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.cellphone),callback:function ($$v) {_vm.$set(_vm.form, "cellphone", $$v)},expression:"form.cellphone"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12",attrs:{"rule":_vm.rules.title,"icon":"message","placeholder":"Título del reporte","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}}),_c('datepicker',{staticClass:"c-input c-input--icon u-mb3",attrs:{"calendar-button":true,"calendar-button-icon":"u-icon calendar","placeholder":"Fecha de reporte","language":"es","format":"dd MMMM yyyy"},model:{value:(_vm.currentDate),callback:function ($$v) {_vm.currentDate=$$v},expression:"currentDate"}}),_c('file-validate',{staticClass:"u-mb3",attrs:{"type":"file","clear":_vm.clearForm,"rule":_vm.rules.photo.extension,"icon":"photo","placeholder":"Foto","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},on:{"update":_vm.updateFile}}),_c('input-validate',{staticClass:"u-mb3 u-12/12",attrs:{"type":"textarea","rule":_vm.rules.detail,"placeholder":"Detalles del reporte","validation":_vm.toggleValidate,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.detail),callback:function ($$v) {_vm.$set(_vm.form, "detail", $$v)},expression:"form.detail"}}),_c('div',{staticClass:"u-mb3"},[_c('button',{staticClass:"c-btn--primary u-12/12 u-fw-s-bold u-fz-h4",attrs:{"disabled":_vm.isLoading}},[_vm._v("Enviar")])])],1)]),_c('div',{staticClass:"u-bg-white u-py3 u-px4 u-br8"},[_vm._m(2),_c('div',{staticClass:"u-mt3",domProps:{"innerHTML":_vm._s(_vm.company.pavillReport)}})])])])]),_c('button',{staticClass:"c-btn--primary u-fw-s-bold u-fz-h4 c-btn--fixed u-hide@tablet",on:{"click":function($event){_vm.isShowModalReport = true}}},[_vm._v("Reportar aquí")]),_c('app-footer',{attrs:{"show-info":false}}),(_vm.isLoading)?_c('loading',{attrs:{"message":"Enviando"}}):_vm._e(),(_vm.isShowModalReport)?_c('modal-report',{on:{"hide":function($event){_vm.isShowModalReport = false},"loading":function($event){_vm.isLoading = !_vm.isLoading},"success":function($event){_vm.isShowModalConfirm = true},"error":function($event){_vm.isShowModalError = true}}}):_vm._e(),(_vm.isShowModalConfirm)?_c('modal-confirm',{attrs:{"message":"Tu reporte ha sido registrado correctamente."},on:{"hide":function($event){_vm.isShowModalConfirm = false}}}):_vm._e(),(_vm.isShowModalError)?_c('modal-error',{on:{"hide":function($event){_vm.isShowModalError = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"u-m0 u-5/12 u-border u-border-white u-mb3 u-circle u-border-8 u-mx-auto",staticStyle:{"margin-top":"-5rem"}},[_c('img',{attrs:{"src":"/images/report.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-center u-fz-h3 u-mt0 u-mb3 u-pt2"},[_c('span',{staticClass:"u-color-secondary"},[_vm._v("- Reporta ")]),_c('span',{staticClass:"u-white"},[_vm._v("Aquí -")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-center u-fz-h4 u-mt0"},[_c('span',{staticClass:"u-block u-color-secondary"},[_vm._v("¿Qué es")]),_c('span',{staticClass:"u-block u-color-primary"},[_vm._v("Reporta Pavill?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1sE/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ServicesScreen__ = __webpack_require__("dR2x");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/servicios',
  component: __WEBPACK_IMPORTED_MODULE_0__components_ServicesScreen__["a" /* default */],
  name: 'Services'
});

/***/ }),

/***/ "22RI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'SyncLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-syncStretchDelay',
        animationDuration: '0.6s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'ease-in-out',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.07s'
      },
      spinnerDelay2: {
        animationDelay: '0.14s'
      },
      spinnerDelay3: {
        animationDelay: '0.21s'
      }
    };
  }
});

/***/ }),

/***/ "2lxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"width":"500px","modal-class":"u-bg-primary u-p3 u-overflow-visible"},on:{"hide":function($event){_vm.$emit('hide')}}},[_c('div',{staticClass:"u-px4",attrs:{"slot":"content"},slot:"content"},[_c('h3',{staticClass:"u-fz-h2 u-mt0 u-center u-line-1 u-mb4"},[_c('span',{staticClass:"u-color-secondary"},[_vm._v("Reporta ")]),_c('span',{staticClass:"u-white"},[_vm._v("Aquí")])]),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.postForm($event)}}},[_c('input-validate',{staticClass:"u-mb3 u-12/12",attrs:{"rule":_vm.rules.dni,"icon":"card","placeholder":"DNI","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.dni),callback:function ($$v) {_vm.$set(_vm.form, "dni", $$v)},expression:"form.dni"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12",attrs:{"rule":_vm.rules.cellphone,"icon":"cellphone","placeholder":"Celular o teléfono","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.cellphone),callback:function ($$v) {_vm.$set(_vm.form, "cellphone", $$v)},expression:"form.cellphone"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12",attrs:{"rule":_vm.rules.title,"icon":"message","placeholder":"Título del reporte","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}}),_c('datepicker',{staticClass:"c-input c-input--icon u-mb3",attrs:{"calendar-button":true,"calendar-button-icon":"u-icon calendar","placeholder":"Fecha de reporte","language":"es","format":"dd MMMM yyyy"},model:{value:(_vm.currentDate),callback:function ($$v) {_vm.currentDate=$$v},expression:"currentDate"}}),_c('file-validate',{staticClass:"u-mb3",attrs:{"type":"file","rule":_vm.rules.photo.extension,"icon":"photo","placeholder":"Foto","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},on:{"update":_vm.updateFile}}),_c('input-validate',{staticClass:"u-mb3 u-12/12",attrs:{"type":"textarea","rule":_vm.rules.detail,"placeholder":"Detalles del reporte","validation":_vm.toggleValidate,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.detail),callback:function ($$v) {_vm.$set(_vm.form, "detail", $$v)},expression:"form.detail"}}),_c('div',{staticClass:"u-mb3"},[_c('button',{staticClass:"c-btn--primary u-12/12 u-fw-s-bold u-fz-h4 u-py3",attrs:{"disabled":_vm.isLoading}},[_vm._v("Enviar")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Hd2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AboutScreen__ = __webpack_require__("LKUX");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/nosotros',
  component: __WEBPACK_IMPORTED_MODULE_0__components_AboutScreen__["a" /* default */],
  name: 'About'
});

/***/ }),

/***/ "3gno":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OperatorScreen__ = __webpack_require__("5LdA");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/operadora',
  name: 'Operator',
  component: __WEBPACK_IMPORTED_MODULE_0__components_OperatorScreen__["a" /* default */]
});

/***/ }),

/***/ "3mMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerComponents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_AppHeader__ = __webpack_require__("c4Eh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AppFooter__ = __webpack_require__("hytZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_InputQuantity__ = __webpack_require__("n+5Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_InputValidate__ = __webpack_require__("9Azt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_FileValidate__ = __webpack_require__("JegX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SelectValidate__ = __webpack_require__("lOtX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_InputNumber__ = __webpack_require__("EkLA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_recaptcha__ = __webpack_require__("097D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker__ = __webpack_require__("XILU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_timepicker__ = __webpack_require__("SVjV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_slick__ = __webpack_require__("jYep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper__ = __webpack_require__("F3EI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Modal__ = __webpack_require__("8bQK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_ModalVideo__ = __webpack_require__("rRNQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_ModalConfirm__ = __webpack_require__("or3v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_ModalError__ = __webpack_require__("N6Oi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_ShareButtons__ = __webpack_require__("v17k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Price__ = __webpack_require__("GBNT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Loading__ = __webpack_require__("k8bv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_spinner_src_PulseLoader__ = __webpack_require__("YzIw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_spinner_src_ClipLoader__ = __webpack_require__("QkVr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_spinner_src_SyncLoader__ = __webpack_require__("RlLa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_headroom__ = __webpack_require__("BPKv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_headroom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_headroom__);































function registerComponents(Vue) {
  Vue.component('app-footer', __WEBPACK_IMPORTED_MODULE_1_components_AppFooter__["a" /* default */]);
  Vue.component('app-header', __WEBPACK_IMPORTED_MODULE_0_components_AppHeader__["a" /* default */]);
  Vue.component('headroom', __WEBPACK_IMPORTED_MODULE_22_vue_headroom__["headroom"]);

  Vue.component('input-quantity', __WEBPACK_IMPORTED_MODULE_2_components_InputQuantity__["a" /* default */]);
  Vue.component('input-validate', __WEBPACK_IMPORTED_MODULE_3_components_InputValidate__["a" /* default */]);
  Vue.component('file-validate', __WEBPACK_IMPORTED_MODULE_4_components_FileValidate__["a" /* default */]);
  Vue.component('select-validate', __WEBPACK_IMPORTED_MODULE_5_components_SelectValidate__["a" /* default */]);
  Vue.component('input-number', __WEBPACK_IMPORTED_MODULE_6_components_InputNumber__["a" /* default */]);

  Vue.component('modal', __WEBPACK_IMPORTED_MODULE_12_components_Modal__["a" /* default */]);
  Vue.component('modal-video', __WEBPACK_IMPORTED_MODULE_13_components_ModalVideo__["a" /* default */]);
  Vue.component('modal-confirm', __WEBPACK_IMPORTED_MODULE_14_components_ModalConfirm__["a" /* default */]);
  Vue.component('modal-error', __WEBPACK_IMPORTED_MODULE_15_components_ModalError__["a" /* default */]);

  Vue.component('share-buttons', __WEBPACK_IMPORTED_MODULE_16_components_ShareButtons__["a" /* default */]);
  Vue.component('price', __WEBPACK_IMPORTED_MODULE_17_components_Price__["a" /* default */]);

  Vue.component('swiper-slide', __WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper__["swiperSlide"]);
  Vue.component('swiper', __WEBPACK_IMPORTED_MODULE_11_vue_awesome_swiper__["swiper"]);
  Vue.component('slick', __WEBPACK_IMPORTED_MODULE_10_vue_slick__["a" /* default */]);

  Vue.component('vue-recaptcha', __WEBPACK_IMPORTED_MODULE_7_vue_recaptcha___default.a);
  Vue.component('datepicker', __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker___default.a);
  Vue.component('timepicker', __WEBPACK_IMPORTED_MODULE_9_vue2_timepicker___default.a);

  Vue.component('loading', __WEBPACK_IMPORTED_MODULE_18_components_Loading__["a" /* default */]);
  Vue.component('pulse-loader', __WEBPACK_IMPORTED_MODULE_19_vue_spinner_src_PulseLoader__["a" /* default */]);
  Vue.component('clip-loader', __WEBPACK_IMPORTED_MODULE_20_vue_spinner_src_ClipLoader__["a" /* default */]);
  Vue.component('sync-loader', __WEBPACK_IMPORTED_MODULE_21_vue_spinner_src_SyncLoader__["a" /* default */]);
}

/***/ }),

/***/ "40L4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_c('div',{staticClass:"u-bg-primary"},[_c('div',{staticClass:"u-flex o-wrapper u-py5 u-flex-wrap u-items-start"},[_vm._m(0),_c('div',{staticClass:"u-white u-5/12@laptop u-6/12@tablet u-12/12 u-flex-wrap u-flex",attrs:{"data-aos":"fade-left"}},[_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.firstname,"icon":"user","placeholder":"Nombres","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.firstname),callback:function ($$v) {_vm.$set(_vm.form, "firstname", $$v)},expression:"form.firstname"}}),_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.lastname,"placeholder":"Apellidos","validation":_vm.toggleValidate,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.lastname),callback:function ($$v) {_vm.$set(_vm.form, "lastname", $$v)},expression:"form.lastname"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-px2",attrs:{"rule":_vm.rules.email,"icon":"message","placeholder":"Correo electrónico","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-px2",attrs:{"rule":_vm.rules.whatsapp,"icon":"location","placeholder":"Whatsapp","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.whatsapp),callback:function ($$v) {_vm.$set(_vm.form, "whatsapp", $$v)},expression:"form.whatsapp"}}),_c('select-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"value":_vm.form.countryId,"rule":_vm.rules.countryId,"placeholder":"País","validation":_vm.toggleValidate,"options":_vm.countries,"wrapper-class":"c-input u-bg-quaternary","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.countryId),callback:function ($$v) {_vm.$set(_vm.form, "countryId", $$v)},expression:"form.countryId"}}),_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.origin,"icon":"location","placeholder":"Origen","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.origin),callback:function ($$v) {_vm.$set(_vm.form, "origin", $$v)},expression:"form.origin"}}),_c('div',{staticClass:"u-flex u-flex-wrap u-px2 u-items-center u-mb2"},[_c('label',{staticClass:"u-block u-mb2 u-mr4 u-color-text"},[_vm._v("¿En que medio de transporte viajas?")]),_c('div',{staticClass:"c-input u-flex u-items-center u-mr3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.transportId),expression:"form.transportId"}],staticClass:"u-mr2",attrs:{"id":"transport1","type":"radio","name":"transport"},domProps:{"value":1,"checked":_vm._q(_vm.form.transportId,1)},on:{"change":function($event){_vm.$set(_vm.form, "transportId", 1)}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"transport1"}},[_vm._v("Avión")])]),_c('div',{staticClass:"c-input u-flex u-items-center u-mr3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.transportId),expression:"form.transportId"}],staticClass:"u-mr2",attrs:{"id":"transport2","type":"radio","name":"transport"},domProps:{"value":2,"checked":_vm._q(_vm.form.transportId,2)},on:{"change":function($event){_vm.$set(_vm.form, "transportId", 2)}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"transport2"}},[_vm._v("Bus")])])]),(_vm.form.transportId === 1)?_c('select-validate',{staticClass:"u-mb3 u-12/12 u-px2",attrs:{"value":_vm.form.airlineCompany,"rule":_vm.rules.airlineCompany,"placeholder":"Empresa de aerolínea","validation":_vm.toggleValidate,"options":_vm.airplanes,"wrapper-class":"c-input u-bg-quaternary","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.airlineCompany),callback:function ($$v) {_vm.$set(_vm.form, "airlineCompany", $$v)},expression:"form.airlineCompany"}}):_vm._e(),(_vm.form.transportId === 2)?_c('select-validate',{staticClass:"u-mb3 u-12/12 u-px2",attrs:{"value":_vm.form.busCompany,"rule":_vm.rules.busCompany,"placeholder":"Empresa de bus","validation":_vm.toggleValidate,"options":_vm.buses,"wrapper-class":"c-input u-bg-quaternary","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.busCompany),callback:function ($$v) {_vm.$set(_vm.form, "busCompany", $$v)},expression:"form.busCompany"}}):_vm._e(),(_vm.form.transportId === 1)?_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.flightNumber,"placeholder":"Número de vuelo","validation":_vm.toggleValidate,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.flightNumber),callback:function ($$v) {_vm.$set(_vm.form, "flightNumber", $$v)},expression:"form.flightNumber"}}):_vm._e(),_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.checkinHour,"placeholder":"Hora de llegada","validation":_vm.toggleValidate,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.checkinHour),callback:function ($$v) {_vm.$set(_vm.form, "checkinHour", $$v)},expression:"form.checkinHour"}}),_c('div',{staticClass:"c-input u-flex u-items-center u-px2 u-mb2 u-12/12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.invoice),expression:"form.invoice"}],staticClass:"u-mr2",attrs:{"id":"invoice","type":"checkbox","name":"invoice"},domProps:{"value":2,"checked":Array.isArray(_vm.form.invoice)?_vm._i(_vm.form.invoice,2)>-1:(_vm.form.invoice)},on:{"change":function($event){var $$a=_vm.form.invoice,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=2,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "invoice", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "invoice", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "invoice", $$c)}}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"invoice"}},[_vm._v("Deseo Factura")])]),_c('div',{staticClass:"u-px2 u-12/12"},[_c('button',{staticClass:"c-btn--primary u-12/12 u-fw-s-bold u-fz-h4 u-mt2",on:{"click":_vm.postForm}},[_vm._v("Realizar Reserva")])])],1)])]),_c('div',{staticClass:"u-py5"},[_vm._m(1),_c('p',{staticClass:"o-wrapper u-center u-mb5",attrs:{"data-aos":"fade-up"}},[_vm._v("Visita los principales puntos turísticos de nuestra ciudad, recorreremos la Alameda Bolognesi, Plaza de Armas apreciando el Arco Parabólico y Pileta Ornamental, Catedral, Parque de la Locomotora, Mezquita Musulmana, Zona Franca de Tacna, los principales mercadillos de la ciudad y los principales hoteles de la ciudad. Contamos con una amplia variedad de vehículos adaptándonos a sus necesidades. Infórmate más de nuestros servicios ¡Llamanos!")]),_c('div',{staticClass:"o-wrapper"},[_c('div',{staticClass:"u-relative u-6/12@tablet u-mx-auto u-px4 u-12/12",attrs:{"data-aos":"fade-up"}},[_c('swiper',{staticClass:"u-mx2",attrs:{"options":_vm.swiperGallery}},_vm._l((_vm.attractions),function(attraction,index){return _c('swiper-slide',{key:index,staticStyle:{"height":"auto"}},[_c('img',{staticClass:"u-br32",attrs:{"src":attraction.imageUrl,"title":attraction.name}})])})),_vm._m(2),_vm._m(3)],1)])]),_c('section',{staticClass:"o-wrapper u-center u-pb5"},[_c('h4',{staticClass:"u-color-primary u-fw-bold u-fz-h4 u-center o-wrapper u-mt0",attrs:{"data-aos":"fade-up"}},[_vm._v("¿Qué esperas?")]),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#root'),expression:"'#root'"}],staticClass:"c-btn--primary u-px5 u-fw-bold u-inline-flex u-items-center",attrs:{"href":"#","data-aos":"fade-up"}},[_vm._v("Realiza tu reserva")])]),_c('app-footer'),(_vm.isLoading)?_c('loading',{attrs:{"message":"Enviando"}}):_vm._e(),(_vm.isShowModalConfirm)?_c('modal-confirm',{on:{"hide":function($event){_vm.isShowModalConfirm = false}}}):_vm._e(),(_vm.isShowModalError)?_c('modal-error',{on:{"hide":function($event){_vm.isShowModalError = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-white u-7/12@laptop u-6/12@tablet u-12/12"},[_c('div',{staticClass:"u-8/12@laptop u-10/12@tablet u-mx-auto u-px2"},[_c('h2',{staticClass:"u-fz-h0 u-line-1 u-mb3 u-mt4 u-mt0",attrs:{"data-aos":"fade-right"}},[_c('span',{staticClass:"u-color-secondary u-block"},[_vm._v("¿Viajas a")]),_c('span',{staticClass:"u-white u-block"},[_vm._v("Tacna?")])]),_c('p',{staticClass:"u-color-text u-mb0 u-mt0 u-fz-h4 u-mb4",attrs:{"data-aos":"fade-right"}},[_vm._v("Horarios flexibles, un equipo jóven, un gran ambiente y muchas oportunidades")]),_c('figure',{staticClass:"u-m0 u-show@laptop ",attrs:{"data-aos":"fade-right"}},[_c('img',{attrs:{"src":"/images/car_pavill.png"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-mt0 u-mb4 u-fz-h1 u-center u-line-1",attrs:{"data-aos":"fade-up"}},[_c('span',{staticClass:"u-inline-block u-fw-light u-inline-block"},[_vm._v("Ven y Conoce ")]),_c('span',{staticClass:"u-color-secondary "},[_vm._v("Tacna")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-btn-nav c-btn-nav--prev c-btn-nav--white",attrs:{"id":"gallery-prev"}},[_c('i',{staticClass:"u-icon"},[_vm._v("arrow_left")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-btn-nav c-btn-nav--next c-btn-nav--white",attrs:{"id":"gallery-next"}},[_c('i',{staticClass:"u-icon"},[_vm._v("arrow_right")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Y0A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReserveScreen_vue__ = __webpack_require__("m1aC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c29aab2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ReserveScreen_vue__ = __webpack_require__("40L4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReserveScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c29aab2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ReserveScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5LdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperatorScreen_vue__ = __webpack_require__("VPvz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f438b064_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_OperatorScreen_vue__ = __webpack_require__("/coY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperatorScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f438b064_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_OperatorScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5l3V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{staticClass:"u-bg-primary",attrs:{"wrapper-class":"u-bg-primary","white":true}}),_c('div',{staticClass:"u-bg-landscape u-flex u-items-center",staticStyle:{"min-height":"80vh"}},[_c('div',{staticClass:"u-flex o-wrapper u-py5 u-flex-wrap u-items-center u-justify-center"},[_c('div',{staticClass:" u-6/12@laptop u-6/12@tablet u-12/12"},[_c('div',{staticClass:"u-8/12@laptop u-11/12@tablet u-mx-auto u-px2"},[_c('h2',{staticClass:"u-fz-h1 u-line-1 u-mb4 u-mt0 u-mt0 u-fw-light",attrs:{"data-aos":"fade-right"}},[_c('span',{staticClass:"u-block"},[_vm._v(_vm._s(_vm.company.name)+" está")]),_c('span',[_vm._v("para ")]),_c('span',{staticClass:"u-color-secondary u-fw-bold"},[_vm._v("ayudarte")])]),_c('p',{staticClass:"u-mb0 u-mt0 u-mb4",attrs:{"data-aos":"fade-right"}},[_vm._v("Escríbenos y nuestro departamento de consultas se pondrá en contacto para brindarte toda la información que requieras.")])])]),_c('div',{staticClass:"u-white u-5/12@laptop u-6/12@tablet u-12/12 u-flex-wrap u-flex u-justify-center",attrs:{"data-aos":"fade-left"}},[_c('input-validate',{staticClass:"u-mb3 u-12/12 u-px2",attrs:{"clear":_vm.clearForm,"rule":_vm.rules.fullname,"icon":"user","placeholder":"Nombres y apellidos","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--secondary c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.fullname),callback:function ($$v) {_vm.$set(_vm.form, "fullname", $$v)},expression:"form.fullname"}}),_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet  u-12/12 u-px2",attrs:{"clear":_vm.clearForm,"rule":_vm.rules.whatsapp,"icon":"cellphone","placeholder":"Whatsapp","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--secondary c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.whatsapp),callback:function ($$v) {_vm.$set(_vm.form, "whatsapp", $$v)},expression:"form.whatsapp"}}),_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet  u-12/12 u-px2",attrs:{"clear":_vm.clearForm,"rule":_vm.rules.email,"icon":"message","placeholder":"Correo electrónico","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--secondary c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-px2 c-input c-input--secondary",attrs:{"clear":_vm.clearForm,"rule":_vm.rules.message,"placeholder":"¿Cómo podemos ayudarte?","validation":_vm.toggleValidate,"type":"textarea","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold"},model:{value:(_vm.form.message),callback:function ($$v) {_vm.$set(_vm.form, "message", $$v)},expression:"form.message"}}),_c('div',{staticClass:"u-12/12 u-px2 u-mb2"},[_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":"6LdA-g8UAAAAAEvHOIl8vXLSz9sIsDSe4VgkvMPB"},on:{"expired":function($event){_vm.form.recaptcha = ''},"verify":_vm.onVerify}})],1),_c('div',{staticClass:"u-px2 u-10/12@tablet u-12/12"},[_c('button',{staticClass:"c-btn--primary u-12/12 u-fw-s-bold u-fz-h4 u-mt2",on:{"click":_vm.postForm}},[_vm._v("Enviar correo")])])],1)])]),_c('app-footer'),(_vm.isLoading)?_c('loading',{attrs:{"message":"Enviando"}}):_vm._e(),(_vm.isShowModalConfirm)?_c('modal-confirm',{attrs:{"message":"Nos pondremos en contacto con usted."},on:{"hide":function($event){_vm.isShowModalConfirm = false}}}):_vm._e(),(_vm.isShowModalError)?_c('modal-error',{on:{"hide":function($event){_vm.isShowModalError = false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "67t3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7oBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__("gsqX");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ "7sA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__ = __webpack_require__("gCMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7f087038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__ = __webpack_require__("goRD");
function injectStyle (ssrContext) {
  __webpack_require__("EKA0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7f087038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "89sE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8bQK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__("SBma");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a75a1fa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__("wIom");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a75a1fa0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9Azt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputValidate_vue__ = __webpack_require__("pp/w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d11832ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InputValidate_vue__ = __webpack_require__("0pDC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputValidate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d11832ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InputValidate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9uhu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalExpress_vue__ = __webpack_require__("KKBJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dafd8bf8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalExpress_vue__ = __webpack_require__("zxac");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalExpress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dafd8bf8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalExpress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AhPL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AnAc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('header',{staticClass:"c-off-canvas__wrapper",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.$emit('hide')}}},[_c('nav',{staticClass:"c-off-canvas u-overflow-auto u-flex u-flex-column u-justify-between"},[_c('div',[_c('button',{staticClass:"u-bg-transparent u-border-none u-mb4 u-pl0",on:{"click":function($event){_vm.$emit('hide')}}},[_c('i',{staticClass:"u-icon u-color-secondary u-fz-h3"},[_vm._v("menu")])]),_c('ul',{staticClass:"u-list-none u-pl0 u-mb0 u-mt0"},[_c('li',[_c('router-link',{staticClass:"c-off-canvas__link",attrs:{"to":{ name: 'Home'},"exact":"exact"}},[_vm._v("Inicio")])],1),_c('li',[_c('router-link',{staticClass:"c-off-canvas__link",attrs:{"to":{ name: 'Operator'}}},[_vm._v("Trabaja con nosotros")])],1),_c('li',[_c('router-link',{staticClass:"c-off-canvas__link",attrs:{"to":{ name: 'Services'}}},[_vm._v("Servicios")])],1),_c('li',[_c('router-link',{staticClass:"c-off-canvas__link",attrs:{"to":{ name: 'About'}}},[_vm._v("Nosotros")])],1),_c('li',[_c('router-link',{staticClass:"c-off-canvas__link",attrs:{"to":{ name: 'Posts'}}},[_vm._v("Noticias")])],1),_c('li',[_c('router-link',{staticClass:"c-off-canvas__link",attrs:{"to":{ name: 'Contact'}}},[_vm._v("Contáctanos")])],1),_c('li',{staticClass:"u-mb3 u-text-decoration-none"},[_c('a',{attrs:{"href":"https://reporta.pavill.com/","target":_vm.hrefTarget}},[_vm._v(" Reporta Pavill ")])]),_c('li',{staticClass:"u-mb3"},[_c('router-link',{staticClass:"c-off-canvas__link u-fw-s-bold u-uppercase",attrs:{"to":{ name: 'Reserve'},"exact":"exact"}},[_vm._v("Reserva ya!")])],1),_c('li',[_c('router-link',{staticClass:"u-inline-flex u-items-center c-btn--secondary u-fz-h6 u-uppercase u-uppercase u-fw-s-bold u-px4 u-decoration-none",attrs:{"to":{ name: 'App'}}},[_vm._v("Descargar App")])],1)])]),_c('div',[_c('ul',{staticClass:"u-mb4 u-pl0 u-list-none u-color-primary"},[(_vm.company.phone)?_c('li',{staticClass:"u-mb2 u-fw-s-bold"},[_c('i',{staticClass:"u-icon u-color-secondary u-mr2"},[_vm._v("phone")]),_c('span',[_vm._v(_vm._s(_vm.company.phone))])]):_vm._e(),(_vm.company.cellphone)?_c('li',{staticClass:"u-mb2 u-fw-s-bold u-flex"},[_c('i',{staticClass:"u-icon u-color-secondary u-mr2"},[_vm._v("cellphone")]),_c('span',[_vm._v(_vm._s(_vm.company.cellphone))])]):_vm._e(),(_vm.company.email)?_c('li',{staticClass:"u-mb2 u-fw-s-bold"},[_c('i',{staticClass:"u-icon u-color-secondary u-mr2"},[_vm._v("message")]),_c('span',[_vm._v(_vm._s(_vm.company.email))])]):_vm._e()]),_c('ul',{staticClass:"u-mt0 u-mb0 u-pl0 u-list-none u-flex u-flex-wrap"},[(_vm.company.facebookPage)?_c('a',{staticClass:"c-btn-share c-btn-share--facebook",attrs:{"target":"_blank","href":_vm.company.facebookPage}},[_c('i',{staticClass:"u-icon"},[_vm._v("facebook")])]):_vm._e(),(_vm.company.linkedinPage)?_c('a',{staticClass:"c-btn-share c-btn-share--linkedin",attrs:{"target":"_blank","href":_vm.company.linkedinPage}},[_c('i',{staticClass:"u-icon"},[_vm._v("linkedin")])]):_vm._e(),(_vm.company.instagramPage)?_c('a',{staticClass:"c-btn-share c-btn-share--instagram",attrs:{"target":"_blank","href":_vm.company.instagramPage}},[_c('i',{staticClass:"u-icon"},[_vm._v("instagram")])]):_vm._e(),(_vm.company.googlePage)?_c('a',{staticClass:"c-btn-share c-btn-share--google",attrs:{"target":"_blank","href":_vm.company.googlePage}},[_c('i',{staticClass:"u-icon"},[_vm._v("youtube")])]):_vm._e(),(_vm.company.soundcloudPage)?_c('a',{staticClass:"c-btn-share c-btn-share--soundcloud",attrs:{"target":"_blank","href":_vm.company.soundcloudPage}},[_c('i',{staticClass:"u-icon"},[_vm._v("soundcloud")])]):_vm._e(),(_vm.company.vimeoPage)?_c('a',{staticClass:"c-btn-share c-btn-share--vimeo",attrs:{"target":"_blank","href":_vm.company.vimeoPage}},[_c('i',{staticClass:"u-icon"},[_vm._v("vimeo")])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BDGd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppScreen__ = __webpack_require__("cLc9");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/app',
  component: __WEBPACK_IMPORTED_MODULE_0__components_AppScreen__["a" /* default */],
  name: 'App'
});

/***/ }),

/***/ "BFy/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadCompany", function() { return loadCompany; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__("onL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




var loadCompany = function loadCompany(_ref) {
  var commit = _ref.commit;

  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(window.API_URL + '/company').then(function (_ref2) {
    var data = _ref2.data;

    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* RECEIVE_COMPANY */], data.data);
  });
};

/***/ }),

/***/ "BGRw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validatorjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      toggleValidate: false,
      formValidate: false,
      isLoading: false,
      form: {
        fullname: '',
        whatsapp: '',
        origin: '',
        destiny: ''
      },
      rules: {
        fullname: 'required',
        whatsapp: 'required',
        origin: 'required',
        destiny: 'required'
      }
    };
  },


  methods: {
    postForm: function postForm() {
      var _this = this;

      this.validate();

      if (this.formValidate && !this.isLoading) {
        this.isLoading = true;
        // axios.post(`${window.API_URL}/radiotaxi`, this.form)
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://radiotaxipavill.ddns.net:8015/enlacepavill/RegistrarPedidoNormal.php', this.form);
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(window.API_URL + '/radiotaxi', this.form).then(function (response) {
          _this.isLoading = false;
          _this.$emit('hide');
          _this.$emit('success');
        }).catch(function (_ref) {
          var response = _ref.response;

          _this.isLoading = false;
          _this.$emit('hide');
          _this.$emit('error');
        });
      }
    },
    validate: function validate() {
      var validation = new __WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a(this.form, this.rules);
      validation.passes();
      this.toggleValidate = !this.toggleValidate;
      this.formValidate = validation.passes();
    }
  }
});

/***/ }),

/***/ "CpyN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"c-modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.$emit('hide')}}},[_c('div',{staticClass:"c-modal__content u-px4 u-pb4 u-center",class:_vm.modalClass,staticStyle:{"overflow":"visible"},style:({width: _vm.width})},[_c('img',{staticClass:"c-modal__confirm",attrs:{"src":"/images/ready.png"}}),_c('h3',{staticClass:"u-color-dark u-fz-h1 u-center u-mt2 u-mb3 u-fw-s-bold"},[_vm._v("¡Gracias!")]),_c('p',{staticClass:"u-fz-h4 u-py2"},[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"c-btn--success u-9/12@tablet u-12/12",on:{"click":function($event){_vm.$emit('hide')}}},[_vm._v("Finalizar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DF8/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__ = __webpack_require__("sax8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins__ = __webpack_require__("nqDH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_ajax__ = __webpack_require__("yYnH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_company__ = __webpack_require__("1hP4");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    ajax: __WEBPACK_IMPORTED_MODULE_4__modules_ajax__["a" /* default */],
    company: __WEBPACK_IMPORTED_MODULE_5__modules_company__["a" /* default */]
  },
  strict: debug,
  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default()(), __WEBPACK_IMPORTED_MODULE_3__plugins__["a" /* localStoragePlugin */]] : [__WEBPACK_IMPORTED_MODULE_3__plugins__["a" /* localStoragePlugin */]]
}));

/***/ }),

/***/ "DI1c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DNYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DfAW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-quantity"},[_c('button',{staticClass:"c-quantity__btn",attrs:{"type":"button"},on:{"click":function($event){_vm.less()}}},[_vm._v("-")]),_c('input',{ref:"quantity",staticClass:"c-quantity__input",attrs:{"type":"number","max":_vm.maxQuantity,"min":_vm.minQuantity,"number":"number"},domProps:{"value":_vm.quantity},on:{"input":function($event){_vm.handleChange($event)}}}),_c('button',{staticClass:"c-quantity__btn",attrs:{"type":"button"},on:{"click":function($event){_vm.more()}}},[_vm._v("+")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dlsl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EKA0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EXu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"number":"number","type":"number","placeholder":_vm.placeholder,"min":_vm.minQuantity,"max":_vm.maxQuantity},domProps:{"value":_vm.value},on:{"input":function($event){_vm.updateValue($event.target.value)},"blur":_vm.formatValue}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ej4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DriverScreen__ = __webpack_require__("vKnM");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/conductor',
  name: 'Driver',
  component: __WEBPACK_IMPORTED_MODULE_0__components_DriverScreen__["a" /* default */]
});

/***/ }),

/***/ "EkLA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputNumber_vue__ = __webpack_require__("QvV2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eda159aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InputNumber_vue__ = __webpack_require__("EXu4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eda159aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InputNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Etg8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-flex"},_vm._l((_vm.shares),function(share){return (!(!_vm.isMobil && share === 'whatsapp'))?_c('button',{staticClass:"c-btn-share",class:("c-btn-share--" + share),on:{"click":function($event){_vm.shareSocial(_vm.urls[share])}}},[_c('i',{staticClass:"u-icon"},[_vm._v(_vm._s(share))])]):_vm._e()}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GBNT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Price_vue__ = __webpack_require__("tHdN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5649d255_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Price_vue__ = __webpack_require__("+ANa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Price_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5649d255_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Price_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GJge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostsScreen_vue__ = __webpack_require__("+U0J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73d92e8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PostsScreen_vue__ = __webpack_require__("ngMx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostsScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73d92e8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PostsScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GyhJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import MaterialPhotoGallery from 'material-photo-gallery'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AboutScreen',
  data: function data() {
    return {
      swiperFeatures: {
        slidesPerView: 5,
        autoplay: 5000,
        breakpoints: {
          889: {
            slidesPerView: 4
          },
          778: {
            slidesPerView: 3
          },
          560: {
            slidesPerView: 2
          },
          320: {
            slidesPerView: 1
          }
        }
      },
      features: [{
        id: 1,
        title: 'Buen trato al cliente',
        imageUrl: '/images/icon1.png',
        description: 'Atención personalizada en el servicio y buen trato al cliente, siempre con responsabilidad, respeto y honradez.'
      }, {
        id: 2,
        title: 'Flota moderna',
        imageUrl: '/images/icon2.png',
        description: 'Pavill cuenta con vehículos modernos para brindar comodidad en su trayectoria, seguridad y confort.'
      }, {
        id: 3,
        title: 'Conductores con experiencia',
        imageUrl: '/images/icon3.png',
        description: 'Nuestros conductores cuentan con amplia experiencia y están en constante capacitación.'
      }, {
        id: 4,
        title: 'Central telefónica moderna',
        imageUrl: '/images/icon4.png',
        description: 'Central telefónica moderna disponible las 24 horas del día, envio de taxi a domicilio y delivery.'
      }, {
        id: 5,
        title: 'Servicio de taxi por App',
        imageUrl: '/images/icon5.png',
        description: 'Para un servicio más rápido, confiable, y personal, le ofrecemos el servicio de aplicación desde su celular.'
      }]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  mounted: function mounted() {
    setTimeout(function () {
      var elem = document.querySelector('.m-p-g');
      /* eslint-disable */
      if (elem) {
        new MaterialPhotoGallery(elem);
      }
      /* eslint-enable */
    }, 500);
  }
});

/***/ }),

/***/ "H0Kz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoading", function() { return isLoading; });
var isLoading = function isLoading(state, getters, rootState) {
  return state.inProgress > 0;
};

/***/ }),

/***/ "Hpn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_vm._t("parallax-bg"),_vm._v(" "),_c('div',{class:_vm.defaultSwiperClasses.wrapperClass},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination"),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next"),_vm._v(" "),_vm._t("scrollbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IRfg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeaderResponsive_vue__ = __webpack_require__("swk/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68461b70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeaderResponsive_vue__ = __webpack_require__("AnAc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeaderResponsive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68461b70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeaderResponsive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JK1+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ComplaintsScreen__ = __webpack_require__("vhJW");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/reclamaciones',
  name: 'Complaints',
  component: __WEBPACK_IMPORTED_MODULE_0__components_ComplaintsScreen__["a" /* default */]
});

/***/ }),

/***/ "JMiZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JegX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileValidate_vue__ = __webpack_require__("MyUA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e3720e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_FileValidate_vue__ = __webpack_require__("nvOJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileValidate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e3720e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_FileValidate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JzpG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "company", function() { return company; });
var company = function company(_ref) {
  var company = _ref.company;
  return company;
};

/***/ }),

/***/ "KKBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validatorjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      toggleValidate: false,
      formValidate: false,
      isLoading: false,
      form: {
        fullname: '',
        whatsapp: '',
        origin: '',
        destiny: '',
        specificTime: false,
        roundTrip: false,
        hours: null
      },
      rules: {
        fullname: 'required|name',
        whatsapp: 'required|phone',
        origin: 'required',
        hours: ''
      }
    };
  },


  methods: {
    postForm: function postForm() {
      var _this = this;

      this.validate();

      if (this.formValidate && !this.isLoading) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://radiotaxipavill.ddns.net:8015/enlacepavill/RegistrarPedidoExpreso.php', this.form);
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(window.API_URL + '/express', this.form).then(function (response) {
          _this.isLoading = false;
          _this.$emit('hide');
          _this.$emit('success');
        }).catch(function (_ref) {
          var response = _ref.response;

          _this.isLoading = false;
          _this.$emit('hide');
          _this.$emit('error');
        });
      }
    },
    validate: function validate() {
      var validation = new __WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a(this.form, this.rules);
      validation.passes();
      this.toggleValidate = !this.toggleValidate;
      this.formValidate = validation.passes();
    }
  },

  watch: {
    'form.specificTime': function formSpecificTime(val) {
      if (val) {
        this.rules.hours = 'required|min:1';
      } else {
        this.rules.hours = '';
        this.form.hours = null;
      }
    }
  }
});

/***/ }),

/***/ "KZHh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LKUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutScreen_vue__ = __webpack_require__("GyhJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0726ef8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AboutScreen_vue__ = __webpack_require__("NIAv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0726ef8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AboutScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LZOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{staticClass:"u-bg-primary",attrs:{"white":true,"wrapper-class":"u-bg-primary"}}),_c('progressive-background',{attrs:{"src":_vm.currentPost.imageUrl,"placeholder":_vm.currentPost.imageThumbUrl}}),_c('article',{staticClass:"o-wrapper o-container u-py5"},[_c('h2',{staticClass:"c-post__title u-fz-h3 u-mt0 u-mb3",attrs:{"data-aos":"fade-up"}},[_vm._v(_vm._s(_vm.currentPost.title))]),_c('p',{staticClass:"u-mb0 u-capitalize u-fw-s-bold u-mb4 u-color-dark",attrs:{"data-aos":"fade-up"}},[_vm._v(_vm._s(_vm.currentPost.date))]),_c('div',{staticClass:"u-mb4",attrs:{"data-aos":"fade-up"},domProps:{"innerHTML":_vm._s(_vm.currentPost.content)}}),_c('p',{staticClass:"u-uppercase u-border-top u-pt3 u-mt0",attrs:{"data-aos":"fade-up"}},[_vm._v("Compartir")]),_c('share-buttons',{attrs:{"shares":['facebook', 'gplus', 'linkedin'],"data-aos":"fade-up"}})],1),(_vm.posts.length > 0)?_c('div',{staticClass:"u-pt5 u-pb4",staticStyle:{"background-color":"#f0f0f0","background-position":"0% 100%","background-image":"url(/images/footer.png)"}},[_c('aside',{staticClass:"o-wrapper o-container"},[_c('p',{staticClass:"u-uppercase u-color-dark u-fw-s-bold u-mt0",attrs:{"data-aos":"fade-up"}},[_vm._v("Más noticias")]),_c('section',_vm._l((_vm.posts),function(post){return _c('article',{staticClass:"c-post u-mb4",attrs:{"data-aos":"fade-up"}},[_c('div',{staticClass:"u-p4"},[_c('router-link',{staticClass:"c-post__title u-fz-h3",attrs:{"to":{ name: 'Post', params:{slug: post.slug}}}},[_vm._v(_vm._s(post.title))]),_c('div',{domProps:{"innerHTML":_vm._s(post.content)}}),_c('p',[_c('router-link',{staticClass:"u-color-secondary",attrs:{"to":{ name: 'Post', params:{slug: post.slug}}}},[_vm._v("Leer más...")])],1),_c('p',{staticClass:"u-mb0 u-right-align u-capitalize u-color-dark u-fw-s-bold"},[_vm._v(_vm._s(post.date))])],1)])}))])]):_vm._e(),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MJKa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MyUA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validatorjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    inputClass: String,
    wrapperClass: String,
    label: String,
    info: String,
    labelClass: String,
    name: String,
    placeholder: String,
    validation: Boolean,
    icon: String,
    clear: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {
          extension: '',
          base64: ''
        };
      }
    },
    accept: {
      type: String,
      default: 'image/png,image/jpeg'
    },
    errorClass: {
      type: String,
      default: 'u-color-error'
    },
    rule: {
      type: String,
      default: 'required'
    }
  },

  data: function data() {
    return {
      image: this.value,
      title: this.placeholder,
      validated: false,
      message: ''
    };
  },


  methods: {
    updateImage: function updateImage(e) {
      var files = e.target.files || e.dataTransfer.files;
      var self = this;

      var reader = new window.FileReader();
      reader.onload = function () {
        self.image = {
          base64: reader.result,
          extension: files[0].type.split('/')[1]

          // window.open(reader.result)
        };self.title = files[0].name;
        self.$emit('update', self.image);
        self.validate();
      };

      reader.readAsDataURL(files[0]);
    },


    // updateValue (value) {
    //   this.$emit('input', value)
    //   this.validate()
    // },

    validate: function validate() {
      if (this.rule) {
        var validate = new __WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a({ value: this.$refs.input.value }, { value: this.rule });
        this.validated = validate.passes();
        this.message = validate.errors.first('value');
      }
    }
  },

  watch: {
    validation: function validation(val, oldVal) {
      this.validate();
    },
    clear: function clear(val) {
      this.title = this.placeholder;
    }
  }
});

/***/ }),

/***/ "N+zL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__("+p9J");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_115f7cdb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__("OcrF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_115f7cdb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "N1kN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N6Oi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalError_vue__ = __webpack_require__("uNBx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c1b67a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalError_vue__ = __webpack_require__("U40S");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c1b67a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validatorjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("evzl");



window.$ = window.jQuery = __webpack_require__("7t+N");

// require('headroom.js/dist/jQuery.headroom.min.js')
__webpack_require__("oPmM");
__webpack_require__("AhPL");
__webpack_require__("f/JR");
__webpack_require__("6igw");

__webpack_require__("DI1c");
__webpack_require__("Dlsl");
__webpack_require__("89sE");
// require('material-photo-gallery/dist/js/material-photo-gallery.js')
__webpack_require__("6gWF");
Date.masks.default = 'YYYY-MM-DD';
__webpack_require__("67t3");

window.toastr = __webpack_require__("vQJi");
window.toastr.options = {
  'escapeHtml': true,
  'closeButton': false,
  'debug': false,
  'newestOnTop': false,
  'progressBar': true,
  'positionClass': 'toast-top-right',
  'onclick': null,
  'showDuration': '500',
  'hideDuration': '1000',
  'timeOut': '5000',
  'extendedTimeOut': '1000',
  'showEasing': 'swing',
  'hideEasing': 'linear',
  'showMethod': 'fadeIn',
  'hideMethod': 'fadeOut'
};

__WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a.useLang('es');

__WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a.register('phone', function (value) {
  return value.match(/^\+{0,1}[0-9;\- ]{0,16}$/);
}, 'Ingrese su número correctamente.');
__WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a.register('name', function (value) {
  return value.match(/^[a-zA-ZñáéíóúÑÁÉÍÓÚüÜ;\- ]+$/);
}, 'Este campo sólo acepta texto.');

var messages = __WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a.getMessages('es');
messages.required = 'Por favor complete este campo!';
messages.email = 'Este no es una dirección de email correcta.';
messages.min = 'Ingrese un valor mayor o igual a :min.';
messages.url = 'Esta no es una url correcta.';
messages.integer = 'Este campo solo acepta números.';
__WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a.setMessages('es', messages);

/* eslint-disable */
var aos = __webpack_require__("RInU");
new aos.init({
  offset: 100,
  delay: 0,
  startEvent: 'DOMContentLoaded'
});
/* eslint-enable */
__WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#root');

/***/ }),

/***/ "NIAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{staticClass:"u-absolute",attrs:{"white":true}}),_c('section',{staticClass:"u-flex u-items-center u-relative",staticStyle:{"min-height":"85vh"}},[_c('figure',{staticClass:"u-m0 u-absolute u-left-0 u-right-0 u-top-0 u-bottom-0 u-bg-opacity",staticStyle:{"z-index":"-1","background-image":"url(/images/about.jpg)","background-size":"cover","background-position":"50% 50%"}}),_c('div',{staticClass:"o-about"},[_c('h2',{staticClass:"u-line-1 u-fz-h0",attrs:{"data-aos":"fade-up"}},[_c('span',{staticClass:"u-white u-block"},[_vm._v("¿Quién es ")]),_c('span',{staticClass:"u-block u-color-secondary u-fw-bold "},[_vm._v(_vm._s(_vm.company.name)+"?")])])])]),_c('section',{staticClass:"u-py5"},[_c('article',{staticClass:"c-about o-about-left"},[_vm._m(0),_c('div',{staticClass:"c-about__content u-flex-1",staticStyle:{"margin-top":"-10rem"},attrs:{"data-aos":"fade-up"}},[_c('p',{staticClass:"c-about__title u-4/12@tablet"},[_vm._v("Empresa Líder")]),_c('div',{staticClass:"u-mb4",domProps:{"innerHTML":_vm._s(_vm.company.description)}}),_c('img',{attrs:{"src":"/images/car_pavill2.png"}})])]),_c('article',{staticClass:"c-about o-about-right"},[_vm._m(1),_c('div',{staticClass:"c-about__content u-flex-1",attrs:{"data-aos":"fade-left"}},[_c('p',{staticClass:"c-about__title"},[_vm._v("Visión")]),_c('div',{staticClass:"u-mb4",domProps:{"innerHTML":_vm._s(_vm.company.vision)}})])]),_c('article',{staticClass:"c-about o-about-left"},[_vm._m(2),_c('div',{staticClass:"c-about__content u-flex-1",attrs:{"data-aos":"fade-right"}},[_c('p',{staticClass:"c-about__title"},[_vm._v("Misión")]),_c('div',{staticClass:"u-mb4",domProps:{"innerHTML":_vm._s(_vm.company.mission)}})])])]),_c('section',{staticClass:"o-wrapper u-mb5"},[_vm._m(3),_c('swiper',{staticClass:"u-12/12",attrs:{"options":_vm.swiperFeatures}},_vm._l((_vm.features),function(feature,index){return _c('swiper-slide',{key:index,staticClass:"u-flex",staticStyle:{"height":"auto"}},[_c('div',{staticClass:"c-feature u-flex-1",attrs:{"data-aos":"fade-up"}},[_c('figure',{staticClass:"u-mt0 u-mb0 u-mx-auto u-px3",staticStyle:{"width":"80px"}},[_c('img',{attrs:{"src":feature.imageUrl}})]),_c('p',{staticClass:"u-fw-bold u-uppercase u-color-primary"},[_vm._v(_vm._s(feature.title))]),_c('p',{staticClass:"u-color-tex u-mb0"},[_vm._v(_vm._s(feature.description))])])])}))],1),_c('section',[_vm._m(4),_c('div',{staticClass:"m-p-g o-wrapper u-overflow-auto"},[_c('div',{staticClass:"m-p-g__thumbs",attrs:{"data-google-image-layout":"data-google-image-layout","data-max-height":"320"}},_vm._l((_vm.company.gallery),function(image){return _c('img',{staticClass:"m-p-g__thumbs-img",attrs:{"src":image.urlThumb,"data-full":image.url}})})),_c('div',{staticClass:"m-p-g__fullscreen"})])]),_c('app-footer',{staticClass:"u-mt5"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-about__image u-6/12@tablet",attrs:{"data-aos":"fade-left"}},[_c('figure',{staticStyle:{"background-image":"url(/images/description.jpg)"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-about__image u-6/12@tablet",attrs:{"data-aos":"fade-right"}},[_c('figure',{staticStyle:{"background-image":"url(/images/vision.jpg)"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-about__image u-6/12@tablet",attrs:{"data-aos":"fade-left"}},[_c('figure',{staticStyle:{"background-image":"url(/images/mission.jpg)"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"u-center u-fz-h1 u-line-1 u-mt3",attrs:{"data-aos":"fade-up"}},[_c('span',{staticClass:"u-fw-light"},[_vm._v("Marcamos la ")]),_c('strong',{staticClass:"u-color-secondary"},[_vm._v("Diferencia")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"u-center u-fz-h1 u-line-1 u-mt3",attrs:{"data-aos":"fade-up"}},[_c('span',{staticClass:"u-fw-light"},[_vm._v("Juntos por un mismo ")]),_c('strong',{staticClass:"u-color-secondary"},[_vm._v("Sueño")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NRQ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppFooter',
  props: {
    showInfo: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      date: new Date(),
      isMobile: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  }), {
    faceWeb: function faceWeb() {
      return 'https://www.facebook.com/plugins/page.php?href=https%3A%2F%2F' + this.company.facebookPage + '&tabs=timeline&width=300&height=72&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId';
    }
  }),

  mounted: function mounted() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true;
    }
  }
});

/***/ }),

/***/ "O57X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TermsScreen__ = __webpack_require__("TFg5");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/terminos-y-condiciones',
  component: __WEBPACK_IMPORTED_MODULE_0__components_TermsScreen__["a" /* default */],
  name: 'Terms'
});

/***/ }),

/***/ "O86X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppHeaderResponsive__ = __webpack_require__("IRfg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { AppHeaderResponsive: __WEBPACK_IMPORTED_MODULE_2__AppHeaderResponsive__["a" /* default */] },
  props: {
    wrapperClass: String,
    white: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      isShowCart: false,
      isHeaderResponsive: false,
      swiperItems: {
        slidesPerView: 6,
        spaceBetween: 30,
        breakpoints: {
          458: {
            slidesPerView: 1
          },
          620: {
            slidesPerView: 2
          },
          889: {
            slidesPerView: 3
          },
          998: {
            slidesPerView: 4
          },
          1099: {
            slidesPerView: 5
          }
        }
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  mounted: function mounted() {
    // window.$('.c-header__wrapper').headroom()
  },


  watch: {
    '$route': function $route() {
      this.isHeaderResponsive = false;
    }
  }
});

/***/ }),

/***/ "ON1F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ReportScreen__ = __webpack_require__("tKG8");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/reporta/:slug',
  name: 'Report',
  component: __WEBPACK_IMPORTED_MODULE_0__components_ReportScreen__["a" /* default */]
});

/***/ }),

/***/ "OcrF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.slideClass},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PZgt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PostScreen',
  data: function data() {
    return {
      currentPost: false,
      posts: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  }), {
    faceWeb: function faceWeb() {
      // return `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(this.company.facebookPage)}&tabs=timeline&width=500&height=200&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`
      return 'https://www.facebook.com/plugins/page.php?href=' + encodeURIComponent('https://www.facebook.com/NoveltiePeru/') + '&tabs=timeline&width=500&height=200&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId';
    }
  }),

  methods: {
    getRelated: function getRelated() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/posts/' + this.$route.params.slug + '/related').then(function (_ref) {
        var data = _ref.data;

        _this.posts = data.data;
      });
    }
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/posts/' + to.params.slug).then(function (_ref2) {
      var data = _ref2.data;

      next(function (vm) {
        vm.currentPost = data.data;
      });
    }).catch(function () {
      next({ name: 'NotFound' });
    });
  },


  watch: {
    currentPost: function currentPost(val) {
      this.getRelated();
    },
    $route: function $route(val, olVal) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/posts/' + this.$route.params.slug).then(function (_ref3) {
        var data = _ref3.data;

        _this2.currentPost = data.data;
      });
    }
  }
});

/***/ }),

/***/ "Polv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReportScreen',
  data: function data() {
    return {
      currentPost: false,
      reports: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  }), {
    faceWeb: function faceWeb() {
      // return `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(this.company.facebookPage)}&tabs=timeline&width=500&height=200&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId`
      return 'https://www.facebook.com/plugins/page.php?href=' + encodeURIComponent('https://www.facebook.com/NoveltiePeru/') + '&tabs=timeline&width=500&height=200&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId';
    }
  }),

  methods: {
    getRelated: function getRelated() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/reports/last').then(function (_ref) {
        var data = _ref.data;

        _this.reports = data.data;
      });
    }
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/reports/' + to.params.slug).then(function (_ref2) {
      var data = _ref2.data;

      next(function (vm) {
        vm.currentPost = data.data;
      });
    }).catch(function () {
      next({ name: 'NotFound' });
    });
  },


  watch: {
    currentPost: function currentPost(val) {
      this.getRelated();
    },
    $route: function $route(val, olVal) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/reports/' + this.$route.params.slug).then(function (_ref3) {
        var data = _ref3.data;

        _this2.currentPost = data.data;
      });
    }
  }
});

/***/ }),

/***/ "Q6vL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NotFoundScreen__ = __webpack_require__("+QWg");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/404',
  name: 'NotFound',
  component: __WEBPACK_IMPORTED_MODULE_0__components_NotFoundScreen__["a" /* default */]
});

/***/ }),

/***/ "QN4d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("NotFoundScreen")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QYPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"c-header"},[_c('div',{staticClass:"u-relative"},[_c('headroom',{staticClass:"c-header__wrapper o-container",class:[{'c-header--white' : _vm.white}, _vm.wrapperClass]},[_c('router-link',{staticClass:"c-header__logo",attrs:{"to":{ name: 'Home'}}},[(!_vm.white)?_c('img',{attrs:{"src":_vm.company.logoUrl}}):_vm._e(),(_vm.white)?_c('img',{attrs:{"src":_vm.company.whiteLogoUrl}}):_vm._e()]),_c('div',{staticClass:"u-flex u-items-center"},[_c('ul',{staticClass:"u-list-none  u-pl0 u-flex u-items-center u-mt0 u-mb0 u-show@laptop"},[_c('li',{staticClass:"u-mr3 u-py2 c-dropdown u-relative"},[_c('a',{staticClass:"c-header__link"},[_vm._v("Trabaja con nosotros")]),_c('ul',{staticClass:"c-dropdown__content"},[_c('li',[_c('router-link',{staticClass:"c-dropdown__item",attrs:{"to":{ name: 'Driver'}}},[_vm._v("Conductor")])],1),_c('li',{staticClass:"c-dropdown__item"},[_c('router-link',{staticClass:"c-dropdown__item",attrs:{"to":{ name: 'Operator'}}},[_vm._v("Radio Operadora")])],1)])]),_c('li',{staticClass:"u-mx3 u-py2"},[_c('router-link',{staticClass:"c-header__link",attrs:{"to":{ name: 'Services'}}},[_vm._v("Servicios")])],1),_c('li',{staticClass:"u-mx3 u-py2"},[_c('router-link',{staticClass:"c-header__link",attrs:{"to":{ name: 'About'}}},[_vm._v("Nosotros")])],1),_c('li',{staticClass:"u-mx3 u-py2"},[_c('router-link',{staticClass:"c-header__link",attrs:{"to":{ name: 'Posts'}}},[_vm._v("Noticias")])],1),_c('li',{staticClass:"u-ml3 u-mr2 u-py2"},[_c('router-link',{staticClass:"c-header__link",attrs:{"to":{ name: 'Contact'}}},[_vm._v("Contáctanos")])],1),_c('li',{staticClass:"u-mr4 u-ml2 u-pl3 u-uppercase u-fw-bold u-border-left u-border-text"},[_c('router-link',{staticClass:"c-header__link u-pt0 u-pb0",attrs:{"to":{ name: 'Reserve'}}},[_vm._v("Reserva Ya!")])],1)]),_c('router-link',{staticClass:"u-flex u-items-center c-btn--secondary u-fz-h6 u-uppercase u-uppercase u-fw-s-bold u-px4 u-show@tablet u-decoration-none",attrs:{"to":{ name: 'App'}}},[_vm._v("Descargar App")]),_c('button',{staticClass:"u-flex u-fz-h3 u-items-center c-header__btn u-ml3",on:{"click":function($event){_vm.isHeaderResponsive = true}}},[_c('i',{staticClass:"u-icon"},[_vm._v("menu")])])],1)],1)],1),(_vm.isHeaderResponsive)?_c('app-header-responsive',{on:{"hide":function($event){_vm.isHeaderResponsive = false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QkVr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ClipLoader_vue__ = __webpack_require__("TFaj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7edc50d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ClipLoader_vue__ = __webpack_require__("x3ZV");
function injectStyle (ssrContext) {
  __webpack_require__("MJKa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ClipLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7edc50d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ClipLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QkdM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{staticClass:"u-absolute",attrs:{"white":true}}),_c('ul',{staticClass:"u-white u-3/12 u-list-none c-service__wrapper u-show@tablet",attrs:{"id":"menu"}},_vm._l((_vm.services),function(serv){return _c('li',{staticClass:"u-mb3"},[_c('a',{staticClass:"c-service",class:{'not-selected' : ("#" + (serv.slug)) !== _vm.$route.hash},style:({backgroundColor: serv.color}),attrs:{"href":("#" + (serv.slug)),"data-menuanchor":serv.slug}},[_vm._v(_vm._s(serv.name)),_c('span',{staticClass:"c-service__image u-icon service",style:({color: serv.color})})])])})),_c('div',{attrs:{"id":"fullpage"}},_vm._l((_vm.services),function(service){return _c('div',{staticClass:"section u-flex u-items-center"},[_c('figure',{staticClass:"u-bg-image u-bg-opacity",style:({backgroundImage: 'url(' + service.background + ')'})}),_c('div',{staticClass:"o-wrapper u-flex u-justify-between u-items-center"},[_c('ul',{staticClass:"u-white u-3/12 u-list-none u-show@tablet"}),_c('figure',{staticClass:"u-4/12@tablet u-m0 u-px4 u-show@tablet"},[_c('img',{attrs:{"src":service.imageUrl}})]),_c('div',{staticClass:"u-5/12@tablet u-12/12 u-4/12@laptop"},[_c('h2',{staticClass:"u-fw-light u-fz-h1 u-white u-mt0"},[_vm._v(_vm._s(service.title))]),_c('div',{staticClass:"u-white u-mb3",domProps:{"innerHTML":_vm._s(service.description)}}),(service.images.length > 0)?_c('div',[_c('button',{staticClass:"u-inline-flex u-items-center u-mb4 c-btn--white",on:{"click":function($event){_vm.showGallery('gallery' + service.id)}}},[_c('i',{staticClass:"u-icon u-mr2"},[_vm._v("camera")]),_c('span',{staticClass:"u-fw-s-bold"},[_vm._v("Ver galería de fotos")])])]):_vm._e(),_c('div',[_c('button',{staticClass:"c-btn--primary u-7/12 u-inline-block u-fw-s-bold",on:{"click":function($event){_vm.showModalService(service.id)}}},[_vm._v("Pedir "+_vm._s(service.name))])]),_c('div',{directives:[{name:"viewer",rawName:"v-viewer",value:(_vm.options),expression:"options"}],attrs:{"id":'gallery' + service.id}},[_vm._l((service.images),function(image){return [_c('img',{key:image.url,staticClass:"u-hide",attrs:{"data-source":image.url,"src":image.urlThumb}})]})],2)])])])})),(_vm.isShowModalDelivery)?_c('modal-delivery',{on:{"hide":function($event){_vm.isShowModalDelivery = false},"success":function($event){_vm.isShowModalConfirm = true},"error":function($event){_vm.isShowModalError = true}}}):_vm._e(),(_vm.isShowModalExpress)?_c('modal-express',{on:{"hide":function($event){_vm.isShowModalExpress = false},"success":function($event){_vm.isShowModalConfirm = true},"error":function($event){_vm.isShowModalError = true}}}):_vm._e(),(_vm.isShowModalRadioTaxi)?_c('modal-radio-taxi',{on:{"hide":function($event){_vm.isShowModalRadioTaxi = false},"success":function($event){_vm.isShowModalConfirm = true},"error":function($event){_vm.isShowModalError = true}}}):_vm._e(),(_vm.isShowModalTourism)?_c('modal-tourism',{on:{"hide":function($event){_vm.isShowModalTourism = false},"success":function($event){_vm.isShowModalConfirm = true},"error":function($event){_vm.isShowModalError = true}}}):_vm._e(),(_vm.isShowModalWomanTaxi)?_c('modal-woman-taxi',{on:{"hide":function($event){_vm.isShowModalWomanTaxi = false},"success":function($event){_vm.isShowModalConfirm = true},"error":function($event){_vm.isShowModalError = true}}}):_vm._e(),(_vm.isShowModalConfirm)?_c('modal-confirm',{on:{"hide":function($event){_vm.isShowModalConfirm = false}}}):_vm._e(),(_vm.isShowModalError)?_c('modal-error',{on:{"hide":function($event){_vm.isShowModalError = false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QrN2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("bowN");





var debug = "production" !== 'production';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: debug ? 'history' : 'history',
  linkActiveClass: 'is-active',
  routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "QvV2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    placeholder: String,
    value: {
      type: [Number, null],
      default: null
    },

    minQuantity: {
      type: Number,
      default: 1
    },

    flagTop: {
      type: Boolean,
      default: true
    },

    maxQuantity: {
      type: [Number, null],
      default: null
    },

    decimal: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    updateValue: function updateValue(value) {
      var newValue = null;
      if (parseInt(value, 10)) {
        newValue = parseFloat((parseInt(value * 100, 10) / 100).toFixed(2));
      }

      if (!this.decimal) {
        newValue = Math.round(newValue, 10);
      }

      if (isNaN(newValue)) {
        newValue = this.minQuantity;
      }

      if (this.maxQuantity !== null && this.flagTop && newValue > this.maxQuantity) {
        newValue = this.maxQuantity;
      }

      this.$emit('input', newValue);
    },
    formatValue: function formatValue() {
      if (this.value === null || this.value < this.minQuantity) {
        this.$emit('input', this.minQuantity);
      }
    }
  }
});

/***/ }),

/***/ "R4eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{staticClass:"u-absolute",attrs:{"white":true}}),_c('section',{staticClass:"u-flex u-items-center o-container u-min-height-100vh",staticStyle:{"background-size":"cover","background-position":"0% 100%","background-image":"url(/images/home.jpg)"}},[_c('div',{staticClass:"o-wrapper u-py3 u-flex  u-items-center u-flex-wrap u-justify-between"},[_c('div',{staticClass:"u-py3  u-6/12@tablet u-12/12"},[_vm._m(0),_vm._m(1),_c('router-link',{staticClass:"u-inline-flex u-items-center u-fw-bold u-uppercase c-btn--primary",attrs:{"to":{ name: 'App'},"data-aos":"fade-right"}},[_vm._v("Descargar App")])],1),_c('div',{staticClass:"u-py3 "},[(_vm.company.homeVideo)?_c('button',{staticClass:"u-color-secondary c-video-play",attrs:{"data-aos":"fade-left"},on:{"click":function($event){_vm.isShowModalVideo = true}}},[_c('i',{staticClass:"u-icon"},[_vm._v("video")])]):_vm._e()])])]),_c('section',{staticClass:"u-bg-degradent o-container u-white u-pt5 u-pb4"},[_vm._m(2),_c('p',{staticClass:"u-mt0 u-center u-mb4",attrs:{"data-aos":"fade-up"}},[_vm._v("Varios tipos de vehículos a tu disposición para tu ubicación y necesidades.")]),_c('ul',{staticClass:"u-list-none u-flex u-justify-center u-flex-wrap u-mb0 u-pl0"},_vm._l((_vm.services),function(service){return _c('li',{staticClass:"u-mb4 u-mt3 u-px3",attrs:{"data-aos":"fade-up"}},[_c('button',{staticClass:"c-service",style:({backgroundColor: service.color}),on:{"click":function($event){_vm.showModalService(service.id)}}},[_vm._v(_vm._s(service.name)),_c('span',{staticClass:"c-service__image u-icon service",style:({color: service.color})})])])}))]),_c('section',{staticClass:"u-bg-secondary u-pt5"},[_c('div',{staticClass:" u-justify-between u-flex  u-flex-wrap o-wrapper"},[_c('div',{staticClass:"u-4/12@laptop  u-12/12 u-mb4"},[_c('p',{staticClass:"u-fz-h1 u-mt0  u-mb0 u-white u-line-1",attrs:{"data-aos":"fade-right"}},[_c('strong',[_vm._v("Pide")]),_c('span',{staticClass:"u-block u-fw-light"},[_vm._v("un "+_vm._s(_vm.company.name))])]),_vm._m(3)]),_c('ul',{staticClass:"u-flex u-list-none u-flex-wrap u-6/12@laptop u-12/12 u-pl0 u-m0 u-justify-center"},[_vm._m(4),_c('li',{staticClass:"u-px4 u-mb5 u-6/12@tablet",attrs:{"data-aos":"fade-left"}},[_vm._m(5),_vm._m(6),_c('p',{staticClass:"u-center u-white u-mb0 u-mt0"},[_c('strong',{staticClass:"u-fz-h4"},[_vm._v(_vm._s(_vm.company.phone))])]),_vm._m(7),_c('p',{staticClass:"u-center u-white u-mb0 u-mt0"},[_c('strong',{staticClass:"u-fz-h4"},[_vm._v(_vm._s(_vm.company.cellphone))])])])])])]),_vm._m(8),_c('section',{staticClass:"o-wrapper u-py5"},[_vm._m(9),_c('swiper',{staticClass:"u-12/12",attrs:{"options":_vm.swiperFeatures}},_vm._l((_vm.features),function(feature,index){return _c('swiper-slide',{key:index,staticClass:"u-flex",staticStyle:{"height":"auto"},attrs:{"data-aos":"fade-up"}},[_c('div',{staticClass:"c-feature u-flex-1"},[_c('figure',{staticClass:"u-mt0 u-mb0 u-mx-auto u-px3",staticStyle:{"width":"80px"}},[_c('img',{attrs:{"src":feature.imageUrl}})]),_c('p',{staticClass:"u-fw-bold u-uppercase u-color-primary"},[_vm._v(_vm._s(feature.title))]),_c('p',{staticClass:"u-color-tex u-mb0"},[_vm._v(_vm._s(feature.description))])])])}))],1),_c('a',{attrs:{"href":"https://reporta.pavill.com/","target":_vm.hrefTarget}},[_c('img',{staticClass:"u-block u-12/12",attrs:{"src":"/images/report.jpg"}})]),(_vm.testimonies.length > 0)?_c('section',{staticClass:"u-bg-primary u-py5"},[_c('div',{staticClass:"u-relative o-wrapper u-my4"},[_c('swiper',{staticClass:"u-12/12",attrs:{"options":_vm.swiperTestimonies}},_vm._l((_vm.testimonies),function(testimony,index){return _c('swiper-slide',{key:index,staticClass:"u-center o-container"},[_c('p',{staticClass:"u-fz-h3 u-fw-bold u-white u-mt0 u-mb3"},[_vm._v(_vm._s(testimony.name))]),_c('p',{staticClass:"u-color-text u-mb0"},[_vm._v(_vm._s(testimony.content))])])})),_vm._m(10),_vm._m(11)],1)]):_vm._e(),_c('section',{staticClass:"u-bg-secondary u-py5 o-container"},[_c('div',{staticClass:"u-flex u-flex-wrap u-br8 u-overflow-hidden u-justify-center u-mx-auto",staticStyle:{"width":"850px","max-width":"100%"},attrs:{"data-aos":"fade-up"}},[_c('div',{staticClass:"u-bg-border u-px4 u-py4 u-4/12@laptop u-12/12 u-flex u-justify-center u-flex-column"},[_vm._m(12),_c('p',{staticClass:"u-fw-s-bold u-mb2"},[_vm._v("Compartir en:")]),_c('a',{staticClass:"c-btn-share u-bg-primary",attrs:{"href":_vm.company.facebookPage,"target":"_blank"}},[_c('i',{staticClass:"u-icon"},[_vm._v("facebook")])])]),_c('div',{staticClass:"u-bg-white u-py4 u-px3 u-flex-1"},[_c('iframe',{staticClass:"u-mx-auto u-block u-facebook",staticStyle:{"border":"none","overflow":"hidden"},attrs:{"src":_vm.faceWeb,"width":"500","height":"200","scrolling":"no","frameborder":"0","allowTransparency":"true"}})])])]),(_vm.company && _vm.company.parnerts.length > 0)?_c('section',{staticClass:"u-pt5 u-pb4 u-bg-landscape"},[_vm._m(13),_c('ul',{staticClass:"u-flex u-flex-wrap u-pl0 u-list-none u-mb0 o-wrapper u-justify-center"},_vm._l((_vm.company.parnerts),function(parnert){return _c('li',{staticClass:"u-px4 u-mb4"},[_c('a',{staticClass:"u-m0 u-block",staticStyle:{"height":"60px"},attrs:{"href":parnert.link,"target":"_blank"}},[_c('img',{staticStyle:{"max-height":"100%"},attrs:{"src":parnert.imageUrl,"title":parnert.title}})])])}))]):_vm._e(),_c('app-footer'),(_vm.isShowModalDelivery)?_c('modal-delivery',{on:{"hide":function($event){_vm.isShowModalDelivery = false},"success":function($event){_vm.isShowModalConfirm = true},"error":function($event){_vm.isShowModalError = true}}}):_vm._e(),(_vm.isShowModalExpress)?_c('modal-express',{on:{"hide":function($event){_vm.isShowModalExpress = false},"success":function($event){_vm.isShowModalConfirm = true},"error":function($event){_vm.isShowModalError = true}}}):_vm._e(),(_vm.isShowModalRadioTaxi)?_c('modal-radio-taxi',{on:{"hide":function($event){_vm.isShowModalRadioTaxi = false},"success":function($event){_vm.isShowModalConfirm = true},"error":function($event){_vm.isShowModalError = true}}}):_vm._e(),(_vm.isShowModalTourism)?_c('modal-tourism',{on:{"hide":function($event){_vm.isShowModalTourism = false},"success":function($event){_vm.isShowModalConfirm = true},"error":function($event){_vm.isShowModalError = true}}}):_vm._e(),(_vm.isShowModalWomanTaxi)?_c('modal-woman-taxi',{on:{"hide":function($event){_vm.isShowModalWomanTaxi = false},"success":function($event){_vm.isShowModalConfirm = true},"error":function($event){_vm.isShowModalError = true}}}):_vm._e(),(_vm.isShowModalVideo)?_c('modal-video',{attrs:{"url":_vm.company.homeVideo},on:{"hide":function($event){_vm.isShowModalVideo = false},"success":function($event){_vm.isShowModalConfirm = true},"error":function($event){_vm.isShowModalError = true}}}):_vm._e(),(_vm.isShowModalConfirm)?_c('modal-confirm',{on:{"hide":function($event){_vm.isShowModalConfirm = false}}}):_vm._e(),(_vm.isShowModalError)?_c('modal-error',{on:{"hide":function($event){_vm.isShowModalError = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"u-line-1",attrs:{"data-aos":"fade-right"}},[_c('span',{staticClass:"u-fz-h2 u-white u-fw-light u-block"},[_vm._v("Seria, Responsable")]),_c('span',{staticClass:"u-fz-h0 u-block u-white u-fw-bold"},[_vm._v("de mucha")]),_c('span',{staticClass:"u-fz-h0 u-block u-color-secondary u-fw-bold "},[_vm._v("Confianza.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"u-white u-fz-h4",attrs:{"data-aos":"fade-right"}},[_c('span',{staticClass:"u-fw-bold u-uppercase"},[_vm._v("Instale la aplicación ")]),_c('span',{staticClass:"u-color-text"},[_vm._v("en tu móvil y vive")]),_c('span',{staticClass:"u-block u-color-text"},[_vm._v("tu experiencia en Tacna con Pavill.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-white u-mt0 u-mb3 u-fz-h2 u-center u-line-1",attrs:{"data-aos":"fade-up"}},[_c('span',{staticClass:" u-inline-block u-fw-light"},[_vm._v("¿Qué ")]),_c('span',{staticClass:"u-inline-block"},[_vm._v("Servicios ")]),_c('span',{staticClass:"u-inline-block u-fw-light"},[_vm._v("deseas hoy?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"u-ml0 u-mr0",attrs:{"data-aos":"fade-right"}},[_c('img',{attrs:{"src":"/images/car.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"u-px4 u-mb5 u-6/12@tablet",attrs:{"data-aos":"fade-left"}},[_c('figure',{staticClass:"u-mt0 u-mb0 u-mx-auto",staticStyle:{"width":"250px"}},[_c('img',{attrs:{"src":"/images/cellphone.png"}})]),_c('p',{staticClass:"u-center u-white u-mb0"},[_c('span',{staticClass:"u-fw-light u-fz-h4"},[_vm._v("Descarga nuestra ")]),_c('strong',{staticClass:"u-fz-h4"},[_vm._v("aplicación móvil para android")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"u-mt0 u-mb0 u-mx-auto",staticStyle:{"width":"250px"}},[_c('img',{attrs:{"src":"/images/call.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"u-center u-white u-mb0"},[_c('span',{staticClass:"u-fw-light u-fz-h4"},[_vm._v("Llamar al")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"u-center u-white u-mb0 u-mt0"},[_c('span',{staticClass:"u-fw-light u-fz-h4"},[_vm._v("o al whatsapp")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"u-m0 u-show@tablet"},[_c('img',{staticClass:"u-12/12",attrs:{"src":"/images/border-bottom.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"u-center u-fz-h1 u-line-1 u-mt3",attrs:{"data-aos":"fade-up"}},[_c('span',{staticClass:"u-block u-fw-light"},[_vm._v("Marcamos la")]),_c('strong',{staticClass:"u-block u-color-secondary"},[_vm._v("Diferencia")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-btn-nav c-btn-nav--prev c-btn-nav--white",attrs:{"id":"testimony-prev"}},[_c('i',{staticClass:"u-icon"},[_vm._v("arrow_left")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-btn-nav c-btn-nav--next c-btn-nav--white",attrs:{"id":"testimony-next"}},[_c('i',{staticClass:"u-icon"},[_vm._v("arrow_right")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"u-fw-bold u-line-1 u-color-primary u-fz-h3 u-uppercase u-mt0"},[_vm._v("Síguenos en"),_c('span',{staticClass:"u-block"},[_vm._v("Facebook")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-fz-h2 u-center u-mt0 u-line-1 o-wrapper u-mb5"},[_c('span',{staticClass:"u-color-secondary"},[_vm._v("Trabajamos juntos ")]),_c('span',{staticClass:"u-color-primary"},[_vm._v("para un mejor servicio")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RlLa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SyncLoader_vue__ = __webpack_require__("22RI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0a9ecc07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SyncLoader_vue__ = __webpack_require__("oDt+");
function injectStyle (ssrContext) {
  __webpack_require__("JMiZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SyncLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0a9ecc07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SyncLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rp6+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isShowButtonTop: false
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    loadCompany: 'loadCompany'
  }), {
    handleScroll: function handleScroll() {
      var win = window.$(window);

      if (win.scrollTop() >= win.height()) {
        this.isShowButtonTop = true;
      } else {
        this.isShowButtonTop = false;
      }
    },
    goTop: function goTop() {
      window.$(window).animate({ scrollTop: 0 }, '2000', 'swing');
    }
  }),

  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  created: function created() {
    this.loadCompany();
  }
});

/***/ }),

/***/ "SBma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: String,
      default: 'auto'
    },
    modalClass: String
  },

  beforeCreate: function beforeCreate() {
    window.$('body').css('overflow-y', 'hidden');
  },
  beforeDestroy: function beforeDestroy() {
    window.$('body').css('overflow-y', '');
  }
});

/***/ }),

/***/ "SDej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeScreen_vue__ = __webpack_require__("q9OF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403e4711_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_HomeScreen_vue__ = __webpack_require__("R4eh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_403e4711_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_HomeScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SRNr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_validatorjs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContactScreen',
  data: function data() {
    return {
      isShowModalConfirm: false,
      isShowModalError: false,
      toggleValidate: false,
      formValidate: false,
      clearForm: false,
      isLoading: false,
      form: {
        fullname: '',
        email: '',
        whatsapp: '',
        message: '',
        recaptcha: ''
      },
      rules: {
        fullname: 'required',
        email: 'required|email',
        whatsapp: 'required|phone',
        recaptcha: 'required'
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  methods: {
    postForm: function postForm() {
      var _this = this;

      this.validate();

      if (this.formValidate && !this.isLoading) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(window.API_URL + '/contact', this.form).then(function (response) {
          _this.isShowModalConfirm = true;
          _this.isLoading = false;
          var recaptcha = _this.form.recaptcha;
          _this.form = {
            fullname: '',
            email: '',
            whatsapp: '',
            message: '',
            recaptcha: recaptcha
          };
          _this.clearForm = true;
        }).catch(function (_ref) {
          var response = _ref.response;

          _this.isLoading = false;
          _this.isShowModalError = true;
        });
      }
    },
    validate: function validate() {
      var validation = new __WEBPACK_IMPORTED_MODULE_3_validatorjs___default.a(this.form, this.rules);
      validation.passes();
      this.toggleValidate = !this.toggleValidate;
      this.formValidate = validation.passes();
    },
    onVerify: function onVerify(value) {
      this.form.recaptcha = value;
    }
  }
});

/***/ }),

/***/ "ShzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PostScreen__ = __webpack_require__("ZaT/");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/noticias/:slug',
  name: 'Post',
  component: __WEBPACK_IMPORTED_MODULE_0__components_PostScreen__["a" /* default */]
});

/***/ }),

/***/ "Sk9G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_validatorjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ModalReport__ = __webpack_require__("ZseE");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReportsScreen',
  components: {
    ModalReport: __WEBPACK_IMPORTED_MODULE_4__ModalReport__["a" /* default */]
  },
  data: function data() {
    return {
      reports: [],
      isShowModalReport: false,
      isShowModalError: false,
      isShowModalConfirm: false,
      isLoading: false,
      toggleValidate: false,
      formValidate: false,
      clearForm: false,
      currentDate: '',
      currentPage: 1,
      totalPages: 1,
      lastPage: 1,
      form: {
        dni: '',
        cellphone: '',
        title: '',
        date: '',
        detail: '',
        // recaptcha: '',
        photo: {
          base64: '',
          extension: ''
        }
      },
      rules: {
        dni: 'required',
        title: 'required',
        date: 'required',
        detail: 'required',
        photo: {
          extension: 'required'
        },
        // recaptcha: 'required'
        cellphone: 'required|phone'
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  methods: {
    getReports: function getReports() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/reports?page=' + this.currentPage).then(function (_ref) {
        var data = _ref.data;

        _this.reports = data.data;
        _this.totalPages = data.last_page;
        _this.isLoading = false;
      });
    },
    prevReports: function prevReports() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        this.getReports();
      }
    },
    nextReports: function nextReports() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1;
        this.getReports();
      }
    },
    changePage: function changePage(page) {
      this.currentPage = page;
      this.getReports();
    },
    postForm: function postForm() {
      var _this2 = this;

      this.validate();

      if (this.formValidate && !this.isLoading) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(window.API_URL + '/reports', this.form).then(function (response) {
          _this2.isShowModalConfirm = true;
          _this2.isLoading = false;
          // this.$refs.recaptcha.reset()
          _this2.currentDate = '';
          _this2.form = {
            dni: '',
            cellphone: '',
            title: '',
            date: '',
            detail: '',
            recaptcha: '',
            photo: {
              base64: '',
              extension: ''
            }
          };
          _this2.clearForm = !_this2.clearForm;
        }).catch(function (_ref2) {
          var response = _ref2.response;

          _this2.isLoading = false;
          _this2.isShowModalError = true;
        });
      }
    },
    validate: function validate() {
      var validation = new __WEBPACK_IMPORTED_MODULE_3_validatorjs___default.a(this.form, this.rules);
      validation.passes();
      this.toggleValidate = !this.toggleValidate;
      this.formValidate = validation.passes();
    },
    updateFile: function updateFile(image) {
      this.form.photo = image;
    },
    onVerify: function onVerify(value) {
      this.form.recaptcha = value;
    }
  },

  created: function created() {
    this.getReports();
  },


  watch: {
    currentDate: function currentDate(val) {
      if (val) {
        this.form.date = val.format();
      } else {
        this.form.date = '';
      }
    }
  }
});

/***/ }),

/***/ "TFaj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'ClipLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '35px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size,
        width: this.size,
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: this.color + ' ' + this.color + ' transparent',
        borderRadius: this.radius,
        background: 'transparent'
      };
    }
  }
});

/***/ }),

/***/ "TFg5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsScreen_vue__ = __webpack_require__("TmuR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305e8ad0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_TermsScreen_vue__ = __webpack_require__("y16v");
function injectStyle (ssrContext) {
  __webpack_require__("lxni")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-305e8ad0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305e8ad0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_TermsScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TmuR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TermsScreen',
  data: function data() {
    return {};
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  methods: {}
});

/***/ }),

/***/ "U40S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"c-modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.$emit('hide')}}},[_c('div',{staticClass:"c-modal__content u-px4 u-pb4 u-center",class:_vm.modalClass,staticStyle:{"overflow":"visible"},style:({width: _vm.width})},[_c('img',{staticClass:"c-modal__confirm",attrs:{"src":"/images/error.png"}}),_c('h3',{staticClass:"u-color-dark u-fz-h1 u-center u-mt2 u-mb3 u-fw-s-bold"},[_vm._v("¡UPS!")]),_c('p',{staticClass:"u-fz-h4 u-py2"},[_vm._v("Al parecer hubo un problema "),_c('br'),_vm._v("Por favor vuelva a intentarlo.")]),_c('button',{staticClass:"c-btn--error u-9/12@tablet u-12/12",on:{"click":function($event){_vm.$emit('hide')}}},[_vm._v("Aceptar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VPvz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_validatorjs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OperatorScreen',
  data: function data() {
    return {
      isShowModalConfirm: false,
      isShowModalError: false,
      toggleValidate: false,
      clearForm: false,
      formValidate: false,
      isLoading: false,
      form: {
        firstname: '',
        lastname: '',
        dni: '',
        workExperience: '',
        whyWork: '',
        photo: {
          base64: '',
          extension: ''
        },
        curriculumvitae: ''
      },
      rules: {
        firstname: 'required|name',
        lastname: 'required|name',
        dni: 'required',
        workExperience: 'required',
        whyWork: 'required',
        photo: {
          extension: 'required'
        },
        curriculumvitae: 'required|url'
      },
      infos: {
        curriculumvitae: '<span class="u-block">Insertar o copiar una URL del documento</span><span class="u-block">Ejm: <strong>www.drive.google.com/midocumento</strong></span>',
        photo: 'Tamaño máximo del archivo <strong>2MB</strong>'
      },
      whereabouts: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  methods: {
    postForm: function postForm() {
      var _this = this;

      this.validate();

      if (this.formValidate && !this.isLoading) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(window.API_URL + '/operators', this.form).then(function (response) {
          _this.isLoading = false;
          _this.isShowModalConfirm = true;
          _this.form = {
            firstname: '',
            lastname: '',
            dni: '',
            workExperience: '',
            whyWork: '',
            photo: {
              base64: '',
              extension: ''
            },
            curriculumvitae: ''
          };
          _this.clearForm = true;
        }).catch(function (_ref) {
          var response = _ref.response;

          _this.isLoading = false;
          _this.isShowModalError = true;
        });
      }
    },
    validate: function validate() {
      var validation = new __WEBPACK_IMPORTED_MODULE_3_validatorjs___default.a(this.form, this.rules);
      validation.passes();
      this.toggleValidate = !this.toggleValidate;
      this.formValidate = validation.passes();
    },
    updateFile: function updateFile(image) {
      this.form.photo = image;
    },
    getWhereabouts: function getWhereabouts() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/whereabouts').then(function (_ref2) {
        var data = _ref2.data;

        _this2.whereabouts = data.data;
      });
    }
  },

  created: function created() {
    this.getWhereabouts();
  }
});

/***/ }),

/***/ "W6ZF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-load"},[_c('p',{staticClass:"u-mb3 u-mt0 u-white u-fz-h1"},[_vm._v(_vm._s(_vm.message))]),_c('pulse-loader',{attrs:{"color":"white","size":"20px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WLtR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    minQuantity: {
      type: [Number, String],
      default: 1
    },
    quantity: {
      type: [Number, String],
      required: true
    },
    less: {
      type: Function,
      default: function _default() {}
    },
    more: {
      type: Function,
      default: function _default() {}
    },
    newValue: {
      type: Function,
      default: function _default() {}
    }
  },
  methods: {
    handleChange: function handleChange(event) {
      var newValue = event.target.value;
      if (newValue > this.minQuantity) {
        this.newValue(newValue);
      } else {
        this.newValue(this.minQuantity);
      }
    }
  }
});

/***/ }),

/***/ "XVQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDelivery_vue__ = __webpack_require__("YAkj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_200432e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDelivery_vue__ = __webpack_require__("dajh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDelivery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_200432e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDelivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xsej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"c-modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.$emit('hide')}}},[_c('div',{staticClass:"c-modal__content u-bg-black",staticStyle:{"width":"900px"}},[_c('div',{staticClass:"c-video__button"},[_c('iframe',{attrs:{"slot":"content","width":"100%","height":"200","src":_vm.currentVideoUrl,"frameborder":"0","allowfullscreen":"allowfullscreen"},slot:"content"})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YAkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validatorjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      toggleValidate: false,
      formValidate: false,
      isLoading: false,
      form: {
        fullname: '',
        whatsapp: '',
        placeOfPurchase: '',
        purchaseDescription: '',
        destinyAddress: '',
        destinyReference: ''
      },
      rules: {
        fullname: 'required',
        whatsapp: 'required|phone',
        placeOfPurchase: 'required',
        purchaseDescription: 'required',
        destinyAddress: 'required',
        destinyReference: 'required'
      }
    };
  },


  methods: {
    postForm: function postForm() {
      var _this = this;

      this.validate();

      if (this.formValidate && !this.isLoading) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://radiotaxipavill.ddns.net:8015/enlacepavill/RegistrarPedidoDelivery.php', this.form);
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(window.API_URL + '/delivery', this.form).then(function (response) {
          _this.isLoading = false;
          _this.$emit('hide');
          _this.$emit('success');
        }).catch(function (_ref) {
          var response = _ref.response;

          _this.isLoading = false;
          _this.$emit('hide');
          _this.$emit('error');
        });
      }
    },
    validate: function validate() {
      var validation = new __WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a(this.form, this.rules);
      validation.passes();
      this.toggleValidate = !this.toggleValidate;
      this.formValidate = validation.passes();
    }
  }
});

/***/ }),

/***/ "YzIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PulseLoader_vue__ = __webpack_require__("i/iG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__ = __webpack_require__("iL/f");
function injectStyle (ssrContext) {
  __webpack_require__("KZHh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PulseLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z1Ew":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    message: {
      type: String,
      default: 'Cargando'
    }
  },

  mounted: function mounted() {
    window.$('body').css('overflow-y', 'hidden');
  },
  beforeDestroy: function beforeDestroy() {
    window.$('body').css('overflow-y', '');
  }
});

/***/ }),

/***/ "Z3Ux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotFoundScreen'
});

/***/ }),

/***/ "ZQTd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validatorjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    validation: Boolean,
    wrapperClass: String,
    icon: String,
    placeholder: {
      type: String,
      default: 'Seleccione'
    },
    options: {
      type: Array,
      default: []
    },
    errorClass: {
      type: String,
      default: 'u-color-error'
    },
    rule: {
      type: String,
      default: 'min:1'
    },
    selectClass: String,
    value: Number,
    label: String,
    message: {
      type: String,
      default: 'Seleccione una opción'
    }
  },

  data: function data() {
    return {
      isShowMessage: false,
      validated: false
    };
  },


  methods: {
    updateValue: function updateValue(value) {
      this.validate();
      this.$emit('input', parseInt(value, 10));
    },
    validate: function validate() {
      if (this.rule) {
        var validate = new __WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a({ value: parseInt(this.$refs.input.value, 10) }, { value: this.rule });
        this.validated = validate.passes();
        this.isShowMessage = validate.errors.first('value');
      }
    }
  },

  watch: {
    validation: function validation(val, oldVal) {
      this.validate();
    }
  }
});

/***/ }),

/***/ "ZaT/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostScreen_vue__ = __webpack_require__("PZgt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da47736_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PostScreen_vue__ = __webpack_require__("LZOi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da47736_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PostScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZflP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsScreen_vue__ = __webpack_require__("Sk9G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5621f1f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsScreen_vue__ = __webpack_require__("1pPX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5621f1f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZseE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalReport_vue__ = __webpack_require__("p3sy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae135810_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalReport_vue__ = __webpack_require__("2lxP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae135810_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zsuk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ReserveScreen__ = __webpack_require__("4Y0A");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/reserva',
  name: 'Reserve',
  component: __WEBPACK_IMPORTED_MODULE_0__components_ReserveScreen__["a" /* default */]
});

/***/ }),

/***/ "bS0T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"root"}},[_c('router-view'),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#root'),expression:"'#root'"}],staticClass:"c-btn-top",class:_vm.isShowButtonTop ? 'is-show' : '',attrs:{"href":"#"}},[_c('i',{staticClass:"u-icon"},[_vm._v("arrow_right")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bowN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_screens_Home__ = __webpack_require__("jBYz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_screens_NotFound__ = __webpack_require__("Q6vL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_screens_Construction__ = __webpack_require__("1RGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_screens_About__ = __webpack_require__("3Hd2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_screens_Driver__ = __webpack_require__("Ej4N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_screens_Operator__ = __webpack_require__("3gno");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_screens_Reserve__ = __webpack_require__("Zsuk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_screens_Services__ = __webpack_require__("1sE/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_screens_App__ = __webpack_require__("BDGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_screens_Posts__ = __webpack_require__("etME");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_screens_Post__ = __webpack_require__("ShzI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_screens_Contact__ = __webpack_require__("qtDB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_screens_Complaints__ = __webpack_require__("JK1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__app_screens_Terms__ = __webpack_require__("O57X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_screens_Reports__ = __webpack_require__("xj/w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__app_screens_Report__ = __webpack_require__("ON1F");

















var routes = [__WEBPACK_IMPORTED_MODULE_0__app_screens_Home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__app_screens_About__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__app_screens_Terms__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__app_screens_Construction__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__app_screens_Driver__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__app_screens_Operator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__app_screens_Reserve__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__app_screens_Services__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__app_screens_App__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__app_screens_Posts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__app_screens_Post__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__app_screens_Contact__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__app_screens_Complaints__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__app_screens_Reports__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__app_screens_Report__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app_screens_NotFound__["a" /* default */], {
  path: '*',
  redirect: { name: 'NotFound' }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "c4Eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__("O86X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b184620_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__("QYPt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b184620_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cJ1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_validatorjs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DriverScreen',
  data: function data() {
    return {
      toggleValidate: false,
      formValidate: false,
      isLoading: false,
      clearForm: false,
      isShowModalError: false,
      isShowModalConfirm: false,
      form: {
        hasVehicle: true,
        firstname: '',
        lastname: '',
        dni: '',
        cellphone: '',
        driverLicense: '',
        vehiclePlate: '',
        year: null,
        baseRadio: true,
        model: '',
        chanels: '',
        professionaldriveExperience: '',
        whyWork: ''
      },
      rules: {
        firstname: 'required|name',
        lastname: 'required|name',
        dni: 'required',
        cellphone: 'required|phone',
        driverLicense: 'required',
        vehiclePlate: 'required',
        year: 'required|integer',
        model: 'required',
        chanels: 'required'
      },
      whereabouts: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  methods: {
    postForm: function postForm() {
      var _this = this;

      this.validate();

      if (this.formValidate && !this.isLoading) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(window.API_URL + '/drivers', this.form).then(function (response) {
          _this.isLoading = false;
          _this.isShowModalConfirm = true;
          _this.form = {
            hasVehicle: true,
            firstname: '',
            lastname: '',
            dni: '',
            cellphone: '',
            driverLicense: '',
            vehiclePlate: '',
            year: null,
            baseRadio: true,
            model: '',
            chanels: '',
            professionaldriveExperience: '',
            whyWork: ''
          };
          _this.clearForm = true;
        }).catch(function (_ref) {
          var response = _ref.response;

          _this.isLoading = false;
          _this.isShowModalError = true;
        });
      }
    },
    validate: function validate() {
      this.toggleValidate = !this.toggleValidate;
      var validation = new __WEBPACK_IMPORTED_MODULE_3_validatorjs___default.a(this.form, this.rules);

      validation.passes();
      this.formValidate = validation.passes();
    },
    getWhereabouts: function getWhereabouts() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/whereabouts').then(function (_ref2) {
        var data = _ref2.data;

        _this2.whereabouts = data.data;
      });
    }
  },

  created: function created() {
    this.getWhereabouts();
  },


  watch: {
    'form.baseRadio': function formBaseRadio(val) {
      if (val) {
        this.rules.model = 'required';
        this.rules.chanels = 'required';
      } else {
        this.rules.model = '';
        this.rules.chanels = '';
        this.form.model = '';
        this.form.chanels = '';
      }
    },
    'form.hasVehicle': function formHasVehicle(val) {
      if (val) {
        this.rules.vehiclePlate = 'required';
        this.rules.year = 'required|integer';
      } else {
        this.rules.vehiclePlate = '';
        this.rules.year = '';
        this.form.vehiclePlate = '';
        this.form.year = '';
        this.form.baseRadio = false;
      }
    }
  }
});

/***/ }),

/***/ "cLc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppScreen_vue__ = __webpack_require__("gPYu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab4414b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppScreen_vue__ = __webpack_require__("ockH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab4414b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dR2x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServicesScreen_vue__ = __webpack_require__("kQde");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c3fc6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ServicesScreen_vue__ = __webpack_require__("QkdM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServicesScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c3fc6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ServicesScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dajh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"width":"500px","modal-class":"u-bg-primary u-p3"},on:{"hide":function($event){_vm.$emit('hide')}}},[_c('div',{staticClass:"u-px4",attrs:{"slot":"content"},slot:"content"},[_c('h3',{staticClass:"u-fz-h2 u-mt0 u-center u-line-1 u-mb4"},[_c('span',{staticClass:"u-white"},[_vm._v("Reserva un Pavill para ")]),_c('span',{staticClass:"u-color-secondary"},[_vm._v("Delivery")])]),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.fullname,"name":"fullname","icon":"user","placeholder":"Nombres y apellidos","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.fullname),callback:function ($$v) {_vm.$set(_vm.form, "fullname", $$v)},expression:"form.fullname"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.whatsapp,"name":"whatsapp","icon":"whatsapp","placeholder":"Whatsapp","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.whatsapp),callback:function ($$v) {_vm.$set(_vm.form, "whatsapp", $$v)},expression:"form.whatsapp"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.placeOfPurchase,"icon":"location","placeholder":"Lugar de compra","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.placeOfPurchase),callback:function ($$v) {_vm.$set(_vm.form, "placeOfPurchase", $$v)},expression:"form.placeOfPurchase"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.purchaseDescription,"placeholder":"Descripción de la compra","type":"textarea","validation":_vm.toggleValidate,"rows":"3","wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.purchaseDescription),callback:function ($$v) {_vm.$set(_vm.form, "purchaseDescription", $$v)},expression:"form.purchaseDescription"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.destinyAddress,"icon":"transport","placeholder":"¿A dónde llevo tu compra?","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.destinyAddress),callback:function ($$v) {_vm.$set(_vm.form, "destinyAddress", $$v)},expression:"form.destinyAddress"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.destinyReference,"placeholder":"Referencia del lugar de destino","validation":_vm.toggleValidate,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.destinyReference),callback:function ($$v) {_vm.$set(_vm.form, "destinyReference", $$v)},expression:"form.destinyReference"}}),_c('button',{staticClass:"c-btn--primary u-12/12 u-fw-s-bold u-mb3 u-fz-h4 u-mt2",on:{"click":_vm.postForm}},[_vm._v("Realizar Reserva")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ehw1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConstructionScreen',

  data: function data() {
    return {
      percentage: 0,
      today: new Date(new Date().setHours(0, 0, 0)),
      startDate: new Date('10/21/2017'),
      endDate: new Date('1/1/2018')
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  methods: {
    getLoad: function getLoad() {
      var _this = this;

      var passedDays = parseInt(((this.today - this.startDate) / 24 / 3600 / 1000).toFixed(0), 10);
      var totalDays = (this.endDate - this.startDate) / 24 / 3600 / 1000;
      var xDays = parseInt((100 * passedDays / totalDays).toFixed(0), 10);

      var interval = setInterval(function () {
        _this.percentage++;

        if (_this.percentage >= xDays || _this.percentage >= 99) {
          clearInterval(interval);
        }
      }, 50);
    }
  },

  mounted: function mounted() {
    this.getLoad();
  }
});

/***/ }),

/***/ "ekIZ":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de": "GoRv",
	"./de.js": "GoRv",
	"./el": "YBGD",
	"./el.js": "YBGD",
	"./en": "a+GG",
	"./en.js": "a+GG",
	"./es": "hlff",
	"./es.js": "hlff",
	"./fa": "FBL3",
	"./fa.js": "FBL3",
	"./fr": "spYB",
	"./fr.js": "spYB",
	"./it": "JRcz",
	"./it.js": "JRcz",
	"./ja": "zhtS",
	"./ja.js": "zhtS",
	"./nb_NO": "60Od",
	"./nb_NO.js": "60Od",
	"./nl": "T8P1",
	"./nl.js": "T8P1",
	"./pl": "DQle",
	"./pl.js": "DQle",
	"./pt": "pX3b",
	"./pt.js": "pX3b",
	"./ru": "K90p",
	"./ru.js": "K90p",
	"./tr": "YxGU",
	"./tr.js": "YxGU",
	"./ua": "wrFv",
	"./ua.js": "wrFv",
	"./vi": "UzW1",
	"./vi.js": "UzW1",
	"./zh": "IlzH",
	"./zh.js": "IlzH",
	"./zh_TW": "7Hn3",
	"./zh_TW.js": "7Hn3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ekIZ";

/***/ }),

/***/ "enRu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: String,
      default: '360px'
    },
    message: {
      type: String,
      default: 'En breves momentos nos comunicaremos con usted.'
    },
    modalClass: String
  },

  mounted: function mounted() {
    window.$('body').css('overflow-y', 'hidden');
  },
  beforeDestroy: function beforeDestroy() {
    window.$('body').css('overflow-y', '');
  }
});

/***/ }),

/***/ "etME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PostsScreen__ = __webpack_require__("GJge");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/noticias',
  name: 'Posts',
  component: __WEBPACK_IMPORTED_MODULE_0__components_PostsScreen__["a" /* default */]
});

/***/ }),

/***/ "evzl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_store__ = __webpack_require__("DF8/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_router__ = __webpack_require__("QrN2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Root__ = __webpack_require__("gUXg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_registerFilters__ = __webpack_require__("obte");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_registerComponents__ = __webpack_require__("3mMu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_mask__ = __webpack_require__("1I9z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_fullpage__ = __webpack_require__("M6Dg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_fullpage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_fullpage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_scrollto__ = __webpack_require__("bm7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_progressive_image__ = __webpack_require__("vlaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_progressive_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_progressive_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_v_viewer__ = __webpack_require__("EAZf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_v_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_v_viewer__);
/* unused harmony reexport router */
/* unused harmony reexport store */
















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_v_viewer___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_progressive_image___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_fullpage___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_v_mask__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_7__config_registerComponents__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]);
Object(__WEBPACK_IMPORTED_MODULE_6__config_registerFilters__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]);

Object(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_2__config_store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__config_router__["a" /* default */]);

var app = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  router: __WEBPACK_IMPORTED_MODULE_3__config_router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_2__config_store__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_5__components_Root__["a" /* default */]));



/***/ }),

/***/ "f/JR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gCMD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'readValues',
    'displayTime': 'fillValues'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }

      this.fillValues();
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
      this.$emit('change', { data: fullValues });
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),

/***/ "gPYu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppScreen',
  data: function data() {
    return {
      selectStep: 0,
      isShowModalVideo: false,
      slickOptions: {
        arrows: false,
        centerPadding: '0',
        centerMode: true,
        slidesToScroll: 1,
        slidesToShow: 5,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      },
      apps: [{
        imageUrl: 'https://lh3.googleusercontent.com/lrhMZZm0BcZEfho7nvUs4SuNl-CJ416jg8O5Q7sBnTkXhm44dL2zuXjKMLRYNlu_SCY=h900-rw'
      }, {
        imageUrl: 'https://lh3.googleusercontent.com/NHeE4QWA4n9dNmGZ6dwkeCQkE6e4DnbZapLUJGWCq8_ZKDFlSgsO0glNgYvQcB34FF4=h900-rw'
      }, {
        imageUrl: 'https://lh3.googleusercontent.com/izKVM3z1RZYPcL6dyCdY_Rh2e3rVQkx5yPEwFmbEDFqetFfaqo1_mY495Ayzn-qLkLo=h900-rw'
      }],
      steps: [{
        label: 'Registrarte',
        title: 'CREAR CUENTA',
        description: 'Registrate por única vez desde el menú "Crear Cuenta".'
      }, {
        label: 'Ubicación',
        title: 'CONOCE TU UBICACIÓN',
        description: 'En la pantalla inicial se te ubicará dentro de un mapa.'
      }, {
        label: 'Reservar',
        title: 'ESCOGE TU PAVILL',
        description: 'Cuando requieras un taxi, presiona el auto de color rojo ubicado en la parte inferior derecha y llena los campos de acuerdo a tu información.'
      }, {
        label: 'El conductor',
        title: 'SOBRE EL VEHÍCULO Y EL CONDUCTOR',
        description: 'Presiona continuar y espera la confirmación en pantalla, con toda la información del vehículo y conductor.'
      }, {
        label: 'Estado',
        title: 'CONOCE EL ESTADO DE TU PEDIDO',
        description: 'Realiza un seguimiento en tiempo real, a través del mapa.'
      }],
      features: [{
        title: 'Ubicación GPS',
        description: 'Automáticamente la aplicación ubicará tu posición exacta dentro del mapa',
        imageUrl: '/images/feature_1.png'
      }, {
        title: 'Tu propia cuenta',
        description: 'Puedes registrarte gratuitamente para llevar el historial de tus pedidos',
        imageUrl: '/images/feature_2.png'
      }, {
        title: 'Sistema de mapas',
        description: 'Se muestra el mapa con las calles de la ciudad, este mapa está bajo el soporte de Google',
        imageUrl: '/images/feature_3.png'
      }, {
        title: 'Atención las 24hrs.',
        description: 'Nuestra moderna central teléfonica computarizada, te atenderá a cualquier hora del día',
        imageUrl: '/images/feature_4.png'
      }, {
        title: 'Rápido y fácil de usar',
        description: 'Descarga nuestra aplicación y empieza a realizar tus pedidos fácilmente',
        imageUrl: '/images/feature_5.png'
      }, {
        title: 'Consulta estado del pedido',
        description: 'Puedes consultar el nro de placa y conductor asignado a tu pedido de taxi',
        imageUrl: '/images/feature_6.png'
      }]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  methods: {
    next: function next() {
      this.$refs.slick.next();
    },
    prev: function prev() {
      this.$refs.slick.prev();
    }
  }
});

/***/ }),

/***/ "gUXg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Root_vue__ = __webpack_require__("Rp6+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37f36594_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Root_vue__ = __webpack_require__("bS0T");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Root_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37f36594_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Root_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gg5W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showInfo)?_c('div',{staticClass:"u-bg-primary u-flex u-flex-wrap o-container u-pt5"},[_vm._m(0),_c('div',{staticClass:"u-px2 u-2/12@laptop u-4/12@tablet u-mb4 u-12/12",attrs:{"data-aos":"fade-up"}},[_c('p',{staticClass:"u-white u-fw-s-bold u-mt0"},[_vm._v("La Empresa")]),_c('ul',{staticClass:"u-m0 u-pl0 u-list-none u-color-text"},[_c('li',{staticClass:"u-mb2"},[_c('router-link',{staticClass:"u-decoration-none u-color-text",attrs:{"to":{ name: 'Home'},"exact":"exact"}},[_vm._v("Inicio")])],1),_c('li',{staticClass:"u-mb2"},[_c('router-link',{staticClass:"u-decoration-none u-color-text",attrs:{"to":{ name: 'Services'}}},[_vm._v("Servicios")])],1),_c('li',{staticClass:"u-mb2"},[_c('router-link',{staticClass:"u-decoration-none u-color-text",attrs:{"to":{ name: 'About'}}},[_vm._v("Nosotros")])],1),_c('li',{staticClass:"u-mb2"},[_c('router-link',{staticClass:"u-decoration-none u-color-text",attrs:{"to":{ name: 'Posts'}}},[_vm._v("Noticias")])],1),_c('li',{staticClass:"u-mb2"},[_c('router-link',{staticClass:"u-decoration-none u-color-text",attrs:{"to":{ name: 'Contact'}}},[_vm._v("Contáctanos")])],1)])]),_c('div',{staticClass:"u-px2 u-2/12@laptop u-4/12@tablet u-mb4 u-12/12",attrs:{"data-aos":"fade-up"}},[_c('p',{staticClass:"u-white u-fw-s-bold u-mt0"},[_vm._v("Trabaja con nosotros")]),_c('ul',{staticClass:"u-m0 u-pl0 u-list-none u-color-text"},[_c('li',{staticClass:"u-mb2"},[_c('router-link',{staticClass:"u-decoration-none u-color-text",attrs:{"to":{ name: 'Driver'}}},[_vm._v("Conductor Pavill")])],1),_c('li',{staticClass:"u-mb3 u-border-bottom u-pb3 u-border-text"},[_c('router-link',{staticClass:"u-decoration-none u-color-text",attrs:{"to":{ name: 'Operator'}}},[_vm._v("Operadora")])],1),_c('li',{staticClass:"u-mb2"},[_c('router-link',{staticClass:"u-decoration-none u-color-text",attrs:{"to":{ name: 'Complaints'}}},[_c('i',{staticClass:"u-icon u-mr2"},[_vm._v("book")]),_c('span',[_vm._v("Libro de Reclamaciones")])])],1)])]),_c('div',{staticClass:"u-px2 u-3/12@laptop u-4/12@tablet u-mb4 u-12/12",attrs:{"data-aos":"fade-up"}},[_c('p',{staticClass:"u-white u-fw-s-bold u-mt0"},[_vm._v("App")]),_c('ul',{staticClass:"u-m0 u-pl0 u-list-none u-color-text"},[_c('li',{staticClass:"u-mb2"},[_c('router-link',{staticClass:"u-decoration-none u-color-text",attrs:{"to":{ name: 'App'}}},[_vm._v("Descargar APP")])],1),_c('li',{staticClass:"u-mb2"},[_c('router-link',{staticClass:"u-decoration-none u-color-text",attrs:{"to":{ name: 'Terms'}}},[_vm._v("Terminos y condiciones de la APP")])],1)])]),_c('div',{staticClass:"u-px2 u-3/12@laptop u-4/12@tablet u-mb4 u-12/12",attrs:{"data-aos":"fade-up"}},[_c('p',{staticClass:"u-white u-fw-s-bold u-mt0 u-fz-h4"},[_vm._v("Pide un "+_vm._s(_vm.company.name))]),_c('ul',{staticClass:"u-m0 u-pl0 u-list-none u-color-text"},[(_vm.company.phone)?_c('li',{staticClass:"u-mb2 u-fw-s-bold"},[_c('i',{staticClass:"u-icon u-color-secondary u-mr2"},[_vm._v("phone")]),_c('span',[_vm._v(_vm._s(_vm.company.phone))])]):_vm._e(),(_vm.company.cellphone)?_c('li',{staticClass:"u-mb2 u-fw-s-bold"},[_c('i',{staticClass:"u-icon u-color-secondary u-mr2"},[_vm._v("cellphone")]),_c('span',[_vm._v(_vm._s(_vm.company.cellphone))])]):_vm._e(),(_vm.company.email)?_c('li',{staticClass:"u-mb2 u-fw-s-bold"},[_c('i',{staticClass:"u-icon u-color-secondary u-mr2"},[_vm._v("message")]),_c('span',[_vm._v(_vm._s(_vm.company.email))])]):_vm._e()])])]):_vm._e(),_c('footer',{staticClass:"o-container u-bg-primary u-center u-py3 u-fz-h6 u-fw-light u-color-text"},[(_vm.showInfo)?_c('ul',{staticClass:"u-mt0 u-pl0 u-list-none  u-flex u-justify-center u-mb3"},[(_vm.company.facebookPage)?_c('a',{staticClass:"c-btn-share c-btn-share--facebook",attrs:{"target":"_blank","href":_vm.company.facebookPage}},[_c('i',{staticClass:"u-icon"},[_vm._v("facebook")])]):_vm._e(),(_vm.company.linkedinPage)?_c('a',{staticClass:"c-btn-share c-btn-share--linkedin",attrs:{"target":"_blank","href":_vm.company.linkedinPage}},[_c('i',{staticClass:"u-icon"},[_vm._v("linkedin")])]):_vm._e(),(_vm.company.instagramPage)?_c('a',{staticClass:"c-btn-share c-btn-share--instagram",attrs:{"target":"_blank","href":_vm.company.instagramPage}},[_c('i',{staticClass:"u-icon"},[_vm._v("instagram")])]):_vm._e(),(_vm.company.youtubePage)?_c('a',{staticClass:"c-btn-share c-btn-share--google",attrs:{"target":"_blank","href":_vm.company.youtubePage}},[_c('i',{staticClass:"u-icon"},[_vm._v("youtube")])]):_vm._e(),(_vm.company.soundcloudPage)?_c('a',{staticClass:"c-btn-share c-btn-share--soundcloud",attrs:{"target":"_blank","href":_vm.company.soundcloudPage}},[_c('i',{staticClass:"u-icon"},[_vm._v("soundcloud")])]):_vm._e(),(_vm.company.vimeoPage)?_c('a',{staticClass:"c-btn-share c-btn-share--vimeo",attrs:{"target":"_blank","href":_vm.company.vimeoPage}},[_c('i',{staticClass:"u-icon"},[_vm._v("vimeo")])]):_vm._e()]):_vm._e(),_c('span',{staticClass:"u-color-text"},[_vm._v("Copyright © "+_vm._s(_vm.date.getFullYear())+" "+_vm._s(_vm.company.name)+". Todos los derechos reservados. Desarrollado por "),_c('a',{staticClass:"u-color-text u-decoration-none u-fw-s-bold",attrs:{"href":"https://noveltie.la/","target":"_blank"}},[_vm._v("Noveltie")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"u-px2 u-2/12@laptop u-6/12@tablet u-mb4 u-12/12 u-m0",attrs:{"data-aos":"fade-up"}},[_c('img',{staticStyle:{"max-height":"50px"},attrs:{"src":"/images/logo_white.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "goRD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"time-picker"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayTime),expression:"displayTime"}],staticClass:"display-time",attrs:{"id":_vm.id,"type":"text","readonly":""},domProps:{"value":(_vm.displayTime)},on:{"click":function($event){$event.stopPropagation();return _vm.toggleDropdown($event)},"input":function($event){if($event.target.composing){ return; }_vm.displayTime=$event.target.value}}}),_vm._v(" "),(!_vm.hideClearButton)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showDropdown && _vm.showClearBtn),expression:"!showDropdown && showClearBtn"}],staticClass:"clear-btn",on:{"click":function($event){$event.stopPropagation();return _vm.clearTime($event)}}},[_vm._v("×")]):_vm._e(),_vm._v(" "),(_vm.showDropdown)?_c('div',{staticClass:"time-picker-overlay",on:{"click":function($event){$event.stopPropagation();return _vm.toggleDropdown($event)}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropdown),expression:"showDropdown"}],staticClass:"dropdown"},[_c('div',{staticClass:"select-list"},[_c('ul',{staticClass:"hours"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.hourType)}}),_vm._v(" "),_vm._l((_vm.hours),function(hr){return _c('li',{class:{active: _vm.hour === hr},domProps:{"textContent":_vm._s(hr)},on:{"click":function($event){$event.stopPropagation();_vm.select('hour', hr)}}})})],2),_vm._v(" "),_c('ul',{staticClass:"minutes"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.minuteType)}}),_vm._v(" "),_vm._l((_vm.minutes),function(m){return _c('li',{class:{active: _vm.minute === m},domProps:{"textContent":_vm._s(m)},on:{"click":function($event){$event.stopPropagation();_vm.select('minute', m)}}})})],2),_vm._v(" "),(_vm.secondType)?_c('ul',{staticClass:"seconds"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.secondType)}}),_vm._v(" "),_vm._l((_vm.seconds),function(s){return _c('li',{class:{active: _vm.second === s},domProps:{"textContent":_vm._s(s)},on:{"click":function($event){$event.stopPropagation();_vm.select('second', s)}}})})],2):_vm._e(),_vm._v(" "),(_vm.apmType)?_c('ul',{staticClass:"apms"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.apmType)}}),_vm._v(" "),_vm._l((_vm.apms),function(a){return _c('li',{class:{active: _vm.apm === a},domProps:{"textContent":_vm._s(a)},on:{"click":function($event){$event.stopPropagation();_vm.select('apm', a)}}})})],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hytZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__ = __webpack_require__("NRQ5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c22544_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__("gg5W");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c22544_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i/iG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),

/***/ "iFJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConstructionScreen_vue__ = __webpack_require__("ehw1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d484f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ConstructionScreen_vue__ = __webpack_require__("yfZo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConstructionScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d484f7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ConstructionScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iL/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-pulse v-pulse1",style:([_vm.spinnerStyle,_vm.spinnerDelay1])}),_c('div',{staticClass:"v-pulse v-pulse2",style:([_vm.spinnerStyle,_vm.spinnerDelay2])}),_c('div',{staticClass:"v-pulse v-pulse3",style:([_vm.spinnerStyle,_vm.spinnerDelay3])})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jBYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HomeScreen__ = __webpack_require__("SDej");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_0__components_HomeScreen__["a" /* default */]
});

/***/ }),

/***/ "jYep":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slickCarousel_vue__ = __webpack_require__("1f4k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_48eb5f11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slickCarousel_vue__ = __webpack_require__("DNYT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slickCarousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_48eb5f11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_slickCarousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k8bv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__("Z1Ew");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7123ec72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__("W6ZF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7123ec72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kQde":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ModalExpress__ = __webpack_require__("9uhu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ModalDelivery__ = __webpack_require__("XVQg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ModalRadioTaxi__ = __webpack_require__("/XiT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_ModalTourism__ = __webpack_require__("/PsR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ModalWomanTaxi__ = __webpack_require__("nbec");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ServicesScreen',
  components: {
    ModalExpress: __WEBPACK_IMPORTED_MODULE_3_components_ModalExpress__["a" /* default */],
    ModalWomanTaxi: __WEBPACK_IMPORTED_MODULE_7_components_ModalWomanTaxi__["a" /* default */],
    ModalDelivery: __WEBPACK_IMPORTED_MODULE_4_components_ModalDelivery__["a" /* default */],
    ModalTourism: __WEBPACK_IMPORTED_MODULE_6_components_ModalTourism__["a" /* default */],
    ModalRadioTaxi: __WEBPACK_IMPORTED_MODULE_5_components_ModalRadioTaxi__["a" /* default */]
  },
  data: function data() {
    return {
      index: null,
      isShowModalConfirm: false,
      isShowModalError: false,
      isShowModalDelivery: false,
      isShowModalExpress: false,
      isShowModalRadioTaxi: false,
      isShowModalTourism: false,
      isShowModalWomanTaxi: false,
      selectedService: 0,
      services: [],
      options: {
        inline: false,
        button: true,
        navbar: true,
        title: false,
        toobar: false,
        tooltip: false,
        movable: false,
        zoomable: false,
        rotatable: false,
        scalable: false,
        transition: true,
        fullscreen: false,
        keyboard: true,
        url: 'data-source'
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  methods: {
    showGallery: function showGallery(gallery) {
      var viewer = this.$el.querySelector('#' + gallery).$viewer;
      viewer.show();
    },
    getServices: function getServices() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/services').then(function (_ref) {
        var data = _ref.data;

        _this.services = data.data;

        setTimeout(function () {
          var array = _this.services.map(function (a) {
            return a.slug;
          });

          window.$('#fullpage').fullpage({
            anchors: array,
            // scrollBar: true,
            menu: '#menu'
          });
        }, 10);
      });
    },
    showModalService: function showModalService(id) {
      this.selectedService = id;
      switch (id) {
        case 1:
          this.isShowModalWomanTaxi = true;
          break;
        case 2:
          this.isShowModalExpress = true;
          break;
        case 3:
          this.isShowModalTourism = true;
          break;
        case 4:
          this.isShowModalRadioTaxi = true;
          break;
        case 5:
          this.isShowModalDelivery = true;
          break;
        default:
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    /* eslint-disable */
    $.fn.fullpage.destroy('all');
    /* eslint-enable */
  },
  created: function created() {
    this.getServices();
  }
});

/***/ }),

/***/ "kpCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactScreen_vue__ = __webpack_require__("SRNr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1a9304_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ContactScreen_vue__ = __webpack_require__("5l3V");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1a9304_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ContactScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l4P7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "beginAjaxCall", function() { return beginAjaxCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ajaxCallSuccess", function() { return ajaxCallSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ajaxCallError", function() { return ajaxCallError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__("+0zs");


var beginAjaxCall = function beginAjaxCall(_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch,
      state = _ref.state,
      rootState = _ref.rootState;

  commit(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* BEGIN_AJAX_CALL */]);
};

var ajaxCallSuccess = function ajaxCallSuccess(_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* AJAX_CALL_SUCCESS */]);
};

var ajaxCallError = function ajaxCallError(_ref3) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* AJAX_CALL_ERROR */]);
};

/***/ }),

/***/ "lOtX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectValidate_vue__ = __webpack_require__("ZQTd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30bc0420_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SelectValidate_vue__ = __webpack_require__("qf9j");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectValidate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30bc0420_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SelectValidate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lkgy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    url: {
      required: true
    }
  },

  computed: {
    currentVideoUrl: function currentVideoUrl() {
      return 'https://www.youtube.com/embed/' + this.url + '?rel=0&amp;showinfo=0;autoplay=1';
    }
  },

  beforeCreate: function beforeCreate() {
    window.$('body').css('overflow-y', 'hidden');
  },
  beforeDestroy: function beforeDestroy() {
    window.$('body').css('overflow-y', '');
  }
});

/***/ }),

/***/ "lxni":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m1aC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_validatorjs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReserveScreen',
  data: function data() {
    return {
      isShowModalConfirm: false,
      isShowModalError: false,
      toggleValidate: false,
      clearForm: false,
      formValidate: false,
      isLoading: false,
      form: {
        firstname: '',
        lastname: '',
        email: '',
        whatsapp: '',
        origin: '',
        countryId: 0,
        transportId: 1,
        airlineCompany: 0,
        flightNumber: '',
        busCompany: 0,
        checkinHour: '',
        invoice: false
      },
      rules: {
        firstname: 'required|name',
        lastname: 'required|name',
        email: 'required|email',
        whatsapp: 'required|phone',
        origin: 'required',
        countryId: 'min:1',
        airlineCompany: 'min:1',
        flightNumber: 'required',
        busCompany: 'min:0',
        checkinHour: 'required'
      },
      countries: [{
        id: 1,
        name: 'Perú'
      }, {
        id: 2,
        name: 'Chile'
      }],
      airplanes: [],
      buses: [],
      attractions: [],
      swiperGallery: {
        slidesPerView: 1,
        autoplay: 5000,
        prevButton: '#gallery-prev',
        nextButton: '#gallery-next'
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  methods: {
    postForm: function postForm() {
      var _this = this;

      this.validate();

      if (this.formValidate && !this.isLoading) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://radiotaxipavill.ddns.net:8015/enlacepavill/RegistrarReserva.php', this.form);
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(window.API_URL + '/reservation', this.form).then(function (response) {
          _this.isShowModalConfirm = true;
          _this.isLoading = false;
          _this.form = {
            firstname: '',
            lastname: '',
            email: '',
            whatsapp: '',
            origin: '',
            countryId: 0,
            transportId: 1,
            airlineCompany: 0,
            flightNumber: '',
            busCompany: 0,
            checkinHour: '',
            invoice: false
          };
          _this.clearForm = true;
        }).catch(function (_ref) {
          var response = _ref.response;

          _this.isLoading = false;
          _this.isShowModalError = true;
        });
      }
    },
    validate: function validate() {
      var validation = new __WEBPACK_IMPORTED_MODULE_3_validatorjs___default.a(this.form, this.rules);
      validation.passes();
      this.formValidate = validation.passes();
      this.toggleValidate = !this.toggleValidate;
      console.log(validation);
    },
    getAttractions: function getAttractions() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/attractions').then(function (_ref2) {
        var data = _ref2.data;

        _this2.attractions = data.data;
      });
    },
    getAirplanes: function getAirplanes() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/airplanes').then(function (_ref3) {
        var data = _ref3.data;

        _this3.airplanes = data.data;
      });
    },
    getBuses: function getBuses() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(window.API_URL + '/buses').then(function (_ref4) {
        var data = _ref4.data;

        _this4.buses = data.data;
      });
    }
  },

  created: function created() {
    this.getAttractions();
    this.getAirplanes();
    this.getBuses();
  },


  watch: {
    'form.transportId': function formTransportId(val) {
      if (val === 2) {
        this.rules.busCompany = 'min:1';

        this.rules.airlineCompany = 'min:0';
        this.form.airlineCompany = 0;

        this.rules.flightNumber = '';
        this.form.flightNumber = '';
      } else {
        this.rules.busCompany = 'min:0';
        this.form.busCompany = 0;

        this.rules.airlineCompany = 'min:1';
        this.rules.flightNumber = 'required';
      }
    }
  }
});

/***/ }),

/***/ "msQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_c('section',{staticClass:"u-bg-primary"},[_c('div',{staticClass:"u-flex o-wrapper u-py5 u-flex-wrap u-items-start"},[_c('div',{staticClass:"u-white u-7/12@laptop u-6/12@tablet u-12/12",attrs:{"data-aos":"fade-right"}},[_c('div',{staticClass:"u-8/12@laptop u-10/12@tablet u-mx-auto u-px2"},[_c('h2',{staticClass:"u-fz-h0 u-line-1 u-mb3 u-mt4 u-mt0"},[_c('span',{staticClass:"u-color-secondary u-block"},[_vm._v("Conduce")]),_c('span',{staticClass:"u-white u-block"},[_vm._v("con "+_vm._s(_vm.company.name))])]),_c('p',{staticClass:"u-color-text u-mb0 u-mt0 u-fz-h4"},[_vm._v("Únete como conductor o afilia tu auto.")]),_c('p',{staticClass:"u-color-text u-mb4 u-mt0 u-fz-h4"},[_vm._v("Disfruta de las ventas de "+_vm._s(_vm.company.name))]),_vm._m(0)])]),_c('div',{staticClass:"u-white u-5/12@laptop u-6/12@tablet u-12/12 u-flex-wrap u-flex",attrs:{"data-aos":"fade-left"}},[_c('div',{staticClass:"u-flex u-flex-wrap u-px2 u-items-center u-mb2"},[_c('div',{staticClass:"c-input u-flex u-items-center u-mr3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.hasVehicle),expression:"form.hasVehicle"}],staticClass:"u-mr3",attrs:{"id":"a1","type":"radio","name":"a"},domProps:{"value":true,"checked":_vm._q(_vm.form.hasVehicle,true)},on:{"change":function($event){_vm.$set(_vm.form, "hasVehicle", true)}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"a1"}},[_vm._v("Tengo vehículo")])]),_c('div',{staticClass:"c-input u-flex u-items-center u-mr3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.hasVehicle),expression:"form.hasVehicle"}],attrs:{"id":"a2","type":"radio","name":"a"},domProps:{"value":false,"checked":_vm._q(_vm.form.hasVehicle,false)},on:{"change":function($event){_vm.$set(_vm.form, "hasVehicle", false)}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"a2"}},[_vm._v("No tengo vehículo")])])]),_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.firstname,"icon":"user","placeholder":"Nombres","validation":_vm.toggleValidate,"clear":_vm.clearForm,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.firstname),callback:function ($$v) {_vm.$set(_vm.form, "firstname", $$v)},expression:"form.firstname"}}),_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.lastname,"placeholder":"Apellidos","validation":_vm.toggleValidate,"clear":_vm.clearForm,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.lastname),callback:function ($$v) {_vm.$set(_vm.form, "lastname", $$v)},expression:"form.lastname"}}),_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.dni,"icon":"message","placeholder":"DNI","validation":_vm.toggleValidate,"clear":_vm.clearForm,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.dni),callback:function ($$v) {_vm.$set(_vm.form, "dni", $$v)},expression:"form.dni"}}),_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.cellphone,"icon":"cellphone","placeholder":"Celular o teléfono","validation":_vm.toggleValidate,"clear":_vm.clearForm,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.cellphone),callback:function ($$v) {_vm.$set(_vm.form, "cellphone", $$v)},expression:"form.cellphone"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-px2",attrs:{"rule":_vm.rules.driverLicense,"icon":"driver_license","placeholder":"Licencia de conductor","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align","clear":_vm.clearForm},model:{value:(_vm.form.driverLicense),callback:function ($$v) {_vm.$set(_vm.form, "driverLicense", $$v)},expression:"form.driverLicense"}}),(_vm.form.hasVehicle)?_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.vehiclePlate,"placeholder":"Placa de vehículo","validation":_vm.toggleValidate,"clear":_vm.clearForm,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.vehiclePlate),callback:function ($$v) {_vm.$set(_vm.form, "vehiclePlate", $$v)},expression:"form.vehiclePlate"}}):_vm._e(),(_vm.form.hasVehicle)?_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.year,"placeholder":"Año","validation":_vm.toggleValidate,"mask":"####","clear":_vm.clearForm,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.year),callback:function ($$v) {_vm.$set(_vm.form, "year", $$v)},expression:"form.year"}}):_vm._e(),(_vm.form.hasVehicle)?_c('div',{staticClass:"u-flex u-flex-wrap u-px2 u-items-center u-mb2"},[_c('label',{staticClass:"u-block u-mb2 u-mr3 u-color-text"},[_vm._v("¿Cuentas con la herramienta de radio base?")]),_c('div',{staticClass:"c-input u-flex u-items-center u-mr3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.baseRadio),expression:"form.baseRadio"}],staticClass:"u-mr2",attrs:{"id":"x1","type":"radio","name":"x"},domProps:{"value":true,"checked":_vm._q(_vm.form.baseRadio,true)},on:{"change":function($event){_vm.$set(_vm.form, "baseRadio", true)}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"x1"}},[_vm._v("Si")])]),_c('div',{staticClass:"c-input u-flex u-items-center u-mr3 u-mb2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.baseRadio),expression:"form.baseRadio"}],staticClass:"u-mr2",attrs:{"id":"x2","type":"radio","name":"x"},domProps:{"value":false,"checked":_vm._q(_vm.form.baseRadio,false)},on:{"change":function($event){_vm.$set(_vm.form, "baseRadio", false)}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"x2"}},[_vm._v("No")])])]):_vm._e(),(_vm.form.baseRadio)?_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.model,"placeholder":"Modelo","validation":_vm.toggleValidate,"clear":_vm.clearForm,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.model),callback:function ($$v) {_vm.$set(_vm.form, "model", $$v)},expression:"form.model"}}):_vm._e(),(_vm.form.baseRadio)?_c('input-validate',{staticClass:"u-mb3 u-6/12@tablet u-12/12 u-px2",attrs:{"rule":_vm.rules.chanels,"placeholder":"Canales","validation":_vm.toggleValidate,"clear":_vm.clearForm,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.chanels),callback:function ($$v) {_vm.$set(_vm.form, "chanels", $$v)},expression:"form.chanels"}}):_vm._e(),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-px2",attrs:{"rule":_vm.rules.professionaldriveExperience,"placeholder":"Cuéntanos tu experiencia como conductor profesional","validation":_vm.toggleValidate,"type":"textarea","wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align","clear":_vm.clearForm},model:{value:(_vm.form.professionaldriveExperience),callback:function ($$v) {_vm.$set(_vm.form, "professionaldriveExperience", $$v)},expression:"form.professionaldriveExperience"}}),_c('input-validate',{staticClass:"u-mb3 u-12/12 u-px2",attrs:{"rule":_vm.rules.whyWork,"placeholder":"¿Por qué deseas trabajar con nosotros?","validation":_vm.toggleValidate,"clear":_vm.clearForm,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.whyWork),callback:function ($$v) {_vm.$set(_vm.form, "whyWork", $$v)},expression:"form.whyWork"}}),_c('div',{staticClass:"u-px2 u-12/12"},[_c('button',{staticClass:"c-btn--primary u-12/12 u-fw-s-bold u-fz-h4 u-mt2",on:{"click":_vm.postForm}},[_vm._v("Registrarse")])])],1)])]),(_vm.company.parnerts && _vm.company.parnerts.length > 0)?_c('section',{staticClass:"u-pt5 o-wrapper"},[_vm._m(1),_c('p',{staticClass:"o-container o-wrapper u-center u-mb4",attrs:{"data-aos":"fade-up"}},[_vm._v("Convenios con empresas privadas y públicas con ubicaciones en paraderos estratégicos en toda la ciudad, trabajamos con la cadena de mercados del Perú Plaza Vea.")]),_c('ul',{staticClass:"u-flex u-flex-wrap u-pl0 u-list-none u-mb0 u-justify-center"},_vm._l((_vm.company.parnerts),function(parnert,index){return _c('li',{staticClass:"u-px4 u-mb3",class:{'u-12/12 u-center u-mb4' : index === 0},attrs:{"data-aos":"fade-up"}},[_c('a',{staticClass:"u-m0 u-block",staticStyle:{"height":"60px"},attrs:{"href":parnert.link,"target":"_blank"}},[_c('img',{staticStyle:{"max-height":"100%"},attrs:{"src":parnert.imageUrl,"title":parnert.title}})])])}))]):_vm._e(),(_vm.whereabouts.length > 0)?_c('section',{staticClass:"u-pt5 o-wrapper"},[_vm._m(2),_c('ul',{staticClass:"u-mt0 u-pt3 u-flex u-flex-wrap u-list-none u-mb0 u-pl0 u-justify-center"},_vm._l((_vm.whereabouts),function(whereabout){return _c('li',{staticClass:"u-px3 u-mb4 u-4/12@tablet u-12/12 u-px3",attrs:{"data-aos":"fade-up"}},[_c('figure',{staticClass:"u-mb0 u-mt0 u-mx2 u-br16 u-overflow-hidden"},[_c('img',{attrs:{"src":whereabout.imageUrl}})]),_c('p',{staticClass:"u-mb2 u-px2 u-center u-color-tertiary u-fz-h4 u-fw-light"},[_vm._v(_vm._s(whereabout.name))]),_c('p',{staticClass:"u-px2 u-mt0 u-mb3 u-center u-color-dark"},[_vm._v(_vm._s(whereabout.address))])])}))]):_vm._e(),_c('section',{staticClass:"o-wrapper u-center u-pt5"},[_c('h3',{staticClass:"u-color-primary u-fz-h3 u-mt0 u-mb3",attrs:{"data-aos":"fade-up"}},[_vm._v("¿Te interesa?")]),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#root'),expression:"'#root'"}],staticClass:"c-btn--primary u-px5 u-fw-bold u-inline-flex u-items-center",attrs:{"data-aos":"fade-up","href":"#"}},[_vm._v("Empieza hoy")])]),_c('app-footer',{staticClass:"u-mt5"}),(_vm.isLoading)?_c('loading',{attrs:{"message":"Enviando"}}):_vm._e(),(_vm.isShowModalConfirm)?_c('modal-confirm',{attrs:{"message":"Nos pondremos en contacto con usted."},on:{"hide":function($event){_vm.isShowModalConfirm = false}}}):_vm._e(),(_vm.isShowModalError)?_c('modal-error',{on:{"hide":function($event){_vm.isShowModalError = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"u-m0 u-show@laptop"},[_c('img',{attrs:{"src":"/images/car_pavill.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-mt0 u-mb3 u-fz-h1 u-center u-line-1",attrs:{"data-aos":"fade-up"}},[_c('span',{staticClass:"u-color-secondary u-inline-block"},[_vm._v("Convenios ")]),_c('span',{staticClass:"u-inline-block u-fw-light"},[_vm._v("que te benefician")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-mt0 u-mb4 u-fz-h1 u-center u-line-1",attrs:{"data-aos":"fade-up"}},[_c('span',{staticClass:"u-color-secondary u-inline-block"},[_vm._v("Paraderos ")]),_c('span',{staticClass:"u-inline-block u-fw-light"},[_vm._v("estratégicos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n+5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputQuantity_vue__ = __webpack_require__("WLtR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c6c2109_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InputQuantity_vue__ = __webpack_require__("DfAW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputQuantity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c6c2109_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_InputQuantity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nbec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalWomanTaxi_vue__ = __webpack_require__("+tAw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5dd40c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalWomanTaxi_vue__ = __webpack_require__("o334");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalWomanTaxi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5dd40c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalWomanTaxi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nbpO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"width":"500px","modal-class":"u-bg-primary u-p3"},on:{"hide":function($event){_vm.$emit('hide')}}},[_c('div',{staticClass:"u-px4",attrs:{"slot":"content"},slot:"content"},[_c('h3',{staticClass:"u-fz-h2 u-mt0 u-center u-line-1 u-mb4"},[_c('span',{staticClass:"u-white"},[_vm._v("Reserva un Pavill para ")]),_c('span',{staticClass:"u-color-secondary"},[_vm._v("Turismo")])]),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.fullname,"name":"fullname","icon":"user","placeholder":"Nombres y apellidos","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.fullname),callback:function ($$v) {_vm.$set(_vm.form, "fullname", $$v)},expression:"form.fullname"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.whatsapp,"icon":"whatsapp","name":"whatsapp","placeholder":"Whatsapp","validation":_vm.toggleValidate,"type":"tel","wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.whatsapp),callback:function ($$v) {_vm.$set(_vm.form, "whatsapp", $$v)},expression:"form.whatsapp"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.origin,"name":"origin","icon":"location","placeholder":"Estoy en","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.origin),callback:function ($$v) {_vm.$set(_vm.form, "origin", $$v)},expression:"form.origin"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.destiny,"name":"destiny","icon":"transport","placeholder":"Quiero viajar a","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.destiny),callback:function ($$v) {_vm.$set(_vm.form, "destiny", $$v)},expression:"form.destiny"}}),_c('div',[_c('label',{staticClass:"u-color-text u-mb1 u-block"},[_vm._v("Fecha y hora de viaje")]),_c('input-validate',{staticClass:"u-mb3",attrs:{"type":"textarea","rule":_vm.rules.travelDate,"name":"destiny","placeholder":"Indique la fecha y hora ejem. 01 de Enero a las 3:00P.M.","validation":_vm.toggleValidate,"wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.travelDate),callback:function ($$v) {_vm.$set(_vm.form, "travelDate", $$v)},expression:"form.travelDate"}})],1),_c('div',{staticClass:"u-flex u-flex-wrap"},[_c('div',{staticClass:"c-input u-flex u-items-center u-mr3 u-mb3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.roundTrip),expression:"form.roundTrip"}],staticClass:"u-mr2",attrs:{"id":"x1","type":"radio","name":"roundTrip"},domProps:{"value":false,"checked":_vm._q(_vm.form.roundTrip,false)},on:{"change":function($event){_vm.$set(_vm.form, "roundTrip", false)}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"x1"}},[_vm._v("Solo ida")])]),_c('div',{staticClass:"c-input u-flex u-items-center u-mb3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.roundTrip),expression:"form.roundTrip"}],staticClass:"u-mr2",attrs:{"id":"x2","type":"radio","name":"roundTrip"},domProps:{"value":true,"checked":_vm._q(_vm.form.roundTrip,true)},on:{"change":function($event){_vm.$set(_vm.form, "roundTrip", true)}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"x2"}},[_vm._v("Ida y recojo")])])]),(_vm.form.roundTrip)?_c('input-validate',{staticClass:"u-7/12@laptop u-8/12@tablet u-mb3",attrs:{"icon":"clock","placeholder":"¿Cuántas días?","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align","type":"number","min":"1"},model:{value:(_vm.form.days),callback:function ($$v) {_vm.$set(_vm.form, "days", $$v)},expression:"form.days"}}):_vm._e(),_c('button',{staticClass:"c-btn--primary u-12/12 u-fw-s-bold u-mb3 u-fz-h4 u-mt2",on:{"click":_vm.postForm}},[_vm._v("Realizar Reserva")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ngMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{staticClass:"u-bg-primary",attrs:{"white":true}}),_vm._m(0),_c('div',{staticClass:"u-bg-border"},[_c('div',{staticClass:"o-wrapper u-pt5 u-flex",attrs:{"id":"posts-container"}},[_c('section',{staticClass:"u-mb4 u-flex-1"},[_vm._l((_vm.posts),function(post){return _c('article',{staticClass:"c-post u-mb4",attrs:{"data-aos":"fade-up"}},[_c('progressive-background',{staticClass:"c-post__image",attrs:{"src":post.imageUrl,"placeholder":post.imageThumbUrl}}),_c('div',{staticClass:"u-p4"},[_c('router-link',{staticClass:"c-post__title u-fz-h3",attrs:{"to":{ name: 'Post', params:{slug: post.slug}}}},[_vm._v(_vm._s(post.title))]),_c('div',{domProps:{"innerHTML":_vm._s(post.content)}}),_c('p',[_c('router-link',{staticClass:"u-color-secondary",attrs:{"to":{ name: 'Post', params:{slug: post.slug}}}},[_vm._v("Leer más...")])],1),_c('p',{staticClass:"u-mb0 u-right-align u-capitalize u-color-dark u-fw-s-bold"},[_vm._v(_vm._s(post.date))])],1)],1)}),(_vm.posts.length > 0 && _vm.totalPages != 1)?_c('nav',{staticClass:"u-flex u-justify-between u-items-center"},[_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#posts-container'),expression:"'#posts-container'"}],staticClass:"c-btn c-btn--tertiary u-p2 u-fz-h4",attrs:{"disabled":_vm.currentPage === 1},on:{"click":_vm.prevPosts}},[_c('i',{staticClass:"u-icon"},[_vm._v("arrow_left")])]),(_vm.totalPages > 0)?_c('ul',{staticClass:"u-flex u-mt0 u-mb0 u-px2 u-flex-wrap"},_vm._l((_vm.totalPages),function(number){return _c('li',{staticClass:"u-px1"},[_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#posts-container'),expression:"'#posts-container'"}],staticClass:"u-fw-s-bold u-px1",class:{'u-color-primary' : _vm.currentPage === number},on:{"click":function($event){_vm.changePage(number)}}},[_vm._v(" "+_vm._s(number))])])})):_vm._e(),_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#posts-container'),expression:"'#posts-container'"}],staticClass:"c-btn c-btn--tertiary u-p2 u-fz-h4",attrs:{"disabled":_vm.totalPages === _vm.currentPage},on:{"click":_vm.nextPosts}},[_c('i',{staticClass:"u-icon"},[_vm._v("arrow_right")])])]):_vm._e()],2),_c('aside',{staticClass:"u-mb5 u-ml5 u-show@tablet"},[_c('p',{staticClass:"u-uppercase u-color-dark u-fw-s-bold",attrs:{"data-aos":"fade-up"}},[_vm._v("Síguenos")]),_c('ul',{staticClass:"u-m0 u-px4 u-py3 u-list-none u-bg-white u-mb4",attrs:{"data-aos":"fade-up"}},[_c('li',[_c('a',{staticClass:"u-flex  u-items-center u-decoration-none",attrs:{"href":_vm.company.facebookPage,"target":"_blank"}},[_vm._m(1),_c('span',[_vm._v(_vm._s(_vm.company.name))])])])]),_c('iframe',{staticClass:"u-mx-auto u-block u-facebook",staticStyle:{"border":"none","overflow":"hidden"},attrs:{"data-aos":"fade-up","src":_vm.faceWeb,"width":"320","height":"400","scrolling":"no","frameborder":"0","allowTransparency":"true"}})])])]),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-bg-white o-container u-py4"},[_c('h2',{staticClass:"u-center u-fz-h1 u-line-1 u-my3"},[_c('span',{staticClass:"u-fw-light"},[_vm._v("Entérate sobre ")]),_c('strong',{staticClass:"u-color-secondary"},[_vm._v("nuestras actividades")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c-btn-share c-btn-share--facebook"},[_c('i',{staticClass:"u-icon"},[_vm._v("facebook")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nqDH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = localStoragePlugin;
// import * as types from './modules/cart/types'
// import {WEB_CART_KEY} from './constants'

function localStoragePlugin(store) {
  store.subscribe(function (_ref) {
    var type = _ref.type;

    switch (type) {
      // case types.ADD_TO_WEB_CART:
      // case types.REMOVE_FROM_WEB_CART:
      // case types.UPDATE_QUANTITY_FROM_WEB_CART:
      // case types.CHECKOUT_WEB_CART: {
      //   window.localStorage.setItem(WEB_CART_KEY, JSON.stringify(webCart))
      //   break
      // }
      default:
        {
          //
        }
    }
  });
}

/***/ }),

/***/ "nvOJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label)?_c('label',{staticClass:"u-mb1 u-block",class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{class:_vm.wrapperClass},[_c('input',{ref:"input",class:{inputClass: _vm.inputClass, 'u-border-warning' : _vm.message},attrs:{"type":"file","name":_vm.name,"accept":_vm.accept},on:{"change":_vm.updateImage}}),_c('label',{class:[{'u-border-warning' : _vm.message}, {'placeholder' : _vm.title === _vm.placeholder}]},[_vm._v(_vm._s(_vm.title)+" ")]),(_vm.icon)?_c('i',{staticClass:"u-icon"},[_vm._v(_vm._s(_vm.icon))]):_vm._e()]),(_vm.info)?_c('p',{staticClass:"u-color-text u-fz-h6 u-mt1 u-mb0",staticStyle:{"font-size":"12px","user-select":"none"},domProps:{"innerHTML":_vm._s(_vm.info)}}):_vm._e(),(_vm.message)?_c('span',{staticClass:"u-fz-h6 u-pt1 u-pl1 u-block",class:_vm.errorClass},[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o334":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"width":"500px","modal-class":"u-bg-primary u-p3"},on:{"hide":function($event){_vm.$emit('hide')}}},[_c('div',{staticClass:"u-px4",attrs:{"slot":"content"},slot:"content"},[_c('h3',{staticClass:"u-fz-h2 u-mt0 u-center u-line-1 u-mb4"},[_c('span',{staticClass:"u-white"},[_vm._v("Reserva un Pavill para ")]),_c('span',{staticClass:"u-color-secondary"},[_vm._v("Mujer Taxi")])]),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.fullname,"name":"fullname","icon":"user","placeholder":"Nombres y apellidos","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.fullname),callback:function ($$v) {_vm.$set(_vm.form, "fullname", $$v)},expression:"form.fullname"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.whatsapp,"name":"whatsapp","icon":"whatsapp","placeholder":"Whatsapp","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.whatsapp),callback:function ($$v) {_vm.$set(_vm.form, "whatsapp", $$v)},expression:"form.whatsapp"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.descriptionService,"placeholder":"¿Desea especificar algún detalle del servicio?","validation":_vm.toggleValidate,"type":"textarea","wrapper-class":"c-input","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.descriptionService),callback:function ($$v) {_vm.$set(_vm.form, "descriptionService", $$v)},expression:"form.descriptionService"}}),_c('div',{staticClass:"u-flex u-flex-wrap"},[_c('div',{staticClass:"c-input u-flex u-items-center u-mr3 u-mb3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.specificTime),expression:"form.specificTime"}],staticClass:"u-mr2",attrs:{"id":"specificTime","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.specificTime)?_vm._i(_vm.form.specificTime,null)>-1:(_vm.form.specificTime)},on:{"change":function($event){var $$a=_vm.form.specificTime,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "specificTime", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "specificTime", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "specificTime", $$c)}}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"specificTime"}},[_vm._v("Especificar tiempo del servicio")])]),_c('div',{staticClass:"c-input u-flex u-items-center u-mb3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.roundTrip),expression:"form.roundTrip"}],staticClass:"u-mr2",attrs:{"id":"roundTrip","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.roundTrip)?_vm._i(_vm.form.roundTrip,null)>-1:(_vm.form.roundTrip)},on:{"change":function($event){var $$a=_vm.form.roundTrip,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "roundTrip", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "roundTrip", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "roundTrip", $$c)}}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"roundTrip"}},[_vm._v("Ida y recojo")])])]),(_vm.form.specificTime)?_c('input-validate',{staticClass:"u-7/12@laptop u-8/12@tablet u-mb3",attrs:{"rule":_vm.rules.hours,"icon":"clock","placeholder":"¿Cuántas horas?","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align","type":"number","min":"1"},model:{value:(_vm.form.hours),callback:function ($$v) {_vm.$set(_vm.form, "hours", $$v)},expression:"form.hours"}}):_vm._e(),_c('button',{staticClass:"c-btn--primary u-12/12 u-fw-s-bold u-mb3 u-fz-h4 u-mt2",on:{"click":_vm.postForm}},[_vm._v("Realizar Reserva")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oDt+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-sync v-sync1",style:([_vm.spinnerStyle,_vm.spinnerDelay1])}),_c('div',{staticClass:"v-sync v-sync2",style:([_vm.spinnerStyle,_vm.spinnerDelay2])}),_c('div',{staticClass:"v-sync v-sync3",style:([_vm.spinnerStyle,_vm.spinnerDelay3])})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "obcv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validatorjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      toggleValidate: false,
      formValidate: false,
      isLoading: false,
      form: {
        fullname: '',
        whatsapp: '',
        origin: '',
        destiny: '',
        roundTrip: true,
        travelDate: '',
        days: null
      },
      rules: {
        fullname: 'required|name',
        whatsapp: 'required|phone',
        origin: 'required',
        destiny: 'required',
        travelDate: 'required',
        days: 'required|min:1'
      }
    };
  },


  methods: {
    postForm: function postForm() {
      var _this = this;

      this.validate();

      if (this.formValidate && !this.isLoading) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://radiotaxipavill.ddns.net:8015/enlacepavill/RegistrarPedidoTurismo.php', this.form);
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(window.API_URL + '/tourism', this.form).then(function (response) {
          _this.isLoading = false;
          _this.$emit('hide');
          _this.$emit('success');
        }).catch(function (_ref) {
          var response = _ref.response;

          _this.isLoading = false;
          _this.$emit('hide');
          _this.$emit('error');
        });
      }
    },
    validate: function validate() {
      var validation = new __WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a(this.form, this.rules);
      validation.passes();
      this.toggleValidate = !this.toggleValidate;
      this.formValidate = validation.passes();
    }
  },

  watch: {
    'form.roundTrip': function formRoundTrip(val) {
      if (val) {
        this.rules.days = 'required|min:1';
      } else {
        this.rules.days = '';
        this.form.days = null;
      }
    }
  }
});

/***/ }),

/***/ "obte":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerFilters;
function registerFilters(Vue) {
  // Filtro de texto -> length = máximo de caracteres
  Vue.filter('truncate', function (value, length) {
    if (value.length < length) {
      return value;
    }

    length = length - 3;
    return value.substring(0, length) + '...';
  });

  // Filtro de hora -> 02:00:00 to 02:00am | 16:00:00 to 04:00pm
  Vue.filter('hour', function (value) {
    if (value) {
      var time = value.split(':');
      var hour = void 0;
      var hourName = void 0;

      if (parseInt(time[0], 10) > 12) {
        hour = parseInt(time[0], 10) % 12;
        hourName = 'pm';
      } else {
        hour = parseInt(time[0], 10);
        hourName = 'am';
      }
      hour = hour < 10 ? '0' + hour : hour;
      return hour + ':' + time[1] + hourName;
    } else {
      return value;
    }
  });

  // Filtro de fecha -> 2016-01-01 to 01/01/2016
  Vue.filter('reverseDate', function (value) {
    if (value) {
      return value.split('-').reverse().join('/');
    } else {
      return value;
    }
  });

  // Filtro de fecha -> Dia(01) | Mes(ene) | Año(2016) | Fecha Completa(01 de Enero del 2016)
  Vue.filter('date', function (value, datetype) {
    if (value) {
      var date = value.split('-').reverse();
      var monthNumber = parseInt(date[1], 10);
      var monthName = void 0;
      var monthNameFull = void 0;
      switch (monthNumber) {
        case 1:
          monthName = 'ene';
          monthNameFull = 'Enero';
          break;
        case 2:
          monthName = 'feb';
          monthNameFull = 'Febrero';
          break;
        case 3:
          monthName = 'mar';
          monthNameFull = 'Marzo';
          break;
        case 4:
          monthName = 'abr';
          monthNameFull = 'Abril';
          break;
        case 5:
          monthName = 'may';
          monthNameFull = 'Mayo';
          break;
        case 6:
          monthName = 'jun';
          monthNameFull = 'Junio';
          break;
        case 7:
          monthName = 'jul';
          monthNameFull = 'Julio';
          break;
        case 8:
          monthName = 'ago';
          monthNameFull = 'Agosto';
          break;
        case 9:
          monthName = 'sep';
          monthNameFull = 'Septiembre';
          break;
        case 10:
          monthName = 'oct';
          monthNameFull = 'Octubre';
          break;
        case 11:
          monthName = 'nov';
          monthNameFull = 'Noviembre';
          break;
        case 12:
          monthName = 'dic';
          monthNameFull = 'Diciembre';
          break;
      }
      switch (datetype) {
        case 'day':
          return date[0];
        case 'month':
          return monthName;
        case 'year':
          return date[2];
        case 'short':
          return date[0] + ', ' + monthName + ' ' + date[2];
        default:
          return date[0] + ' de ' + monthNameFull + ' del ' + date[2];
      }
    } else {
      return value;
    }
  });
}

/***/ }),

/***/ "ockH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{staticClass:"u-absolute",attrs:{"white":true}}),_c('section',{staticClass:"u-flex u-min-height-100vh"},[_c('figure',{staticClass:"u-m0 u-bg-tertiary u-4/12@tablet u-bg-opacity u-relative",staticStyle:{"z-index":"-1","background-image":"url(/images/tacna.jpg)","background-size":"cover","background-position":"50% 50%"}}),_c('div',{staticClass:"u-py4 u-8/12@tablet u-flex u-items-center u-bg-primary"},[_c('div',{staticClass:"u-7/12@tablet u-12/12 o-container u-mx-auto"},[_c('h3',{staticClass:"u-fz-h1 u-white u-line-1 u-mt0 u-mb4",attrs:{"data-aos":"fade-right"}},[_c('span',{staticClass:"u-block"},[_vm._v("Pide un "+_vm._s(_vm.company.name))]),_c('span',{staticClass:"u-fw-light u-block"},[_vm._v("desde tu celular")])]),_c('p',{staticClass:"u-white u-line-1 u-fz-h4 u-mt0 u-mb4",staticStyle:{"line-height":"1.5rem"},attrs:{"data-aos":"fade-right"}},[_c('span',{staticClass:"u-fw-s-bold"},[_vm._v("Descarga la aplicación "+_vm._s(_vm.company.name)+" ")]),_c('span',{staticClass:"u-fw-light"},[_vm._v("en tu móvil con Android y vive tu experiencia en Tacna con "+_vm._s(_vm.company.name)+".")])]),(_vm.company.appLink)?_c('a',{staticClass:"u-inline-block",attrs:{"href":_vm.company.appLink,"target":"_blank","data-aos":"fade-right"}},[_c('img',{staticClass:"u-hover-shadow u-block u-inline-block",staticStyle:{"height":"50px"},attrs:{"src":"/images/google_play.png"}})]):_vm._e()])])]),_c('section',{staticClass:"u-z2 o-wrapper"},[_vm._m(0),_c('div',{staticClass:"u-flex u-flex-wrap u-justify-between o-container"},[_c('div',{staticClass:"u-6/12@laptop u-6/12@tablet u-12/12 u-mb5"},[_c('div',{staticClass:"u-pt6 u-show@laptop"}),_vm._m(1),_c('p',{staticClass:"u-mb4",attrs:{"data-aos":"fade-right"}},[_vm._v(" Haz uso de nuestro nuevo servicio de operador online y haz tus pedidos de taxi más rapido desde tu celular.  Búscanos en la Tienda Play Store en tu dispositivo Android.")]),(_vm.company.appVideo)?_c('button',{staticClass:"c-btn--primary u-fw-s-bold u-uppercase",attrs:{"data-aos":"fade-right"},on:{"click":function($event){_vm.isShowModalVideo = true}}},[_vm._v("Ver Video")]):_vm._e()]),_vm._m(2)])]),_c('section',{staticClass:"o-wrapper"},[_vm._m(3),_c('section',{staticClass:"u-flex u-flex-wrap u-pb5"},_vm._l((_vm.features),function(feature){return _c('article',{staticClass:"u-4/12@laptop u-6/12@tablet u-12/12 u-center u-px4 u-mb4",attrs:{"data-aos":"fade-up"}},[_c('figure',{staticClass:"u-mt0 u-mb0 u-mx-auto",staticStyle:{"height":"80px"}},[_c('img',{staticStyle:{"max-height":"100%"},attrs:{"src":feature.imageUrl}})]),_c('p',{staticClass:"u-fw-bold u-color-primary u-fz-h4"},[_vm._v(_vm._s(feature.title))]),_c('p',{staticClass:"u-mb0"},[_vm._v(_vm._s(feature.description))])])}))]),_c('section',{staticClass:"u-py5 u-relative"},[_c('figure',{staticClass:"u-bg-opacity u-absolute u-left-0 u-right-0 u-top-0 u-bottom-0 u-m0",staticStyle:{"z-index":"-1","background-image":"url(/images/construction.jpg)","background-size":"cover","background-position":"50% 50%"}}),_c('div',{staticClass:"o-wrapper o-container"},[_c('h3',{staticClass:"u-white u-fz-h1 u-mt0 u-mb2",attrs:{"data-aos":"zoom-in"}},[_vm._v("Descarga Gratis!")]),_c('p',{staticClass:"u-white",attrs:{"data-aos":"zoom-in"}},[_vm._v("Vive tu experiencia en Tacna con "+_vm._s(_vm.company.name)+".")]),(_vm.company.appLink)?_c('a',{staticClass:"u-inline-block",attrs:{"href":_vm.company.appLink,"target":"_blank","data-aos":"zoom-in"}},[_c('img',{staticStyle:{"height":"50px"},attrs:{"src":"/images/google_play.png"}})]):_vm._e()])]),_c('section',{staticClass:"o-wrapper"},[_vm._m(4),_c('p',{staticClass:"u-center u-mb4",attrs:{"data-aos":"fade-up"}},[_vm._v("Listado de las pantallas de nuestra aplicación móvil.")]),_c('div',{staticClass:" u-relative u-mb5 u-12/12"},[_c('button',{staticClass:"c-btn-nav--prev c-btn-nav--page c-btn-nav c-btn-nav--white",attrs:{"data-aos":"fade-up"},on:{"click":_vm.prev}},[_c('i',{staticClass:"u-icon"},[_vm._v("arrow_left")])]),_c('button',{staticClass:"c-btn-nav--next c-btn-nav--page c-btn-nav c-btn-nav--white",attrs:{"data-aos":"fade-up"},on:{"click":_vm.next}},[_c('i',{staticClass:"u-icon"},[_vm._v("arrow_right")])]),_c('slick',{ref:"slick",staticClass:"o-wrapper",attrs:{"options":_vm.slickOptions}},_vm._l((_vm.apps),function(app){return _c('article',{attrs:{"data-aos":"zoom-in","data-aos-duration":"1000"}},[_c('figure',{staticClass:"u-m0"},[_c('img',{attrs:{"src":app.imageUrl}})])])}))],1)]),_c('section',{staticClass:"o-wrapper",staticStyle:{"background-position":"0% 100%","background-image":"url(/images/footer.png)"}},[_vm._m(5),_c('div',{staticClass:"u-flex u-justify-between"},[_vm._m(6),_c('aside',{staticClass:"u-8/12@laptop u-12/12"},[_c('ul',{staticClass:"u-list-none u-pl0 u-my4 u-flex u-overflow-auto",attrs:{"data-aos":"fade-up"}},_vm._l((_vm.steps),function(step,index){return _c('li',{staticClass:"u-mr4"},[_c('button',{staticClass:"u-pl0 u-pr0 u-border-bottom u-pb3 u-border-4",class:_vm.selectStep === index ? 'u-border-primary' : 'u-border-white ',on:{"click":function($event){_vm.selectStep = index}}},[_c('span',{staticClass:"u-fz-h5 u-flex u-items-center u-justify-center u-fw-bold c-btn-nav--white u-mx-auto u-mb2",class:_vm.selectStep === index ? 'u-bg-secondary' : 'u-bg-text '},[_vm._v(_vm._s(index + 1))]),_c('span',{staticClass:"u-block u-uppercase u-fw-s-bold",class:{'u-color-dark' : _vm.selectStep === index}},[_vm._v(_vm._s(step.label))])])])})),_c('div',{staticClass:"u-mb4"},[_c('p',{staticClass:"u-color-dark u-fz-h4 u-fw-s-bold",attrs:{"data-aos":"fade-up"}},[_vm._v(_vm._s(_vm.steps[_vm.selectStep].title))]),_c('p',{attrs:{"data-aos":"fade-up"}},[_vm._v(_vm._s(_vm.steps[_vm.selectStep].description))])])])])]),_c('app-footer'),(_vm.isShowModalVideo)?_c('modal-video',{attrs:{"url":_vm.company.appVideo},on:{"hide":function($event){_vm.isShowModalVideo = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"u-ml6 u-mb0 u-mt0 u-show@tablet",staticStyle:{"margin-top":"-80vh","height":"110vh","pointer-events":"none"},attrs:{"data-aos":"fade-up"}},[_c('img',{staticStyle:{"height":"100%"},attrs:{"src":"/images/app.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-color-primary u-fz-h2 u-mb3",attrs:{"data-aos":"fade-right"}},[_c('span',[_vm._v("Acerca ")]),_c('span',{staticClass:"u-fw-light"},[_vm._v("de la APP")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"u-3/12@laptop u-4/12@tablet u-12/12 u-mb5 u-mt0 u-ml0 u-mr0",attrs:{"data-aos":"fade-left"}},[_c('img',{attrs:{"src":"/images/app.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-color-primary u-fz-h2 u-mt4 u-center",attrs:{"data-aos":"fade-up"}},[_c('span',[_vm._v("Características ")]),_c('span',{staticClass:"u-fw-light"},[_vm._v("de la APP")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-color-primary u-fz-h2 u-mb3 u-mt5 u-center",attrs:{"data-aos":"fade-up"}},[_c('span',[_vm._v("Interfaces ")]),_c('span',{staticClass:"u-fw-light"},[_vm._v("de la APP")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"u-color-primary u-fz-h2 u-center u-mt5",attrs:{"data-aos":"fade-up"}},[_c('span',[_vm._v("¿Cómo ")]),_c('span',{staticClass:"u-fw-light"},[_vm._v("usar la APP?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"u-3/12@laptop u-4/12 u-mb5 u-mt0 u-ml0 u-mr0 u-show@tablet",attrs:{"data-aos":"fade-right"}},[_c('img',{attrs:{"src":"/images/app.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "onL2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BEGIN_AJAX_CALL */
/* unused harmony export AJAX_CALL_ERROR */
/* unused harmony export AJAX_CALL_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_COMPANY; });
// mutations
var BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
var AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';
var AJAX_CALL_SUCCESS = 'AJAX_CALL_SUCCESS';

var RECEIVE_COMPANY = 'RECEIVE_COMPANY';

/***/ }),

/***/ "oqJ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_validatorjs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ComplaintsScreen',
  data: function data() {
    return {
      isShowModalConfirm: false,
      isShowModalError: false,
      toggleValidate: false,
      formValidate: false,
      clearForm: false,
      isLoading: false,
      form: {
        claimOptionId: 0,
        person: {
          fullname: '',
          legalName: '',
          address: '',
          district: '',
          province: '',
          region: '',
          identityDocument: '',
          phone: '',
          cellphone: '',
          email: '',
          parentsName: ''
        },
        itemOptionId: 0,
        descriptionItem: '',
        amount: '',
        details: '',
        order: '',
        document: {
          base64: '',
          extension: ''
        },
        responseChanelId: 0
      },
      rules: {
        claimOptionId: 'min:1',
        person: {
          fullname: 'required|name',
          legalName: 'required',
          address: 'required',
          district: 'required',
          province: 'required',
          region: 'required',
          identityDocument: 'required',
          phone: 'required|phone',
          cellphone: 'required|phone',
          email: 'required|email',
          parentsName: 'required'
        },
        itemOptionId: 'min:1',
        descriptionItem: 'required',
        amount: 'required',
        details: 'required',
        order: 'required',
        document: {
          base64: 'required',
          extension: 'required'
        },
        responseChanelId: 'min:1'
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  methods: {
    postForm: function postForm() {
      var _this = this;

      this.validate();

      if (this.formValidate && !this.isLoading) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(window.API_URL + '/claims', this.form).then(function (response) {
          _this.isShowModalConfirm = true;
          _this.isLoading = false;
          _this.form = {
            claimOptionId: 0,
            person: {
              fullname: '',
              legalName: '',
              address: '',
              district: '',
              province: '',
              region: '',
              identityDocument: '',
              phone: '',
              cellphone: '',
              email: '',
              parentsName: ''
            },
            itemOptionId: 0,
            descriptionItem: '',
            amount: '',
            details: '',
            order: '',
            document: {
              base64: '',
              extension: ''
            },
            responseChanelId: 0
          };
          _this.clearForm = !_this.clearForm;
        }).catch(function (_ref) {
          var response = _ref.response;

          _this.isLoading = false;
          _this.isShowModalError = true;
        });
      }
    },
    validate: function validate() {
      var validation = new __WEBPACK_IMPORTED_MODULE_3_validatorjs___default.a(this.form, this.rules);
      validation.passes();
      this.toggleValidate = !this.toggleValidate;
      this.formValidate = validation.passes();
    },
    updateFile: function updateFile(file) {
      this.form.document = file;
    },
    onVerify: function onVerify(value) {
      this.form.recaptcha = value;
    }
  }
});

/***/ }),

/***/ "or3v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalConfirm_vue__ = __webpack_require__("enRu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f0c14c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalConfirm_vue__ = __webpack_require__("CpyN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f0c14c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p3sy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validatorjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      toggleValidate: false,
      formValidate: false,
      isLoading: false,
      currentDate: '',
      form: {
        dni: '',
        cellphone: '',
        title: '',
        date: '',
        detail: '',
        // recaptcha: '',
        photo: {
          base64: '',
          extension: ''
        }
      },
      rules: {
        dni: 'required',
        title: 'required',
        date: 'required',
        detail: 'required',
        photo: {
          extension: 'required'
        },
        // recaptcha: 'required'
        cellphone: 'required|phone'
      }
    };
  },


  methods: {
    postForm: function postForm() {
      var _this = this;

      this.validate();

      if (this.formValidate && !this.isLoading) {
        this.isLoading = true;
        this.$emit('loading');
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(window.API_URL + '/reports', this.form).then(function (response) {
          _this.isLoading = false;
          _this.$emit('loading');
          _this.$emit('hide');
          _this.$emit('success');
        }).catch(function (_ref) {
          var response = _ref.response;

          _this.isLoading = false;

          _this.$emit('loading');
          _this.$emit('error');
        });
      }
    },
    updateFile: function updateFile(image) {
      this.form.photo = image;
    },
    validate: function validate() {
      var validation = new __WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a(this.form, this.rules);
      validation.passes();
      this.toggleValidate = !this.toggleValidate;
      this.formValidate = validation.passes();
    }
  },

  watch: {
    currentDate: function currentDate(val) {
      if (val) {
        this.form.date = val.format();
      } else {
        this.form.date = '';
      }
    }
  }
});

/***/ }),

/***/ "pCBr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    shares: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    url: String,
    title: String,
    height: {
      type: Number,
      default: 400
    },
    width: {
      type: Number,
      default: 600
    }
  },

  data: function data() {
    return {
      leftPosition: window.$(window).width() / 2 - this.width / 2,
      topPosition: window.$(window).height() / 2 - this.height / 2,
      isMobil: true,
      currentUrl: encodeURIComponent(window.location.href)
    };
  },


  computed: {
    urls: function urls() {
      return {
        facebook: "http://www.facebook.com/sharer.php?u=" + this.currentUrl,
        twitter: "http://twitter.com/share?url=" + this.currentUrl + "&text=" + this.title,
        linkedin: "https://www.linkedin.com/shareArticle?url=" + this.currentUrl + "&title=" + this.title,
        gplus: "https://plus.google.com/share?url=" + this.currentUrl,
        whatsapp: "whatsapp://send?text=" + this.currentUrl
      };
    }
  },

  methods: {
    shareSocial: function shareSocial(link) {
      window.open(link, null, "height=" + this.height + ",width=" + this.width + ",top=" + this.topPosition + ",left=" + this.leftPosition + ",toolbar=0");
    }
  },

  created: function created() {
    if (this.url) {
      this.currentUrl = encodeURIComponent(this.url);
    }
  },


  watch: {
    $route: function $route() {
      if (!this.url) {
        this.currentUrl = encodeURIComponent(window.location.href);
      }
    }
  },

  mounted: function mounted() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {} else {
      this.isMobil = false;
    }
  }
});

/***/ }),

/***/ "pYmz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__("7oBO");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3e617127_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__("Hpn/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3e617127_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pp/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs__ = __webpack_require__("5osr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validatorjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validatorjs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    inputClass: String,
    wrapperClass: String,
    mask: {
      type: String,
      default: ''
    },
    info: String,
    label: String,
    labelClass: String,
    name: String,
    placeholder: String,
    validation: Boolean,
    value: [String, Number],
    icon: String,
    min: String,
    clear: Boolean,
    errorBorder: {
      type: String,
      default: 'u-border-error'
    },
    errorClass: {
      type: String,
      default: 'u-color-error'
    },
    type: {
      type: String,
      default: 'text'
    },
    rule: {
      type: String,
      default: 'required'
    },
    messageColor: {
      type: String,
      default: 'error'
    },
    rows: {
      type: String,
      default: '4'
    }
  },

  data: function data() {
    return {
      message: '',
      validated: false
    };
  },


  methods: {
    updateValue: function updateValue(value) {
      if (this.type === 'number') {
        this.$emit('input', parseInt(value, 10));
      } else {
        this.$emit('input', value);
      }

      this.validate();
    },
    validate: function validate() {
      if (this.rule) {
        var validate = new __WEBPACK_IMPORTED_MODULE_0_validatorjs___default.a({ value: this.$refs.input.value ? this.$refs.input.value : this.value }, { value: this.rule });
        this.validated = validate.passes();
        this.message = validate.errors.first('value');
      }
    },
    formatValue: function formatValue() {
      if (this.type === 'number' && this.value < this.min && this.value === !null) {
        this.$emit('input', this.min);
      }
    }
  },

  watch: {
    validation: function validation(val, oldVal) {
      this.validate();
    },
    clear: function clear(val) {
      this.message = '';
    }
  }
});

/***/ }),

/***/ "q9OF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ModalExpress__ = __webpack_require__("9uhu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ModalDelivery__ = __webpack_require__("XVQg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ModalRadioTaxi__ = __webpack_require__("/XiT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ModalTourism__ = __webpack_require__("/PsR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ModalWomanTaxi__ = __webpack_require__("nbec");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeScreen',
  components: {
    ModalExpress: __WEBPACK_IMPORTED_MODULE_1_components_ModalExpress__["a" /* default */],
    ModalWomanTaxi: __WEBPACK_IMPORTED_MODULE_5_components_ModalWomanTaxi__["a" /* default */],
    ModalDelivery: __WEBPACK_IMPORTED_MODULE_2_components_ModalDelivery__["a" /* default */],
    ModalTourism: __WEBPACK_IMPORTED_MODULE_4_components_ModalTourism__["a" /* default */],
    ModalRadioTaxi: __WEBPACK_IMPORTED_MODULE_3_components_ModalRadioTaxi__["a" /* default */]
  },
  data: function data() {
    return {
      isShowModalError: false,
      isShowModalConfirm: false,
      isShowModalDelivery: false,
      isShowModalExpress: false,
      isShowModalRadioTaxi: false,
      isShowModalTourism: false,
      isShowModalWomanTaxi: false,
      isShowModalVideo: false,
      selectedService: 0,
      swiperTestimonies: {
        slidesPerView: 1,
        prevButton: '#testimony-prev',
        nextButton: '#testimony-next'
      },
      testimonies: [],
      swiperFeatures: {
        slidesPerView: 5,
        autoplay: 5000,
        breakpoints: {
          889: {
            slidesPerView: 4
          },
          778: {
            slidesPerView: 3
          },
          560: {
            slidesPerView: 2
          },
          320: {
            slidesPerView: 1
          }
        }
      },
      features: [{
        id: 1,
        title: 'Buen trato al cliente',
        imageUrl: '/images/icon1.png',
        description: 'Atención personalizada en el servicio y buen trato al cliente, siempre con responsabilidad, respeto y honradez.'
      }, {
        id: 2,
        title: 'Flota moderna',
        imageUrl: '/images/icon2.png',
        description: 'Pavill cuenta con vehículos modernos para brindar comodidad en su trayectoria, seguridad y confort.'
      }, {
        id: 3,
        title: 'Conductores con experiencia',
        imageUrl: '/images/icon3.png',
        description: 'Nuestros conductores cuentan con amplia experiencia y están en constante capacitación.'
      }, {
        id: 4,
        title: 'Central telefónica moderna',
        imageUrl: '/images/icon4.png',
        description: 'Central telefónica moderna disponible las 24 horas del día, envio de taxi a domicilio y delivery.'
      }, {
        id: 5,
        title: 'Servicio de taxi por App',
        imageUrl: '/images/icon5.png',
        description: 'Para un servicio más rápido, confiable, y personal, le ofrecemos el servicio de aplicación desde su celular.'
      }],
      services: []
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    company: 'company'
  }), {
    faceWeb: function faceWeb() {
      if (this.company.facebookPage) {
        return 'https://www.facebook.com/plugins/page.php?href=' + encodeURIComponent(this.company.facebookPage) + '&tabs=timeline&width=500&height=200&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId';
      }
      return '';
    }
  }),

  methods: {
    getTestimonies: function getTestimonies() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(window.API_URL + '/testimonies').then(function (_ref) {
        var data = _ref.data;

        _this.testimonies = data.data;
      });
    },
    getServices: function getServices() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(window.API_URL + '/services').then(function (_ref2) {
        var data = _ref2.data;

        _this2.services = data.data;
      });
    },
    showModalService: function showModalService(id) {
      this.selectedService = id;
      switch (id) {
        case 1:
          this.isShowModalWomanTaxi = true;
          break;
        case 2:
          this.isShowModalExpress = true;
          break;
        case 3:
          this.isShowModalTourism = true;
          break;
        case 4:
          this.isShowModalRadioTaxi = true;
          break;
        case 5:
          this.isShowModalDelivery = true;
          break;
        default:
      }
    }
  },

  created: function created() {
    this.getTestimonies();
    this.getServices();
  }
});

/***/ }),

/***/ "qf9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label)?_c('label',{staticClass:"u-mb1 u-block"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"u-12/12",class:_vm.wrapperClass},[_c('select',{ref:"input",class:_vm.selectClass,domProps:{"value":_vm.value},on:{"change":function($event){_vm.updateValue($event.target.value)}}},[_c('option',{attrs:{"hidden":"hidden","disabled":"disabled"},domProps:{"value":0}},[_vm._v(_vm._s(_vm.placeholder))]),_vm._l((_vm.options),function(option){return _c('option',{staticClass:"u-color-default",domProps:{"value":option.id}},[_vm._v(_vm._s(option.name))])})],2),(_vm.icon)?_c('i',{staticClass:"u-icon"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('i',{staticClass:"u-icon caret_down"})]),(_vm.isShowMessage)?_c('span',{staticClass:"u-pt1 u-fz-h6 u-pl1 u-block",class:_vm.errorClass},[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qtDB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ContactScreen__ = __webpack_require__("kpCZ");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/contactanos',
  name: 'Contact',
  component: __WEBPACK_IMPORTED_MODULE_0__components_ContactScreen__["a" /* default */]
});

/***/ }),

/***/ "rRNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalVideo_vue__ = __webpack_require__("lkgy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be983486_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalVideo_vue__ = __webpack_require__("Xsej");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be983486_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ModalVideo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rkIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"width":"500px","modal-class":"u-bg-primary u-p3"},on:{"hide":function($event){_vm.$emit('hide')}}},[_c('div',{staticClass:"u-px4",attrs:{"slot":"content"},slot:"content"},[_c('h3',{staticClass:"u-fz-h2 u-mt0 u-center u-line-1 u-mb4"},[_c('span',{staticClass:"u-white"},[_vm._v("Reserva un Pavill para ")]),_c('span',{staticClass:"u-color-secondary"},[_vm._v("Radio Taxi")])]),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.fullname,"name":"fullname","icon":"user","placeholder":"Nombres y apellidos","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.fullname),callback:function ($$v) {_vm.$set(_vm.form, "fullname", $$v)},expression:"form.fullname"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.whatsapp,"name":"whatsapp","icon":"whatsapp","placeholder":"Whatsapp","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.whatsapp),callback:function ($$v) {_vm.$set(_vm.form, "whatsapp", $$v)},expression:"form.whatsapp"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.origin,"name":"origin","icon":"location","placeholder":"Estoy en","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.origin),callback:function ($$v) {_vm.$set(_vm.form, "origin", $$v)},expression:"form.origin"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.destiny,"name":"destiny","icon":"transport","placeholder":"Quiero ir a","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.destiny),callback:function ($$v) {_vm.$set(_vm.form, "destiny", $$v)},expression:"form.destiny"}}),_c('button',{staticClass:"c-btn--primary u-12/12 u-fw-s-bold u-mb3 u-fz-h4 u-mt2",on:{"click":_vm.postForm}},[_vm._v("Realizar Reserva")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "swk/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    company: 'company'
  })),

  beforeCreate: function beforeCreate() {
    window.$('body').css('overflow-y', 'hidden');
  },
  beforeDestroy: function beforeDestroy() {
    window.$('body').css('overflow-y', '');
  }
});

/***/ }),

/***/ "tHdN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    price: {
      type: Number,
      required: true
    }
  },

  data: function data() {
    return {
      symbol: 'S/.'
    };
  }
});

/***/ }),

/***/ "tKG8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportScreen_vue__ = __webpack_require__("Polv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e146bd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ReportScreen_vue__ = __webpack_require__("zfaB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e146bd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ReportScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uNBx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: String,
      default: '360px'
    },
    modalClass: String
  },

  mounted: function mounted() {
    window.$('body').css('overflow-y', 'hidden');
  },
  beforeDestroy: function beforeDestroy() {
    window.$('body').css('overflow-y', '');
  }
});

/***/ }),

/***/ "v17k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareButtons_vue__ = __webpack_require__("pCBr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_759144aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ShareButtons_vue__ = __webpack_require__("Etg8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareButtons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_759144aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ShareButtons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vKnM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverScreen_vue__ = __webpack_require__("cJ1P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d9155a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DriverScreen_vue__ = __webpack_require__("msQ7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DriverScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d9155a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_DriverScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vhJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComplaintsScreen_vue__ = __webpack_require__("oqJ6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c7bbba2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ComplaintsScreen_vue__ = __webpack_require__("+SIS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComplaintsScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c7bbba2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ComplaintsScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wIom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"c-modal",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.$emit('hide')}}},[_c('div',{staticClass:"c-modal__content",class:_vm.modalClass,style:({width: _vm.width})},[_c('div',{staticClass:"u-right-align"},[_c('button',{staticClass:"u-fz-h3 u-color-quaternary u-mb2",on:{"click":function($event){_vm.$emit('hide')}}},[_c('i',{staticClass:"u-icon"},[_vm._v("close")])])]),_vm._t("content")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x3ZV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-clip",style:(_vm.spinnerStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xj/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ReportsScreen__ = __webpack_require__("ZflP");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/reporta',
  name: 'Reports',
  component: __WEBPACK_IMPORTED_MODULE_0__components_ReportsScreen__["a" /* default */]
});

/***/ }),

/***/ "y16v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._m(0),_c('app-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-bg-landscape u-bg-quinary u-pt5 u-pb6"},[_c('h2',{staticClass:"u-color-primary o-wrapper u-fz-h2 u-center u-mb4 u-mt0",staticStyle:{"max-width":"650px"}},[_c('span',[_vm._v("Términos y condiciones ")]),_c('span',{staticClass:"u-fw-regular"},[_vm._v("de uso de la aplicación móvil Pavill")])]),_c('ol',{staticClass:"o-wrapper c-list--number u-pl3"},[_c('li',[_c('h3',{staticClass:"u-fz-h4 u-color-primary"},[_vm._v("ACEPTACIÓN Y ALCANCE DE LOS TÉRMINOS Y CONDICIONES")]),_c('p',[_vm._v("Estos términos y condiciones de uso, en adelante “Términos”, son aplicables para el uso de los servicios ofrecidos por Pavill a través de la aplicación para teléfonos móviles y de la aplicación Pavill PRO, en adelante “Aplicación”. El usuario manifiesta y declara expresamente que acepta todos los Términos establecidos en el presente documento con la instalación y uso de la Aplicación. La instalación y uso de la Aplicación se entenderá como plena e indubitable manifestación de la voluntad y su aceptación con los presentes Términos. Si usted no está de acuerdo con los Términos de uso de la Aplicación y las políticas de privacidad de Pavill, no instale la aplicación y/o no realice uso de ella.")])]),_c('li',[_c('h3',{staticClass:"u-fz-h4 u-color-primary"},[_vm._v("DEFINICIONES")]),_c('ol',{staticClass:"u-pl4"},[_c('li',[_c('p',[_vm._v("“Usuarios”: Usuarios Conductores y Usuarios Pasajeros, es decir todo aquel que utilice la Aplicación de Pavill.")])]),_c('li',[_c('p',[_vm._v("“Usuario Conductor”, aquel usuario que concluye exitosamente el proceso de registro de Usuario Conductor en la Aplicación de forma presencial y acepta su participación en la comunidad Pavill y los Términos expresados en el presente documento. Asimismo, el Usuario Conductor es quien a título personal realiza el servicio de transporte de pasajeros en la modalidad de Taxi.")])]),_c('li',[_c('p',[_vm._v("“Usuario Pasajero”, aquel usuario que concluye exitosamente el proceso de registro de Usuario Pasajero en la Aplicación de forma electrónica y acepta su participación en la comunidad Pavill y los Términos expresados en el presente documento.")])]),_c('li',[_c('p',[_vm._v("“Viaje”, se entenderá por Viaje a aquella prestación del servicio de traslado, transporte o taxi realizada por el Usuario Conductor a un Usuario Pasajero.")])])])]),_c('li',[_c('h3',{staticClass:"u-fz-h4 u-color-primary"},[_vm._v("¿QUÉ ES Pavill?")]),_c('p',[_vm._v("Pavill es una comunidad virtual que brinda diversos servicios con el propósito de optimizar y brindar valor agregado al requerimiento de prestaciones de traslado entre Usuarios de la misma comunidad, entre ellos los servicios que presta Pavill:")]),_c('ol',{staticClass:"u-pl4"},[_c('li',[_c('p',[_vm._v("Geolocalización: Consiste en poner en contacto a Usuarios Pasajeros con Usuarios Conductores cercanos de forma automatizada, mediante el uso de la Aplicación.")])])]),_c('p',[_vm._v("Pavill no provee el servicio de transporte de pasajeros en la modalidad de taxi y/u otra modalidad de transporte de forma directa o indirecta, así como tampoco crea una relación laboral con los Usuarios Conductores ni con los Usuarios Pasajeros.")])]),_c('li',[_c('h3',{staticClass:"u-fz-h4 u-color-primary"},[_vm._v("REGISTRO Y USO DE LA APLICACIÓN")]),_c('p',{staticClass:"u-color-secondary u-fw-s-bold"},[_vm._v("Registro de Usuario Conductor:")]),_c('ol',{staticClass:"c-list--alpha"},[_c('li',[_c('p',[_vm._v("Cuando se registra, el Usuario Conductor acepta proveer información exacta, veraz, completa y actualizada que se requiera para completar el proceso de registro, pudiendo Pavill realizar controles que crea convenientes para verificar la veracidad de la misma.")])]),_c('li',[_c('p',[_vm._v("El Usuario Conductor acepta que para registrarse se le podrá exigir diversas evaluaciones, las cuales podrán incluir, y no se limitan a:")]),_c('ol',[_c('li',[_vm._v("Verificación de antecedentes policiales.")]),_c('li',[_vm._v("Verificación de antecedentes judiciales.")]),_c('li',[_vm._v("Verificación de antecedentes penales.")]),_c('li',[_vm._v("Verificación de record de conductor.")]),_c('li',[_vm._v("Verificación de aptitud psicológica.")]),_c('li',[_vm._v("Verificación domiciliaria.")]),_c('li',[_vm._v("Verificación de documentación y estado del vehículo a utilizar.")])])]),_c('li',[_c('p',[_vm._v("Pavill no se responsabiliza por cualquier daño como resultado de la pérdida o mal uso de la clave por parte de terceros. El Usuario Conductor es el único responsable por ello.")])]),_c('li',[_c('p',[_vm._v("El registro de Usuario Conductor, es personal y no se puede transferir por ningún motivo a terceras personas.")])]),_c('li',[_c('p',[_vm._v("El Usuario Conductor manifiesta y declara su conformidad para que los datos de su registro sean proporcionados a las autoridades administrativas y judiciales, ya sea por requerimiento expreso o por razón del inicio de una investigación a cargo de Pavill.")])]),_c('li',[_c('p',[_vm._v("Pavill podrá en cualquier momento y sin expresión de causa, suspender y/o cancelar la cuenta del Usuario Conductor, con lo cual el Usuario Conductor manifiesta su conformidad.")])])]),_c('p',{staticClass:"u-fz-h5 u-color-secondary u-fw-s-bold"},[_vm._v("Registro de Usuario Pasajero:")]),_c('ol',{staticClass:"c-list--alpha"},[_c('li',[_c('p',[_vm._v("Cuando se registra, el Usuario Pasajero acepta proveer información exacta, completa y actualizada que se requiera para completar el proceso de registro, pudiendo Pavill realizar controles que crea convenientes para verificar la veracidad de la misma.")])]),_c('li',[_c('p',[_vm._v("Solo las personas que tienen la capacidad legal de ejercicio están autorizados a utilizar la aplicación. Las personas que no cuenten con esta capacidad, entre ellos los menores de edad, deben ser asistidas por sus representantes legales. En este sentido, la declaración realizada por el Usuario Pasajero al momento de ingresar sus datos en la Aplicación se entenderá como una declaración jurada.")])]),_c('li',[_c('p',[_vm._v("Pavill no se responsabiliza por cualquier daño como resultado de la pérdida o mal uso de la clave por parte de terceros. El Usuario Pasajero es el único responsable por ello.")])]),_c('li',[_c('p',[_vm._v("El registro de Usuario Pasajero es personal y no se puede transferir por ningún motivo a terceras personas.")])]),_c('li',[_c('p',[_vm._v("El incuplimiento de alguno de los puntos señalados puede devenir en suspención temporal o definitiva de las cuentas de los Usuario Conductores o Usuarios Pasajeros en cualquier momento. La solicitud acumulativa de otros Usuarios o el incumplimento de políticas internas podrá devenir en similares resoluciones.{")])])])]),_c('li',[_c('h3',{staticClass:"u-fz-h4 u-color-primary"},[_vm._v("LIMITACIONES DE LA RESPONSABILIDAD")]),_c('ol',{staticClass:"u-pl4"},[_c('li',[_c('p',[_vm._v("Los Usuarios declaran conocer expresamente que los Usuarios Conductores debidamente registrados son quienes proveen de forma exclusiva y a título personal los servicios de traslado, transporte o taxi a los Usuarios Pasajeros; Pavill no provee servicios de traslado, transporte o taxi.")])]),_c('li',[_c('p',[_vm._v("Al utilizar la aplicación, los Usuarios Conductores y los Usuarios Pasajeros reconocen y aceptan que Pavill será responsable por cualquier desperfecto ocurrido con los servicios proveidos por Pavill, los cuales son de forma taxativa los siguientes: (i) Geolocalización y dispersión. Asimismo, ambos Usuarios reconocen y aceptan que dado que la prestación de servicios de traslado, transporte o taxi son provistos de forma exclusiva y a título personal por los Usuarios Conductores, Pavill no podrá ser responsable por lo ocurrido dura te la prestación de los mismos incluyendo mas no limitando a la no culminación de ellos; sin embargo, esto no limita cualquier esfuerzo de Pavill para ayudar a solucionar cualquier inconveniente suscitado entre ambos Usuarios aplicando siempre el principio de la buena fe.")])]),_c('li',[_c('p',[_vm._v("Dado que la Aplicación se encuentra en un proceso de mejora continua y constante actualización Pavill no puede garantizar que la misma esté disponible sin interrupciones y que siempre esté libre de errores, y por tanto, no se responsabiliza por posibles perjuicios causados a ambos Usuarios por este concepto.")])]),_c('li',[_c('p',[_vm._v("Debido a que el servicio de geolocalización se presta en tiempo real, Pavill no garantiza la disponibilidad de Usuarios Conductores, lo cual dependerá de la ubicación del Usuario Pasajero y la cercanía de un Usuario Conductor cuando este utiliza la Aplicación.")])])])]),_c('li',[_c('h3',{staticClass:"u-fz-h4 u-color-primary"},[_vm._v("OBLIGACIONES Y RESPONSABILIDADES DE LOS USUARIOS")]),_c('p',[_vm._v("Los Usuarios son responsables del uso de la información personal intercambiada mutuamente mediante el uso de la Aplicación. Dicha información personal debe ser utilizada únicamente para facilitar el encuentro de ambos.")]),_c('p',[_vm._v("Los Usuarios son responsables del consumo de datos o internet de sus dispositivos en los cuales ejecuta/utiliza la Aplicación. En tal sentido, declaran consentir que la Aplicación utilizará y/o consumirá recursos de su plan de datos y/o internet contratado con su operador de telefonía según el uso que hagan de ella. Obligaciones y responsabilidades del Usuario Conductor.")]),_c('ol',{staticClass:"c-list--alpha"},[_c('li',[_c('p',[_vm._v("El Usuario Conductor certifica y declara que está usando la Aplicación por su propia voluntad, este reconoce y acepta las responsabilidades y riesgos por usar la Aplicación.")])]),_c('li',[_c('p',[_vm._v("El Usuario Conductor reconoce que Pavill no tiene ninguna participación en la relación contractual entre el Usuario Conductor y el Usuario Pasajero y reconoce y acepta los riesgos a título personal por el servicio de traslado, transporte o taxi brindado por el Usuario Conductor.")]),_c('blockquote',[_vm._v("– Aceptación y rechazo del servicio de geolocacilización.")])]),_c('li',[_c('p',[_vm._v("El Usuario Conductor puede libremente aceptar o rechazar Viajes de acuerdo al servicio de geolocalización que lo ubica cercano a los Usuarios Pasajeros que requieren de sus servicios. El Usuario Conductor reconoce que Pavill no se responsabiliza por las demoras, cancelaciones y/o errores de comunicación con el Usuario Pasajero, ni cualquier retraso o incumplimiento durante la restación del servicio de traslado, transporte o taxi.")])])]),_c('p',{staticClass:"u-color-secondary u-fw-s-bold"},[_vm._v("Obligaciones y responsabilidades del Usuario Pasajero")]),_c('ol',{staticClass:"c-list--alpha"},[_c('li',[_c('p',[_vm._v("El Usuario Pasajero certifica y declara que está usando la Aplicación por su propia voluntad, este reconoce y acepta las responsabilidades y riesgos por usar la Aplicación.")])]),_c('li',[_c('p',[_vm._v("El Usuario Pasajero reconoce que Pavill no tiene ninguna participación en la relación contractual entre el Usuario Conductor y el Usuario Pasajero y reconoce y acepta los riesgos por el servicio de traslado, transporte o taxi brindado por el Usuario Conductor.")]),_c('blockquote',[_vm._v("– Solicitud y cancelación del servicio de geolocacilización")])]),_c('li',[_c('p',[_vm._v("El Usuario Pasajero puede libremente solicitar o cancelar Viajes mediante el servicio de geolocalización que ubica a los Usuarios Conductores cercanos según el requerimiento de sus servicios. El Usuario Pasajero reconoce que Pavill no se responsabiliza por las demoras, cancelaciones y/o errores de comunicación con el Usuario Conductor, ni cualquier retraso o incumplimiento durante la restación del servicio de traslado, transporte o taxi.")])]),_c('li',[_c('p',[_vm._v("El Usuario Pasajero podrá libremente decidir abordar el vehículo del Usuario Conductor geolocalizadomediante la Aplicación.")])]),_c('li',[_c('p',[_vm._v("Según disponibilidad técnica, el Usuario Pasajero podrá evaluar el servicio de los Usuarios Conductores, calificando y comentando libremente. Dicha evaluación será de uso exclusivo de Pavill con la finalidad de brindar un mejor servicio.")])])])]),_c('li',[_c('h3',{staticClass:"u-fz-h4 u-color-primary"},[_vm._v("PROCEDIMIENTO DE ATENCIÓN Y RECLAMOS")]),_c('p',[_vm._v("Para la atención de cualquier reclamo en relación a los servicios prestados por Pavill, es decir, sobre los servicios de (i) Geolocalización y dispersión, los Usuarios podrán presentar su reclamo por cualquiera de las vías que la normativa de protección al consumidor ha establecido, las cuales incluyen pero no se limitan a: la presentación de un reclamo escrito vía correo electrónico a Pavill@gmail.com; o su presentación en medio físico a nuestras oficinas ubicadas en Coop. Gregorio Albarracin B - 9; asimismo debemos indicar que el libro de reclamaciones de la empresa se encuentra a disposición de los Usuarios en las oficinas antes indicadas. Los reclamos presentados serán atendidos dentro del plazo máximo legal. Adicionalmente, el Usuario podrá contactarse con el número de atención al usuario N° 052310909, para presentar un reclamo y/o conocer el estado del mismo.")]),_c('p',[_vm._v("En caso los Usuarios Pasajeros tengan algún inconveniente con los servicios prestados por los Usuarios Conductores, podrán reportar dichos inconvenientes al número de atención al usuario antes referido. Pavill procurará sus mejores esfuerzos para que los Usuarios puedan resolver los inconvenientes de manera amistosa y directa.")])]),_c('li',[_c('h3',{staticClass:"u-fz-h4 u-color-primary"},[_vm._v("POLITICA DE PRIVACIDAD Y PROTECCIÓN DE DATOS PERSONALES")]),_c('p',[_vm._v("De conformidad con la Ley N° 29733, Ley de Protección de Datos Personales y su norma reglamentaria D.S. y N° 003-2013-JUS y demás normas aplicables (en adelante, “la Ley”), en los términos vigentes de ambas, desde el momento que el Usuario Conductor y el Usuario Pasajero hayan declarado la aceptación expresa del tratamiento de sus datos personales mediante la realización de cliqueo/pinchado (u otro mecanismo utilizado) dispuesto para la autorización mencionada, Pavill garantiza la seguridad y confidencialidad en el tratamiento de los datos de carácter personal facilitados por los Usuarios. de conformidad con los dispuesto en la Ley.")]),_c('p',[_vm._v("Toda información entregada a Pavill mediante la Aplicación y/o cualesquiera forma de registro que utilicen el Usuario Conductor y el Usuario Pasajero, será objeto de tratamiento automatizado e incorporada en una o más bases de datos de las que Pavill será titular y responsable, conforme a los términos previstos por la Ley.")]),_c('p',[_vm._v("El Usuario Conductor y el Usuario Pasajero otorgan de forma personal cada uno y de forma independiente, autorización expresa e inequívoca a Pavill para realizar tratamiento y hacer uso de la información personal que éste proporcione a Pavill cuando acceda a la Aplicación y/o cualesquiera forma de registro que se utilice, participe en promociones comerciales, envíe consultas o comunique incidencias, y en general cualquier interacción en la Aplicación, además de la información que se derive del uso de productos y/o servicios que pudiera tener contratados con Pavill y de cualquier información pública o que pudiera recoger a través de fuentes de acceso público, incluyendo aquellos a los que Pavill tenga acceso como consecuencia de su navegación por la Aplicación (en adelante, la “Información”) para las finalidades de envío de comunicaciones comerciales, comercialización de productos y servicios, y del mantenimiento de su relación contractual con Pavill. La navegación en la Aplicación, la participación en promociones comerciales, y cualquier otra interacción implica el consentimiento expreso e inequívoco del Usuario Conductor y el Usuario Pasajero para la cesión de sus datos personales a Pavill. El Usuario Conductor y el Usuario Pasajero reconocen y aceptan que Pavill podrá ceder sus datos personales a cualquier tercero, siempre que sea necesaria su participación para cumplir con la prestación de servicios y comercialización de productos y servicios.")]),_c('p',[_vm._v("Pavill podrá ceder, en su caso, la Información a sus empresas subsidiarias, filiales, asociadas, afiliadas o miembros del grupo económico al cual pertenece y/o terceros con los que éstas mantengan una relación contractual, supuesto en el cual sus datos serán almacenados en los sistemas informáticos de cualquiera de ellos. En todo caso, Pavill garantiza el mantenimiento de la confidencialidad y el tratamiento seguro de la Información en estos casos. El uso de la Información por las empresas antes indicadas se circunscribirá a los fines contenidos en este documento.")]),_c('p',[_vm._v("La política de privacidad de Pavill le asegura al usuario el ejercicio de los derechos de información, acceso, actualización, inclusión, rectificación, supresión o cancelación, oposición y revocación del consentimiento, en los términos establecidos en la Ley. En cualquier momento, el Usuario Conductor y el Usuario Pasajero tendrán el derecho a solicitar a Pavill el ejercicio de los derechos que le confiere la Ley, así como la revocación de su consentimiento según lo previsto en la Ley.")]),_c('p',[_vm._v("Pavill garantiza la confidencialidad en el tratamiento de los datos de carácter personal, así como haber adoptado los niveles de seguridad de protección de los datos personales, instalado todos los medios y adoptado todas las medidas técnicas, organizativas y legales a su alcance que garanticen la seguridad y eviten la alteración, pérdida, tratamiento o acceso no autorizado a los datos personales.")]),_c('p',[_vm._v("Para cualquier consulta sobre los alcances de la Política sobre Protección de Datos Personales o en caso los usuarios deseen ejercitar los derechos de acceso, actualización, inclusión, rectificación, supresión o cancelación, oposición u otros contemplados en la Ley, sobre sus datos personales, podrán enviar un correo electrónico a: (Pavill@gmail.com)")])]),_c('li',[_c('h3',{staticClass:"u-fz-h4 u-color-primary"},[_vm._v("SANCIONES")]),_c('p',[_vm._v("Pavill podrá notificar, suspender o cancelar, temporal o permanentemente, la cuenta de cualquier Usuario en cualquier momento, y tomar acciones legales si:")]),_c('ol',{staticClass:"c-list--alpha "},[_c('li',[_c('p',[_vm._v("Viola cualquiera de las representaciones, garantías y obligaciones contenidas en estos Términos o cualquier política o regla adyacente a la misma.")])]),_c('li',[_c('p',[_vm._v("Realiza prácticas engañosas o fraudulentas.")])]),_c('li',[_c('p',[_vm._v("Si Pavill concluye que las actividades y actitudes han causado o pueden causar daño a los demás Usuarios o al equipo de Pavill. El usuario no tendrá derecho a ninguna indemnización o compensación por la suspensión temporal o definitiva de su cuenta en la Aplicación.")])])])]),_c('li',[_c('h3',{staticClass:"u-fz-h4 u-color-primary"},[_vm._v("LICENCIA")]),_c('ol',{staticClass:"c-list--alpha"},[_c('li',[_c('p',[_vm._v("Pavill brinda a ambos Usuarios una licencia limitada, personal, no exclusiva, intransferible, no comercial y totalmente revocable para utilizar la Aplicación, en conformidad y por acuerdo de los Términos contenidos en este documento. Pavill se reserva todos los derechos sobre la Aplicación no expresamente concedidos aquí.")])]),_c('li',[_c('p',[_vm._v("Pavill no se hace responsable de ningún daño sufrido por el usuario que realiza una copia, transferencia, distribución o uso de cualquier contenido de la Aplicación protegida, violando los derechos de los demás.")])])])]),_c('li',[_c('h3',{staticClass:"u-fz-h4 u-color-primary"},[_vm._v("CONDICIONES GENERALES")]),_c('ol',{staticClass:"c-list--alpha"},[_c('li',[_c('p',[_vm._v("Los Términos no generan ninguna sociedad, franquicia o relación laboral entre los Usuarios y Pavill.")])]),_c('li',[_c('p',[_vm._v("Los Términos pueden ser cambiados por Pavill en cualquier momento y sin previo aviso. Los cambios serán obligatorios automáticamente en la fecha de publicación de la nueva versión en la página web: https://www.Pavill.com/terminos.html.")])]),_c('li',[_c('p',[_vm._v("Los presentes Términos se regirán e interpretarán de conformidad con la legislación Peruana y cualquier disputa y/o controversia entre los Usuarios y Pavill y que no pueda ser resuelta de forma directa y/o a través de los mecanismos de conciliación legales, será sometida a la jurisdicción de los Jueces y Tribunales de Lima.")])]),_c('li',[_c('p',[_vm._v("Al registrarse en la Aplicación y aceptar los Términos, haciendo clic y/o tap en la opción “Acepto los términos de uso”, el Usuario Pasajero declara automáticamente conocer y se compromete a cumplir con estos Términos y todas las demás políticas y normas disponibles en el sistema.")])]),_c('li',[_c('p',[_vm._v("Los cambios en los presentes Términos podrán ser comunicados mediante la Aplicación así como por medio del correo electrónico provisto por ambos Usuarios en el momento del  registro.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yYnH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("+0zs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__("H0Kz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("l4P7");


var _mutations;





var state = {
  inProgress: 0
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* BEGIN_AJAX_CALL */], function (state) {
  state.inProgress += 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* AJAX_CALL_SUCCESS */], function (state) {
  state.inProgress -= 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* AJAX_CALL_ERROR */], function (state) {
  state.inProgress -= 1;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__
});

/***/ }),

/***/ "yfZo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-construction"},[(_vm.company.construction)?_c('progressive-background',{staticClass:"c-construction__image",attrs:{"src":_vm.company.construction}}):_vm._e(),_c('figure',{staticClass:"o-wrapper u-mb4 u-mt0",staticStyle:{"height":"60px"}},[_c('img',{staticStyle:{"height":"100%"},attrs:{"src":"/images/logo_old.png","alt":_vm.company.name}})]),_c('div',{staticClass:"u-flex u-items-center"},[_c('hr',{staticClass:"c-construction__loading",attrs:{"width":_vm.percentage+ '%'}}),_c('p',{staticClass:"u-fw-bold u-fz-h4 u-mb0 u-mx2 u-mb0 u-mt0"},[_vm._v(_vm._s(_vm.percentage)+"%")]),_c('hr',{staticClass:"u-flex-1 u-border-bottom"})]),_c('div',{staticClass:"o-wrapper u-fz-h4"},[_vm._m(0),_c('p',{staticClass:"u-fw-s-bold u-italic u-mb3"},[_vm._v("Contáctanos")]),_c('div',{staticClass:"u-flex u-flex-wrap"},[(_vm.company.email)?_c('span',{staticClass:"u-mr3 u-mb1"},[_vm._v("C: "+_vm._s(_vm.company.email))]):_vm._e(),_c('span',{staticClass:"u-mr3 u-show@tablet"},[_vm._v("|")]),(_vm.company.cellphone)?_c('span',[_vm._v("T: "+_vm._s(_vm.company.cellphone))]):_vm._e()]),(_vm.company.facebookPage || _vm.company.twitterPage)?_c('div',{staticClass:"u-mt3 u-flex"},[(_vm.company.facebookPage)?_c('a',{staticClass:"c-btn-share c-btn-share--facebook",attrs:{"href":_vm.company.facebookPage,"target":"_blank"}},[_c('i',{staticClass:"u-icon"},[_vm._v("facebook")])]):_vm._e(),(_vm.company.twitterPage)?_c('a',{staticClass:"c-btn-share c-btn-share--twitter",attrs:{"href":_vm.company.twitterPage,"target":"_blank"}},[_c('i',{staticClass:"u-icon"},[_vm._v("twitter")])]):_vm._e()]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"c-construction__title u-fz-h0 u-mt3"},[_c('span',{staticClass:"u-line-1"},[_vm._v("Algo realmente bueno se viene")]),_c('strong',{staticClass:"u-fw-s-bold u-line-1"},[_vm._v(" muy pronto")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zfaB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{staticClass:"u-bg-primary",attrs:{"white":true,"wrapper-class":"u-bg-primary"}}),_c('progressive-background',{attrs:{"src":_vm.currentPost.imageUrl,"placeholder":_vm.currentPost.imageThumbUrl}}),_c('article',{staticClass:"o-wrapper o-container u-py5"},[_c('h2',{staticClass:"c-post__title u-fz-h3 u-mt0 u-mb3",attrs:{"data-aos":"fade-up"}},[_vm._v(_vm._s(_vm.currentPost.title))]),_c('p',{staticClass:"u-mb0 u-capitalize u-fw-s-bold u-mb4 u-color-dark",attrs:{"data-aos":"fade-up"}},[_vm._v(_vm._s(_vm.currentPost.date))]),_c('div',{staticClass:"u-mb4",attrs:{"data-aos":"fade-up"},domProps:{"innerHTML":_vm._s(_vm.currentPost.content)}}),_c('p',{staticClass:"u-uppercase u-border-top u-pt3 u-mt0",attrs:{"data-aos":"fade-up"}},[_vm._v("Compartir")]),_c('share-buttons',{attrs:{"shares":['facebook', 'gplus', 'linkedin'],"data-aos":"fade-up"}})],1),(_vm.reports.length > 0)?_c('div',{staticClass:"u-pt5 u-pb4",staticStyle:{"background-color":"#f0f0f0","background-position":"0% 100%","background-image":"url(/images/footer.png)"}},[_c('aside',{staticClass:"o-wrapper o-container"},[_c('p',{staticClass:"u-uppercase u-color-dark u-fw-s-bold u-mt0",attrs:{"data-aos":"fade-up"}},[_vm._v("Más reportes")]),_c('section',_vm._l((_vm.reports),function(report){return _c('article',{staticClass:"c-post u-mb4",attrs:{"data-aos":"fade-up"}},[_c('div',{staticClass:"u-p4"},[_c('router-link',{staticClass:"c-post__title u-fz-h3",attrs:{"to":{ name: 'Report', params:{slug: report.slug}}}},[_vm._v(_vm._s(report.title))]),_c('div',{domProps:{"innerHTML":_vm._s(report.content)}}),_c('p',[_c('router-link',{staticClass:"u-color-secondary",attrs:{"to":{ name: 'Report', params:{slug: report.slug}}}},[_vm._v("Leer más...")])],1),_c('p',{staticClass:"u-mb0 u-right-align u-capitalize u-color-dark u-fw-s-bold"},[_vm._v(_vm._s(_vm._f("date")(report.date,'short')))])],1)])}))])]):_vm._e(),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zxac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"width":"500px","modal-class":"u-bg-primary u-p3"},on:{"hide":function($event){_vm.$emit('hide')}}},[_c('div',{staticClass:"u-px4",attrs:{"slot":"content"},slot:"content"},[_c('h3',{staticClass:"u-fz-h2 u-mt0 u-center u-line-1 u-mb4"},[_c('span',{staticClass:"u-white"},[_vm._v("Reserva un Pavill para ")]),_c('span',{staticClass:"u-color-secondary"},[_vm._v("Expreso")])]),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.fullname,"name":"fullname","icon":"user","placeholder":"Nombres y apellidos","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.fullname),callback:function ($$v) {_vm.$set(_vm.form, "fullname", $$v)},expression:"form.fullname"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.whatsapp,"name":"whatsapp","icon":"whatsapp","placeholder":"Whatsapp","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.whatsapp),callback:function ($$v) {_vm.$set(_vm.form, "whatsapp", $$v)},expression:"form.whatsapp"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.origin,"name":"origin","icon":"location","placeholder":"Estoy en","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.origin),callback:function ($$v) {_vm.$set(_vm.form, "origin", $$v)},expression:"form.origin"}}),_c('input-validate',{staticClass:"u-mb3",attrs:{"rule":_vm.rules.destiny,"name":"destiny","icon":"transport","placeholder":"Quiero ir a","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align"},model:{value:(_vm.form.destiny),callback:function ($$v) {_vm.$set(_vm.form, "destiny", $$v)},expression:"form.destiny"}}),_c('div',{staticClass:"u-flex u-flex-wrap"},[_c('div',{staticClass:"c-input u-flex u-items-center u-mr3 u-mb3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.specificTime),expression:"form.specificTime"}],staticClass:"u-mr2",attrs:{"id":"specificTime","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.specificTime)?_vm._i(_vm.form.specificTime,null)>-1:(_vm.form.specificTime)},on:{"change":function($event){var $$a=_vm.form.specificTime,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "specificTime", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "specificTime", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "specificTime", $$c)}}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"specificTime"}},[_vm._v("Especificar tiempo del servicio")])]),_c('div',{staticClass:"c-input u-flex u-items-center u-mb3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.roundTrip),expression:"form.roundTrip"}],staticClass:"u-mr2",attrs:{"id":"roundTrip","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.roundTrip)?_vm._i(_vm.form.roundTrip,null)>-1:(_vm.form.roundTrip)},on:{"change":function($event){var $$a=_vm.form.roundTrip,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "roundTrip", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "roundTrip", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "roundTrip", $$c)}}}}),_c('label',{staticClass:"c-input__label u-color-text",attrs:{"for":"roundTrip"}},[_vm._v("Ida y recojo")])])]),(_vm.form.specificTime)?_c('input-validate',{staticClass:"u-7/12@laptop u-8/12@tablet u-mb3",attrs:{"rule":_vm.rules.hours,"icon":"clock","placeholder":"¿Cuántas horas?","validation":_vm.toggleValidate,"wrapper-class":"c-input c-input--icon","error-class":"u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align","type":"number","min":"1"},model:{value:(_vm.form.hours),callback:function ($$v) {_vm.$set(_vm.form, "hours", $$v)},expression:"form.hours"}}):_vm._e(),_c('button',{staticClass:"c-btn--primary u-12/12 u-fw-s-bold u-mb3 u-fz-h4 u-mt2",on:{"click":_vm.postForm}},[_vm._v("Realizar Reserva")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.js